function getSetting(key, defaultValue = "") {
    if (window.subscriptionSettings && window.subscriptionSettings[key] !== undefined && window.subscriptionSettings[key] !== null) {
        return window.subscriptionSettings[key];
    }
    return defaultValue;
}

function getMealsNotAvailableHTML() {
    const text = getSetting('meals_not_selectable_text', 'Gerichte noch nicht wählbar');
    return `
        <div class="meal-selection__not-available">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18" style="vertical-align: middle; margin-right: 8px; color: #a39591;">
                <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 000-1.5h-3.75V6z" clip-rule="evenodd" />
            </svg>
            ${text}
        </div>`;
}

pageSize = 15;

var pageCount = $(".order-details-table tbody tr").length / pageSize;
var total_count = $(".order-details-table tbody tr").length;

// console.log(pageCount);
for (var i = 0; i < pageCount; i++) {
    $("#pagin").append('<li><a href="javascript:;">' + (i + 1) + '</a></li> ');
}
if (total_count > pageSize) {
    $('.accoutn-details .pagination').show();
}
$("#pagin li").first().find("a").addClass("current")

showPage = function (page) {
    $(".order-details-table tbody tr").not(':first').hide();
    $(".order-details-table tbody tr").each(function (n) {
        if (n >= pageSize * (page - 1) && n < pageSize * page)
            $(this).show();
    });
}

showPage(1);

$("#pagin li a").click(function () {
    $("#pagin li a").removeClass("current");
    $(this).addClass("current");
    $('.subscription-page-main-section .customer-account .order-history-tab').css('height', 'auto')
    showPage(parseInt($(this).text()))
});

var dm = window.customer_email;

var cus_id = window.customer_id;

var cus_name = window.customer_name;

var cus_tags = window.customer_tags;

$(document).ready(function () {
    if (cus_tags.includes('Probebox')) {
        const container = $('.your-subscription-details #subscription-data-inner-part');
        const popcontainer = $('#tab-content-list-3-popup');
        const popcontainer5 = $('#tab-content-list-5-popup');
        // Function to generate a new overlay
        function createOverlay() {
            return $(`
        <div class="probebox-overlay" style="
        position: relative;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: transparent;
        z-index: 8;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        pointer-events: none;
        border-radius: inherit;
        height: 100%;">
        <div class="probebox-message" style="
            color: white;
            padding: 0;
            border-radius: 8px;
            pointer-events: auto;
            width: 100%;
            height: 100%;">
            <div class="heading-with-warning" style="
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            margin-bottom: 20px;">
            <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/Group_1198.png?v=1751020933" width="56" height="56">
            <h2 style="
                margin: 0;
                font-size: 22px;
                font-family: 'DM Serif Display';
                font-weight: 500;">
                Wöchentliche Lieferung inaktiv
            </h2>
            <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/Group_1198.png?v=1751020933" width="56" height="56">
            </div>
            <p>Wählen Sie zwischen einem Jahres- oder Flexplan und erhalten Sie wöchentliche Lieferungen, die Sie nach Wunsch wöchentlich pausieren können.</p>
            <button class="probebox-action-btn btn btn--light-border btn--large" style="border-color: white;">Click to Activate</button>
        </div>
        </div>
    `);
        }

        // Append overlay to each container if they exist
        if (container.length) {
            container.append(createOverlay());
        }

        if (popcontainer.length) {
            popcontainer.append(createOverlay());
        }
        if (popcontainer5.length) {
            popcontainer5.append(createOverlay());
        }
    }

    $(document).on("click", ".probebox-action-btn", function (e) {
        if (typeof hasAnyUnsavedMealSelections === "function" && hasAnyUnsavedMealSelections()) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            const dirtyInfo = typeof getActiveDirtyWeekInfo === "function" ? getActiveDirtyWeekInfo() : null;
            const weekText = dirtyInfo && dirtyInfo.label ? ` für ${dirtyInfo.label}` : "";
            const msg = `Bitte speichern oder verwerfen Sie zuerst Ihre ausstehenden Gerichtsauswahlen${weekText}, bevor Sie den Konfigurator öffnen.`;
            if (typeof triggerStickyBarAttention === "function") {
                triggerStickyBarAttention(msg);
            }
            return false;
        }
        $("#custom-config-modal").fadeIn();
        $("body").css("overflow", "hidden");
    });

    $(".custom-modal-close").click(function () {
        $("#custom-config-modal").fadeOut();
        $("body").css("overflow", "");
    });

    // Optional: close modal when clicking outside the modal
    $("#custom-config-modal").click(function (e) {
        if ($(e.target).is("#custom-config-modal")) {
            $(this).fadeOut();
            $("body").css("overflow", "");
        }
    });
});


let create_subscription_list = "";
let previous_subscription_list = "";
let create_subscription_list_date = "";
let select_subscription_date = "";
let your_subscription_data = "";
let meal_data;

let open_subscription_change_popup = "";
let order_overview_wrapper = "";

let your_past_pause_subscription_data = ""

let load_more_create_subscription_list = ""
let load_more_con_date = ""
let get_pause_count = ""
let class_for_make_abo_state_disable = ""
let disable_first_date = ""
let disable_first_date_in_current_week = ""
let get_pause_count_onload = ""
// var emp = $.parseJSON(subscription_data);  

let shipping_cost_abo_1 = "9.90"
let shipping_cost_abo_2 = "16.73"
let shipping_cost_abo_3 = "23.27"
let shipping_cost_abo_4 = "29.90"
let shipping_cost_abo_5 = "36.30"


let shipping_cost_flex_1 = "9.90"
let shipping_cost_flex_2 = "16.73"
let shipping_cost_flex_3 = "23.27"
let shipping_cost_flex_4 = "29.90"
let shipping_cost_flex_5 = "36.30"
let shipping_cost_flex_6 = "42.70"

let make_disable_cancel_button = ""

let active_subscription = ""

let change_subscription_product_handle = "";
let change_subscription_current_product_variant = "";
let change_subscription_current_product_quantity = "";
let get_current_subscription_product_plan = ""
let csp_subscription_id = ""
let csp_get_device_price = ""

let daycare_details_retrieve = {};
daycare_details_retrieve['email'] = dm;

if ($("#created_subscription_list").hasClass("daycare-customer")) {
    var retrieve_data_url = window.ChinukiConfig.apiBaseUrl + "/shopify_daycare_retrieve_subscription/";
    var get_post = "POST";
    var data_body = JSON.stringify(daycare_details_retrieve);
}
else {
    const email = encodeURIComponent(dm);
    var retrieve_data_url = `${window.ChinukiConfig.apiBaseUrl}/shopify_retrieve_subscription/?email=${email}`;
    var get_post = "GET";
    var data_body = "";
}

$.ajax({
    url: retrieve_data_url,
    type: get_post,
    dataType: 'json',
    data: data_body,
    success: function (res) {
        const hasSubscription = res[0]?.subscription_create_details?.length > 0;
        if (hasSubscription) {
            $('#tab-content-list-5-popup').remove();
            $('#tab-content-list-3-popup').remove();
            $('.your-subscription-details #subscription-data-inner-part').addClass('subscription-box-active');
        }
        //  ---------- code for previous subscription details show start here --------------
        let previous_subscription_Present = false;
        $(res[0].subscription_create_details).each(function (key, value) {
            get_current_subscription_product_plan = value.plan;
            if (value.status_of_subscription == "non_renewing") {
                previous_subscription_Present = true;
                var plan_variant_title = value.product_title;

                var variant_Array = plan_variant_title.split(" / ");
                var plan_no_of_qty = value.product_quantity;
                if (value.device_price == "NULL" || value.device_price == "null") {
                    var addon_device = ""
                    var order_overview_addon_price = ""
                }
                else {
                    // console.log(value.device_price);
                    // console.log(value.device_price.replace('.', ','))
                    var addon_device = '<div>5. Sous-Vide Geräte Optionen: <span>Mit Gerät (+ € ' + value.device_price.replace('.', ',') + ')</span></div>'
                    var order_overview_addon_price = '<span>6. Sous-Vide Geräte Optionen:</span> <span>Mit Gerät (+ € ' + value.device_price.replace('.', ',') + ')<label>Mietpreis pro Lieferwoche</label></span>'
                }
                if (pro_plan == "ABO") {
                    var basic_plan_price = `2,99`
                } else {
                    var basic_plan_price = `3,50`
                }
                var new_converted_price = value.total_amount;
                // console.log(value.total_amount.toString().replace('.', ','))
                // console.log(new_converted_price);
                previous_subscription_list += `<div class="accordion__panel"><div class="accordion__heading"><button class="accordion__btn">Kündigungsdatum des Abonnements : ${value.cancel_schedule_created_at}</button></div>
                <div class="accordion__content">
                <div class="accordion__inner text-left">
                <div class="data-delivery-data-list">
                <div class="plan-details-section">
                <div>1. Anzahl der betreuten Kinder: <span>${plan_no_of_qty} Kinder </span></div>
                <div class="selecetd_quentity">2. Anzahl der Betreuungstage: <span>${variant_Array[0]}</span></div>
                <div class="diatry_pattern">3. Ernährungsform: <span>${variant_Array[1]}</span></div>
                <div class="court_preferance">4. Gerichtepräferenz: <span>${variant_Array[2]}</span></div>
                ${addon_device}
                <div>7% MwSt. <span class="discounted_price">+ € <span class="discounted_price_inner">10,50</span></span></div>

                <div>
                Express Kühlversand: <span><span class="chinuki-asf"><span>€ </span><span class="order-overview-shipping-rate"></span></span><label>Versandpreis pro Lieferung</label></span>
                </div>

                <div class="plan-final-bottom-price"><h3>Dein Preis*</h3><span><h3>€ ${new_converted_price}</h3></span></div>              
                </div>
                </div>
                </div>
                </div>
                </div>`

            }
        })

        if (res[0].subscription_create_details.length > 1) {
            if (previous_subscription_Present) {
                // console.log('dddddd');
                $('.your-previous-subscription-details #js-faq-accordion-previous-subscription').html(previous_subscription_list)
                $('.show-subscription-history').show();
                setTimeout(function () {
                    if (document.querySelector('#js-faq-accordion-previous-subscription')) {
                        var faqAccordion = new Accordion({
                            element: "#js-faq-accordion-previous-subscription",
                        });
                    }
                }, 1000)
            }
        }

        //  ---------- code for previous subscription details show end here --------------      

        active_subscription = $(res[0].subscription_create_details).get(-1);

        if (active_subscription && active_subscription.meal_data) {
            if (typeof active_subscription.meal_data === "string") {
                try {
                    meal_data = JSON.parse(active_subscription.meal_data);
                } catch (e) {
                    console.error("Error parsing meal_data string:", e);
                    meal_data = null;
                }
            } else {
                meal_data = active_subscription.meal_data;
            }
        }

        const liquidFeiertagDish = window.subscriptionSettings?.feiertagDish;

        if (meal_data && meal_data.deliveries) {
            // Ensure feiertagDish is always attached since it's not present in the API's meal_data
            meal_data.feiertagDish = liquidFeiertagDish || {
                id: "feiertag",
                category: "Kein Essen",
                title: "Kein Essen / Feiertag",
                image: "https://cdn.shopify.com/s/files/1/0681/2804/7414/files/Product_3.0_Feiertag_e5ccfd90-f2c9-4b72-a046-a55eabcd0402.png?v=1778228498",
                dish_color: "#b0b0b0",
                tags: [],
                handle: "feiertag",
                isFeiertag: true,
                sku: "K000K000"
            };
            // Override isFlexPlan based on actual subscription plan
            if (active_subscription.plan && active_subscription.plan.toUpperCase() === "ABO") {
                meal_data.isFlexPlan = false;
            }
        }

        // Establish the original state before meal controls become interactive.
        captureAllMealBaselines();

        function renderMeals(meal_data, targetDeliveryDate) {
            function getGermanDishDate(dateStr) {
                if (!dateStr) return "";
                const d = new Date(dateStr + "T00:00:00");
                const day = String(d.getDate()).padStart(2, '0');
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const year = d.getFullYear();
                return `${day}.${month}.${year}`;
            }

            let html = "";
            const matchedDelivery = meal_data.deliveries.find(
                d => d.deliveryDate === targetDeliveryDate
            );

            if (!matchedDelivery) return "";

            matchedDelivery.weeklyMeals.forEach((dayData) => {

                // If user already picked a meal, use it. Otherwise find by selectedMealId.
                let selectedMeal = dayData.selectedMeal;
                if (!selectedMeal) {
                    const sourceDay = dayData.selectedMealDay || dayData.day;
                    if (sourceDay === "feiertag") {
                        selectedMeal = meal_data.feiertagDish;
                    } else {
                        const sourceDayData = matchedDelivery.weeklyMeals.find(d => d.day === sourceDay);
                        if (sourceDayData) {
                            selectedMeal = sourceDayData.meals.find(m => m.id === dayData.selectedMealId);
                        }
                    }
                }

                // Fallback to first available meal if none selected yet
                if (!selectedMeal && dayData.meals && dayData.meals.length > 0) {
                    selectedMeal = dayData.meals[0];
                }

                if (!selectedMeal) return;
                const germanDishDate = getGermanDishDate(dayData.date);

                html += `
                    <div class="meal-item ${selectedMeal.isFeiertag ? 'meal-item--no-meal' : ''}">
                        <div class="meal-item__content">
                            <div class="meal-item__header">
                                <div class="meal-item__image">
                                    <div class="meal-image__bg" style="--bg-dish-color: ${selectedMeal.dish_color};"></div>
                                    <img
                                        src="${selectedMeal.image}"
                                        alt="${selectedMeal.title}"
                                    />
                                    <div class="meal-card__tags">
                                        ${(selectedMeal.tags || []).map(tag => `<span style="background-color: ${selectedMeal.dish_color};">${tag}</span>`).join("")}
                                        ${(!selectedMeal.isFeiertag && String(selectedMeal.dish_type).toLowerCase() === 'vegan') ? `<span class="b2b-tag-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="34.536" height="31.308" viewBox="0 0 34.536 31.308">
                                                <defs>
                                                <clipPath id="clip-path">
                                                    <rect width="34.536" height="31.308" fill="${selectedMeal.dish_color}"></rect>
                                                </clipPath>
                                                </defs>
                                                <g clip-path="url(#clip-path)">
                                                <path d="M31.893,8.226C15.491,8.144,6.7,16.154,5.938,32.7a.166.166,0,0,1-.331.02
                                                34.667,34.667,0,0,1,.72-14.617c4.358-14.15,20.9-16.02,32.63-11.548a.842.842,0,0,1,.233,1.423
                                                c-9.164,7.644-7.919,28.523-30.2,19.476
                                                3.463-11.283,10.6-18.3,22.9-19.232" fill="${selectedMeal.dish_color}" fill-rule="evenodd"></path>
                                                </g>
                                            </svg>
                                        </span>` : ''}
                                    </div>
                                </div>
                            </div>
                            <div class="meal-card">
                                <div class="meal-card__header">
                                    <div class="meal-item__date">
                                        <h3>${dayData.day} (${germanDishDate})</h3>
                                    </div>
                                </div>
                                <div class="meal-card__details">
                                    <small class="meal-card__category">
                                        ${selectedMeal.meal_category || selectedMeal.category || ''}
                                    </small>

                                    <h4 class="meal-card__title">
                                        ${selectedMeal.title}
                                    </h4>
                                </div>
                                <div class="meal-card__footer">
                                    <button class="meal-card__button" data-delivery-date="${targetDeliveryDate}" data-day="${dayData.day}">
                                        ändern
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                `;
            });

            return html;
        }
        window.renderMeals = renderMeals;

        $('.overview-customer-id').html(active_subscription.customer_id)
        $('.overview-customer-plan').html(active_subscription.plan)
        $('.overview-customer-status').html(active_subscription.status_of_subscription)
        $('.overview-customer-start-date').html(active_subscription.subscription_created_date)
        $('.overview-customer-renewal-date').html(active_subscription.subscription_ended_date)
        $('.se-pre-con').show();

        var selected_date = $(this).find('option:selected').attr('data-sub-date');
        var selected_id = $(this).find('option:selected').attr('data-sub-id');
        var billingemail = active_subscription.billing_email;

        $(active_subscription).each(function (key, value) {

            $('.payment-card-name').html(value.payment_method)
            $('.payment-card-number').html(value.card_number)
            csp_subscription_id = value.subscription_id
            create_subscription_list = "";
            var pro_handle = value.product_handle;
            change_subscription_product_handle = value.product_handle
            var pro_plan = value.plan
            let product_json_date = "";
            get_pause_count_onload = active_subscription.pause_count
            var plan_variant_title = value.product_title;
            var variant_Array = plan_variant_title.split(" / ");
            change_subscription_current_product_variant = plan_variant_title.split(" / ");
            var plan_no_of_qty = value.product_quantity;
            change_subscription_current_product_quantity = value.product_quantity;

            jQuery.getJSON('/products/' + pro_handle + '.js', function (product) {
                product_json_date = $(product);
            });

            setTimeout(function () {
                var pro_status = value.status_of_subscription;
                var pro_next_billing = value.next_billing_at;
                var pro_selected_delivery_date = value.selected_delivery_date;
                var d_correct_date = new Date(pro_next_billing.split("-").reverse());

                var main = pro_selected_delivery_date.replace(/-/g, '/');
                var test_pro_selected_delivery_date = new Date(main)
                var d1 = test_pro_selected_delivery_date.getDate();
                var d2 = test_pro_selected_delivery_date.getMonth() + 1;
                var d3 = test_pro_selected_delivery_date.getFullYear();

                test_date_month_count = d1
                if (test_date_month_count < 10) {
                    var test_dlf = "0" + test_date_month_count
                } else {
                    var test_dlf = test_date_month_count
                }

                var test_new_delivery_date = test_dlf + "/" + d2 + "/" + d3;
                var dd = d_correct_date.getDate();
                var mm = d_correct_date.getMonth() + 1;
                var yy = d_correct_date.getFullYear();

                var nb_date = yy + "-" + mm + "-" + dd;

                var d_delivet_date = new Date(test_new_delivery_date);
                var dd_delivery = d_delivet_date.getDate();
                var mm_delivery = d_delivet_date.getMonth() + 1;
                var yy_delivery = d_delivet_date.getFullYear();
                var new_delivery_date = mm_delivery + "/" + dd_delivery + "/" + yy_delivery;


                var CurrentDate = new Date();
                GivenDate = new Date(nb_date);
                given_delivery_date = new Date(new_delivery_date)

                if (given_delivery_date > CurrentDate) {
                    var new_delivery_start_date = mm_delivery + "/" + dd_delivery + "/" + yy_delivery;
                } else {
                    var curr = new Date;
                    var friday_date = new Date(curr.setDate(curr.getDate() - curr.getDay() + 5));
                    var new_delivery_start_date = new Date(friday_date.getFullYear() + "/" + (friday_date.getMonth() + 1) + "/" + friday_date.getDate())
                }

                if (GivenDate > CurrentDate) {
                    var con_date = mm + "-" + dd + "-" + yy;

                } else {
                    var curr = new Date;
                    var monday_date = new Date(curr.setDate(curr.getDate() - curr.getDay() + 1));
                    var con_date = (monday_date.getMonth() + 1) + "/" + monday_date.getDate() + '/' + monday_date.getFullYear()
                    load_more_con_date = con_date;
                }

                if (active_subscription.status_of_subscription == "non_renewing") {
                } else {
                    var get_today_date = new Date();

                    //  code for show past pause subscriptino details code start here

                    if (active_subscription.plan == "ABO" || active_subscription.plan == "Abo" || active_subscription.plan == "abo") {
                        console.log('inside code for past subscription')
                        $(value.subscription_update_details).each(function (key1, value1) {
                            if (value1.status_of_subscription == "shopify_pause") {
                                var d1_for_current_date = new Date(); //yyyy-mm-dd  
                                var d2_for_past_pause_date = new Date(value1.delivery_cancel_date);
                                if (d1_for_current_date > d2_for_past_pause_date) {
                                    var show_past_payment_date = d2_for_past_pause_date.setDate(d2_for_past_pause_date.getDate() - 4)
                                    var date4455 = new Date(parseFloat(show_past_payment_date));
                                    var past_dd = date4455.getDate();
                                    var past_mm = date4455.getMonth() + 1;
                                    var past_yyyy = date4455.getFullYear();
                                    if (past_dd < 10) {
                                        past_dd = '0' + past_dd;
                                    }
                                    if (past_mm < 10) {
                                        past_mm = '0' + past_mm;
                                    }
                                    var full_past_pause_submit_val = past_dd + '.' + past_mm + "." + past_yyyy
                                    var past_d = new Date(d2_for_past_pause_date);
                                    var past_get_consumption = new Date((past_d));
                                    var past_fri_d = new Date(value1.delivery_cancel_date);
                                    var past_friday_dd = past_fri_d.getDate();
                                    var past_friday_mm = past_fri_d.getMonth() + 1;
                                    var past_friday_yyyy = past_fri_d.getFullYear();

                                    if (past_friday_dd < 10) {
                                        past_friday_dd = '0' + past_friday_dd;
                                    }
                                    if (past_friday_mm < 10) {
                                        past_friday_mm = '0' + past_friday_mm;
                                    }

                                    var full_past_pause_friday_date = past_friday_dd + '.' + past_friday_mm + "." + past_friday_yyyy
                                    var past_consumption_start = past_get_consumption.setDate(past_get_consumption.getDate() + 3);
                                    var past_consumption_end = past_get_consumption.setDate(past_get_consumption.getDate() + 4);
                                    var pastcon_start = new Date(parseFloat(past_consumption_start));
                                    var past_con_end = new Date(parseFloat(past_consumption_end));

                                    var past_MyDateString_start = ('0' + pastcon_start.getDate()).slice(-2) + '.' + ('0' + (pastcon_start.getMonth() + 1)).slice(-2);
                                    var past_MyDateString_end = ('0' + past_con_end.getDate()).slice(-2) + '.' + ('0' + (past_con_end.getMonth() + 1)).slice(-2);
                                    var past_combine_date_consumption = past_MyDateString_start + '-' + past_MyDateString_end;

                                    var past_get_current_week = getCurrentWeek(past_consumption_start);

                                    your_past_pause_subscription_data += `<div class="data-delivery-data-list ">
                                    <div class="heading-list">
                                    <div class="meal-consumption">
                                        <div class="consumption-dates">
                                        <div class="bet_cons">Betreuungswoche:</div><div class="cons-date">KW ${past_get_current_week} ( ${past_combine_date_consumption} )</div>
                                        </div>
                                        <div class="shipping-dates">
                                        <div class="next-payment-date">
                                            <div>Abrechnungsdatum:</div>
                                            <h2><span class="payment-day-name">Montag</span> ${full_past_pause_submit_val}</h2>
                                        </div>
                                        <div class="next-delivery-date">
                                            <div>Lieferdatum:</div>
                                            <h2><span class="payment-day-name">Freitag</span> ${full_past_pause_friday_date}</h2>
                                        </div>
                                        </div>              
                                    </div>    
                                    <div class="delivery-status">
                                        <div class="toggleSwitch__wrapper shopify_pause_wrapper">
                                                <label class="toggleSwitch">                                  
                                                <span class="toggleSwitch__state">
                                                <span class="toggleSwitch__state-item toggleSwitch__state-item--pause">Pausiert</span>
                                                <span class="toggleSwitch__state-item toggleSwitch__state-item--active">Aktiv</span>
                                                </span>
                                                <a></a>
                                            </label>
                                    </div>
                                    </div>
                                    </div>            
                                    </div>`

                                    $('.get-set-past-sub').show();
                                }
                            }
                        })
                    }

                    //  code for show past pause subscriptino details code end here  

                    for (i = 0; i < 10; i++) {
                        if (i == 0) {
                            var d = new Date(new_delivery_start_date);
                            var pa = d.setDate(d.getDate())
                            var date = new Date(parseFloat(pa)); //converting to date

                            var get_consumption = new Date(parseFloat(pa));
                            var consumption_start = get_consumption.setDate(get_consumption.getDate() + 3);
                            var consumption_end = get_consumption.setDate(get_consumption.getDate() + 4);
                            var con_start = new Date(parseFloat(consumption_start));
                            var con_end = new Date(parseFloat(consumption_end));

                            var get_current_week = getCurrentWeek(consumption_start);

                            var MyDateString_start = ('0' + con_start.getDate()).slice(-2) + '.' + ('0' + (con_start.getMonth() + 1)).slice(-2) + '.';
                            var MyDateString_end = ('0' + con_end.getDate()).slice(-2) + '.' + ('0' + (con_end.getMonth() + 1)).slice(-2) + '.';
                            var combine_date_consumption = MyDateString_start + '-' + MyDateString_end;

                            date_month_count = date.getMonth() + 1
                            if (date_month_count < 10) {
                                var dlf = "0" + date_month_count
                            } else {
                                var dlf = date_month_count
                            }

                            date_day_count = date.getDate()
                            if (date_day_count < 10) {
                                var hdf = "0" + date_day_count
                            } else {
                                var hdf = date_day_count
                            }

                            var last_added_dats_date = new Date(date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate())
                            var con_date = last_added_dats_date;
                            var converted_date_format = hdf + '.' + dlf + "." + date.getFullYear();
                            var date_to_pass_chargebee_month = date.getMonth() + 1;

                            if (date_to_pass_chargebee_month < 10) {
                                var dpc_month = "0" + date_to_pass_chargebee_month
                            } else {
                                var dpc_month = date_to_pass_chargebee_month
                            }

                            var date_to_pass_chargebee_day = date.getDate();
                            if (date_to_pass_chargebee_day < 10) {
                                var dpc_day = "0" + date_to_pass_chargebee_day
                            } else {
                                var dpc_day = date_to_pass_chargebee_day
                            }

                            var date_to_pass_chargebee = date.getFullYear() + '-' + dpc_month + "-" + dpc_day;
                            var modified_date_pass = (date.getMonth() + 1) + "/" + date.getDate() + '/' + date.getFullYear()
                            var date_compare_with_first_delivery_date = date.getDate() + '/' + dlf + "/" + date.getFullYear()
                            // code start for display payment date code stat here

                            var get_payment_date = new Date(con_date);
                            var submit_payment_date = get_payment_date.setDate(get_payment_date.getDate() - 4)
                            var date44 = new Date(parseFloat(submit_payment_date));

                            payment_date_month_count = date44.getMonth() + 1
                            if (payment_date_month_count < 10) {
                                var payment_dlf = "0" + payment_date_month_count
                            } else {
                                var payment_dlf = payment_date_month_count
                            }

                            payment_date_day_count = date44.getDate()
                            if (payment_date_day_count < 10) {
                                var payment_hdf = "0" + payment_date_day_count
                            } else {
                                var payment_hdf = payment_date_day_count
                            }

                            var converted_payment_date_format = payment_hdf + '.' + payment_dlf + "." + date44.getFullYear();

                            // // code start for display payment date code end here
                            if (date_compare_with_first_delivery_date == pro_selected_delivery_date) {
                                disable_first_date = "disable_first_date"
                            }
                        }
                        else {
                            disable_first_date = ""
                            var d = new Date(con_date);
                            // console.log('con date ='+ con_date);
                            var pa = d.setDate(d.getDate() + 7)
                            // console.log('pa = '+pa);
                            var date = new Date(parseFloat(pa)); //converting to date
                            // console.log('second date ='+ date);

                            var get_consumption = new Date(parseFloat(pa));
                            var consumption_start = get_consumption.setDate(get_consumption.getDate() + 3);
                            var consumption_end = get_consumption.setDate(get_consumption.getDate() + 4);
                            var con_start = new Date(parseFloat(consumption_start));
                            var con_end = new Date(parseFloat(consumption_end));

                            var MyDateString_start = ('0' + con_start.getDate()).slice(-2) + '.' + ('0' + (con_start.getMonth() + 1)).slice(-2) + '.';
                            var MyDateString_end = ('0' + con_end.getDate()).slice(-2) + '.' + ('0' + (con_end.getMonth() + 1)).slice(-2) + '.';
                            var combine_date_consumption = MyDateString_start + '-' + MyDateString_end;
                            // console.log(combine_date_consumption)

                            var get_current_week = getCurrentWeek(consumption_start);

                            date_month_count = date.getMonth() + 1
                            if (date_month_count < 10) {
                                var dlf = "0" + date_month_count
                            } else {
                                var dlf = date_month_count
                            }

                            date_day_count = date.getDate()
                            if (date_day_count < 10) {
                                var hdf = "0" + date_day_count
                            } else {
                                var hdf = date_day_count
                            }

                            var last_added_dats_date = new Date(date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate())
                            var con_date = last_added_dats_date;
                            load_more_con_date = last_added_dats_date;

                            var converted_date_format = hdf + '.' + dlf + "." + date.getFullYear();
                            var date_to_pass_chargebee_month = date.getMonth() + 1;
                            if (date_to_pass_chargebee_month < 10) {
                                var dpc_month = "0" + date_to_pass_chargebee_month
                            } else {
                                var dpc_month = date_to_pass_chargebee_month
                            }

                            var date_to_pass_chargebee_day = date.getDate();
                            if (date_to_pass_chargebee_day < 10) {
                                var dpc_day = "0" + date_to_pass_chargebee_day
                            } else {
                                var dpc_day = date_to_pass_chargebee_day
                            }
                            var date_to_pass_chargebee = date.getFullYear() + '-' + dpc_month + "-" + dpc_day;
                            var modified_date_pass = (date.getMonth() + 1) + "/" + date.getDate() + '/' + date.getFullYear()

                            // code start for display payment date code stat here

                            var get_payment_date = new Date(con_date);
                            var submit_payment_date = get_payment_date.setDate(get_payment_date.getDate() - 4)
                            var date44 = new Date(parseFloat(submit_payment_date));

                            payment_date_month_count = date44.getMonth() + 1
                            if (payment_date_month_count < 10) {
                                var payment_dlf = "0" + payment_date_month_count
                            } else {
                                var payment_dlf = payment_date_month_count
                            }

                            payment_date_day_count = date44.getDate()
                            if (payment_date_day_count < 10) {
                                var payment_hdf = "0" + payment_date_day_count
                            } else {
                                var payment_hdf = payment_date_day_count
                            }

                            var converted_payment_date_format = payment_hdf + '.' + payment_dlf + "." + date44.getFullYear();

                            // // code start for display payment date code end here
                        }

                        var curr = new Date;
                        var firstday = new Date(curr.setDate(curr.getDate() - curr.getDay()));
                        var lastday = new Date(curr.setDate(curr.getDate() - curr.getDay() + 6));


                        var d1 = modified_date_pass;
                        var de1 = new Date(d1);

                        let status_changer = "";
                        var paused_delivery_status = "";
                        // Client-side cutoff check: 4 days before delivery date at 09:00 AM
                        var deliveryDateTime = new Date(date.getTime());
                        var cutoffDateTime = new Date(deliveryDateTime.setDate(deliveryDateTime.getDate() - 4));
                        cutoffDateTime.setHours(9, 0, 0, 0);

                        var now = new Date();
                        var clientCutoffPassed = now > cutoffDateTime;

                        var make_previous_date_disable = "";
                        if (clientCutoffPassed) {
                            make_previous_date_disable = "make-previous-date-disable";
                        } else if (active_subscription && active_subscription.delivery_staus) {
                            var cutoffDateStr = active_subscription.delivery_staus.date;
                            var cutoffTimeExceeded = active_subscription.delivery_staus.cutoff_time_exceeded;
                            if (date_to_pass_chargebee < cutoffDateStr) {
                                make_previous_date_disable = "make-previous-date-disable";
                            } else if (date_to_pass_chargebee === cutoffDateStr && cutoffTimeExceeded) {
                                make_previous_date_disable = "make-previous-date-disable";
                            }
                        }
                        let isPresent = false;
                        let firstispresent = false;

                        let time_exceeded_class = ""
                        if (clientCutoffPassed) {
                            time_exceeded_class = "disable_first_date"
                        } else if (active_subscription && active_subscription.delivery_staus && active_subscription.delivery_staus.cutoff_time_exceeded == false && active_subscription.delivery_staus.date == date_to_pass_chargebee) {
                            time_exceeded_class = "disable_first_date"
                        } else {
                            time_exceeded_class = ""
                        }

                        disable_first_date_in_current_week = ""
                        if (value.subscription_update_details.length) {
                            $(value.subscription_update_details).each(function (key1, value1) {
                                if (date_to_pass_chargebee == value1.delivery_cancel_date) {
                                    if (value1.status_of_subscription == "shopify_pause") {
                                        isPresent = true;
                                        paused_delivery_status = "paused-delivery-status";
                                    } else {
                                        paused_delivery_status = "";
                                    }

                                    if (isPresent) {
                                        status_changer = `<div class="toggleSwitch__wrapper shopify_pause_wrapper test123">
                                                    <input id="state-change-btn-${date_to_pass_chargebee}" class="toggleSwitch__input order_status_change" type="checkbox" data-status="${value1.status_of_subscription}"  />
                                                        <label for="state-change-btn-${date_to_pass_chargebee}" class="toggleSwitch" subscription-date-attr="${date_to_pass_chargebee}" subscription-id-attr="${value.subscription_id}">                                  
                                                        <span class="toggleSwitch__state">
                                                        <span class="toggleSwitch__state-item toggleSwitch__state-item--pause">Pausiert</span>
                                                        <span class="toggleSwitch__state-item toggleSwitch__state-item--active">Aktiv</span>
                                                        </span>
                                                        <a></a>
                                                    </label>
                                                    </div>`
                                        return false
                                    } else {
                                        status_changer = `<div class="toggleSwitch__wrapper shopify_resume_wrapper test111">
                                                <input id="state-change-btn-${date_to_pass_chargebee}" class="toggleSwitch__input order_status_change" type="checkbox" checked />
                                                <label for="state-change-btn-${date_to_pass_chargebee}" class="toggleSwitch" subscription-date-attr="${date_to_pass_chargebee}" subscription-id-attr="${value.subscription_id}">                                  
                                                    <span class="toggleSwitch__state">
                                                    <span class="toggleSwitch__state-item toggleSwitch__state-item--pause">Pausiert</span>
                                                    <span class="toggleSwitch__state-item toggleSwitch__state-item--active">Aktiv</span>
                                                    </span>
                                                    <a></a>
                                                </label>
                                                </div>`
                                    }

                                } else {
                                    status_changer = `<div class="toggleSwitch__wrapper shopify_resume_wrapper test456">
                                            <input id="state-change-btn-${date_to_pass_chargebee}" class="toggleSwitch__input order_status_change" type="checkbox" 
                                                ${converted_date_format == '27.12.2024' || converted_date_format == '03.01.2025' ? '' : 'checked'}/>
                                            <label for="state-change-btn-${date_to_pass_chargebee}" class="toggleSwitch" subscription-date-attr="${date_to_pass_chargebee}" subscription-id-attr="${value.subscription_id}">                                  
                                                <span class="toggleSwitch__state">
                                                <span class="toggleSwitch__state-item toggleSwitch__state-item--pause">Pausiert</span>
                                                <span class="toggleSwitch__state-item toggleSwitch__state-item--active">Aktiv</span>
                                                </span>
                                                <a></a>
                                            </label>
                                            </div>`
                                }
                            })
                        } else {
                            status_changer = `<div class="toggleSwitch__wrapper test789">
                                        <input id="state-change-btn-${date_to_pass_chargebee}" class="toggleSwitch__input order_status_change" type="checkbox" checked />    
                                        <label for="state-change-btn-${date_to_pass_chargebee}" class="toggleSwitch" subscription-date-attr="${date_to_pass_chargebee}" subscription-id-attr="${value.subscription_id}">                                  
                                            <span class="toggleSwitch__state">
                                                <span class="toggleSwitch__state-item toggleSwitch__state-item--pause">Pausiert</span>
                                                <span class="toggleSwitch__state-item toggleSwitch__state-item--active">Aktiv</span>
                                            </span>
                                            <a></a>
                                            </label>
                                        </div>`
                        }

                        if (active_subscription.plan == "ABO" || active_subscription.plan == "Abo" || active_subscription.plan == "abo") {
                            if (!isPresent) {
                                if (active_subscription.pause_count == 0 && active_subscription.is_limited_pause == true) {
                                    class_for_make_abo_state_disable = "make_disalbe_state_change_abo"
                                }
                            } else {
                                class_for_make_abo_state_disable = ""
                            }
                        }

                        create_subscription_list += `<div class="${converted_date_format == '27.12.2024' || converted_date_format == '03.01.2025' ? 'holiday-date-disable' : ''} data-delivery-data-list ${paused_delivery_status} ${class_for_make_abo_state_disable} ${disable_first_date} ${disable_first_date_in_current_week} ${time_exceeded_class} ${make_previous_date_disable}">
                            <div class="heading-list">
                                <div class="bet_cons_tooltip" ${converted_date_format == '27.12.2024' ? '' : converted_date_format == '03.01.2025' ? 'style="display:block;"' : converted_date_format == '20.12.2024' ? 'style="display:block;"' : 'style="display:none;"'}>
                                    <img
                                        src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/Info_Button_Pauses_2.svg?v=1733373525"
                                        alt="info-tip"
                                    />
                                <div class="tooltip-hover">
                                    <p>
                                    ${converted_date_format == '27.12.2024' || converted_date_format == '03.01.2025' ? 'Aufgrund der Feiertage erfolgt keine Lieferung. Bitte beachten Sie, dass diese Pausierung verpflichtend ist und nicht auf die Anzahl der möglichen Pausierungen angerechnet wird.' : converted_date_format == '20.12.2024' ? 'Bitte die Sendung nach Erhalt einfrieren! Die Gerichte sind für die Betreuungswoche vom 06.01. bis 10.01.2024 vorgesehen, da am 03.01.2024 keine Lieferung erfolgen kann. ' : 'Bitte pausieren, falls die Lieferung nicht gewünscht ist.'}
                                    </p>
                                </div>
                                </div>
                                <div class="meal-consumption ${converted_date_format == '27.12.2024' || converted_date_format == '03.01.2025' ? 'disable_date' : ''}">
                                <div class="consumption-dates">
                                    <div class="bet_cons">Betreuungswoche:</div>
                                    <div class="cons-date">
                                    <div class="cons-date ${converted_date_format}">
                                        ${converted_date_format == '27.12.2024' ? 'KEINE LIEFERUNG WEGEN WEIHNACHTEN' : converted_date_format == '03.01.2025' ? 'KEINE LIEFERUNG WEGEN NEUJAHR' : converted_date_format == '20.12.2024' ? 'KW 1 (06.01.-10.01.)' : 'KW ' + get_current_week + ' (' + combine_date_consumption + ')'}
                                    </div>
                                    </div>
                                </div>
                                <div class="shipping-dates">
                                    <div class="next-payment-date">
                                    <div>Abrechnungsdatum:</div>
                                    ${converted_date_format == '27.12.2024' ? '' : converted_date_format == '03.01.2025' ? '' : '<h2><span class="payment-day-name">Montag</span> ' + converted_payment_date_format + '</h2>'}
                                    </div>
                                    <div class="next-delivery-date">
                                    <div>Lieferdatum:</div>
                                    <h2>
                                        <span class="payment-day-name">Freitag</span>
                                        ${converted_date_format}
                                    </h2>
                                    </div>
                                </div>
                                </div>
                                <div class="delivery-status ${converted_date_format == '27.12.2024' || converted_date_format == '03.01.2025' ? 'disable_date' : ''}">
                                    ${status_changer}
                                </div>
                            </div>
                            ${(meal_data && meal_data.isFlexPlan) ? (renderMeals(meal_data, converted_date_format) ? `    
                            <div class="meal-selection ${time_exceeded_class}">
                                <div class="meal-selection__header js-dish-selection">
                                    <h2 class="meal-selection__title">
                                        Gerichte
                                    </h2>
                                    <svg
                                        class="meal-selection__toggle"
                                        fill="#7ea35b"
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 199.40 199.40"
                                        stroke="#7ea35b"
                                        stroke-width="0.00199404">
                                        <g>
                                            <polygon points="0,135.411 28.285,163.695 99.703,92.277 171.119,163.695 199.404,135.412 99.703,35.709"></polygon>
                                        </g>
                                    </svg>
                                    <h2 class="meal-selection__title">
                                        auswählen
                                    </h2>
                                </div>
                                <div class="meal-selection__content meal-list" data-delivery-date="${converted_date_format}">
                                    <p class="meal-selection__info">
                                        Änderungen der Gerichte können bis
                                        <strong>Montag ${converted_payment_date_format} um 09:00 Uhr</strong>
                                        vorgenommen werden.
                                    </p>
                                    ${renderMeals(meal_data, converted_date_format)}
                                </div>
                            </div>` : `
                            <div class="meal-selection ${time_exceeded_class}">
                                <div class="meal-selection__header js-dish-selection">
                                    <h2 class="meal-selection__title">
                                        Gerichte
                                    </h2>
                                    <svg
                                        class="meal-selection__toggle"
                                        fill="#7ea35b"
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 199.40 199.40"
                                        stroke="#7ea35b"
                                        stroke-width="0.00199404">
                                        <g>
                                            <polygon points="0,135.411 28.285,163.695 99.703,92.277 171.119,163.695 199.404,135.412 99.703,35.709"></polygon>
                                        </g>
                                    </svg>
                                    <h2 class="meal-selection__title">
                                        auswählen
                                    </h2>
                                </div>
                                <div class="meal-selection__content meal-list" data-delivery-date="${converted_date_format}">
                                    ${getMealsNotAvailableHTML()}
                                </div>
                            </div>`) : ''}
                        </div>`
                    }

                    // code for load more feature delivery dates code start here

                    $(document).on('click', '.load_more_dates .btn', function () {
                        for (i = 0; i < 10; i++) {
                            var d = new Date(load_more_con_date);
                            var pa = d.setDate(d.getDate() + 7)
                            var date = new Date(parseFloat(pa));

                            var get_consumption = new Date(parseFloat(pa));
                            var consumption_start = get_consumption.setDate(get_consumption.getDate() + 3);
                            var consumption_end = get_consumption.setDate(get_consumption.getDate() + 4);
                            var con_start = new Date(parseFloat(consumption_start));
                            var con_end = new Date(parseFloat(consumption_end));

                            var MyDateString_start = ('0' + con_start.getDate()).slice(-2) + '.' + ('0' + (con_start.getMonth() + 1)).slice(-2) + '.';
                            var MyDateString_end = ('0' + con_end.getDate()).slice(-2) + '.' + ('0' + (con_end.getMonth() + 1)).slice(-2) + '.';
                            var combine_date_consumption = MyDateString_start + '-' + MyDateString_end;

                            var get_current_week = getCurrentWeek(consumption_start);

                            date_month_count = date.getMonth() + 1
                            if (date_month_count < 10) {
                                var dlf = "0" + date_month_count
                            } else {
                                var dlf = date_month_count
                            }

                            date_day_count = date.getDate()
                            if (date_day_count < 10) {
                                var hdf = "0" + date_day_count
                            } else {
                                var hdf = date_day_count
                            }

                            var last_added_dats_date = new Date(date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate())
                            var con_date = last_added_dats_date;
                            load_more_con_date = last_added_dats_date
                            var converted_date_format = hdf + '.' + dlf + "." + date.getFullYear();
                            var date_to_pass_chargebee_month = date.getMonth() + 1;
                            if (date_to_pass_chargebee_month < 10) {
                                var dpc_month = "0" + date_to_pass_chargebee_month
                            } else {
                                var dpc_month = date_to_pass_chargebee_month
                            }
                            var date_to_pass_chargebee_day = date.getDate();
                            if (date_to_pass_chargebee_day < 10) {
                                var dpc_day = "0" + date_to_pass_chargebee_day
                            } else {
                                var dpc_day = date_to_pass_chargebee_day
                            }

                            var date_to_pass_chargebee = date.getFullYear() + '-' + dpc_month + "-" + dpc_day;
                            var modified_date_pass = (date.getMonth() + 1) + "/" + date.getDate() + '/' + date.getFullYear()

                            // code start for display payment date code stat here

                            var get_payment_date = new Date(con_date);
                            var submit_payment_date = get_payment_date.setDate(get_payment_date.getDate() - 4)
                            var date44 = new Date(parseFloat(submit_payment_date));

                            payment_date_month_count = date44.getMonth() + 1
                            if (payment_date_month_count < 10) {
                                var payment_dlf = "0" + payment_date_month_count
                            } else {
                                var payment_dlf = payment_date_month_count
                            }

                            payment_date_day_count = date44.getDate()
                            if (payment_date_day_count < 10) {
                                var payment_hdf = "0" + payment_date_day_count
                            } else {
                                var payment_hdf = payment_date_day_count
                            }

                            var converted_payment_date_format = payment_hdf + '.' + payment_dlf + "." + date44.getFullYear();

                            // // code start for display payment date code end here

                            var curr = new Date;
                            var firstday = new Date(curr.setDate(curr.getDate() - curr.getDay()));
                            var lastday = new Date(curr.setDate(curr.getDate() - curr.getDay() + 6));

                            var d1 = modified_date_pass;
                            var de1 = new Date(d1.split("-").reverse());
                            let status_changer = "";
                            var paused_delivery_status = "";
                            let isPresent = false;

                            if (value.subscription_update_details.length) {
                                $(value.subscription_update_details).each(function (key1, value1) {
                                    if (date_to_pass_chargebee == value1.delivery_cancel_date) {

                                        if (value1.status_of_subscription == "shopify_pause") {
                                            isPresent = true;
                                            paused_delivery_status = "paused-delivery-status";
                                        } else {
                                            paused_delivery_status = "";
                                        }

                                        if (isPresent) {
                                            status_changer = `<div class="toggleSwitch__wrapper shopify_pause_wrapper">
                                                        <input id="state-change-btn-${date_to_pass_chargebee}" class="toggleSwitch__input order_status_change" type="checkbox" data-status="${value1.status_of_subscription}"  />
                                                        <label for="state-change-btn-${date_to_pass_chargebee}" class="toggleSwitch" subscription-date-attr="${date_to_pass_chargebee}" subscription-id-attr="${value.subscription_id}">                                  
                                                        <span class="toggleSwitch__state">
                                                            <span class="toggleSwitch__state-item toggleSwitch__state-item--pause">Pausiert</span>
                                                            <span class="toggleSwitch__state-item toggleSwitch__state-item--active">Aktiv</span>
                                                        </span>
                                                        <a></a>
                                                        </label>
                                                    </div>`
                                            return false
                                        }
                                    } else {
                                        status_changer = `<div class="toggleSwitch__wrapper shopify_resume_wrapper">
                                                    <input id="state-change-btn-${date_to_pass_chargebee}" class="toggleSwitch__input order_status_change" type="checkbox" checked />
                                                    <label for="state-change-btn-${date_to_pass_chargebee}" class="toggleSwitch" subscription-date-attr="${date_to_pass_chargebee}" subscription-id-attr="${value.subscription_id}">                                  
                                                        <span class="toggleSwitch__state">
                                                        <span class="toggleSwitch__state-item toggleSwitch__state-item--pause">Pausiert</span>
                                                        <span class="toggleSwitch__state-item toggleSwitch__state-item--active">Aktiv</span>
                                                        </span>
                                                        <a></a>
                                                    </label>
                                                    </div>`
                                    }
                                })
                            } else {
                                status_changer = `<div class="toggleSwitch__wrapper ">
                                        <input id="state-change-btn-${date_to_pass_chargebee}" class="toggleSwitch__input order_status_change" type="checkbox" checked />    
                                        <label for="state-change-btn-${date_to_pass_chargebee}" class="toggleSwitch" subscription-date-attr="${date_to_pass_chargebee}" subscription-id-attr="${value.subscription_id}">                                  
                                            <span class="toggleSwitch__state">
                                            <span class="toggleSwitch__state-item toggleSwitch__state-item--pause">Pausiert</span>
                                            <span class="toggleSwitch__state-item toggleSwitch__state-item--active">Aktiv</span>
                                            </span>
                                            <a></a>
                                        </label>
                                        </div>`
                            }


                            if (active_subscription.plan == "ABO" || active_subscription.plan == "Abo" || active_subscription.plan == "abo") {
                                if (!isPresent) {
                                    if (active_subscription.pause_count == 0 && active_subscription.is_limited_pause == true) {
                                        class_for_make_abo_state_disable = "make_disalbe_state_change_abo"
                                    }
                                } else {
                                    class_for_make_abo_state_disable = ""
                                }
                            }

                            load_more_create_subscription_list += `
                            <div class="data-delivery-data-list ${paused_delivery_status} ${class_for_make_abo_state_disable}">
                                <div class="heading-list">
                                <div class="meal-consumption">
                                    <div class="consumption-dates">
                                    <div class="bet_cons">Betreuungswoche:</div><div class="cons-date">KW ${get_current_week} ( ${combine_date_consumption} )</div>
                                    </div>
                                    <div class="shipping-dates">
                                    <div class="next-payment-date">
                                        <div>Abrechnungsdatum:</div>
                                        <h2><span class="payment-day-name">Montag</span> ${converted_payment_date_format}</h2>
                                    </div>
                                    <div class="next-delivery-date">
                                        <div>Lieferdatum:</div>
                                        <h2><span class="payment-day-name">Freitag</span> ${converted_date_format}</h2>
                                    </div>
                                    </div>              
                                </div> 
                                <div class="delivery-status">${status_changer}</div>
                                </div>
                                ${(meal_data && meal_data.isFlexPlan) ? (renderMeals(meal_data, converted_date_format) ? `
                                 <div class="meal-selection">
                                    <div class="meal-selection__header js-dish-selection">
                                        <h2 class="meal-selection__title">
                                            Gerichte
                                        </h2>
                                        <svg
                                            class="meal-selection__toggle"
                                            fill="#7ea35b"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 199.40 199.40"
                                            stroke="#7ea35b"
                                            stroke-width="0.00199404">
                                            <g>
                                            <polygon points="0,135.411 28.285,163.695 99.703,92.277 171.119,163.695 199.404,135.412 99.703,35.709"></polygon>
                                            </g>
                                        </svg>
                                        <h2 class="meal-selection__title">
                                            auswählen
                                        </h2>
                                    </div>
                                    <div class="meal-selection__content meal-list" data-delivery-date="${converted_date_format}">
                                        <p class="meal-selection__info">
                                            Änderungen der Gerichte können bis
                                            <strong>Montag ${converted_payment_date_format} um 09:00 Uhr</strong>
                                            vorgenommen werden.
                                        </p>
                                        ${renderMeals(meal_data, converted_date_format)}
                                    </div>
                                </div>` : `
                                <div class="meal-selection">
                                   <div class="meal-selection__header js-dish-selection">
                                       <h2 class="meal-selection__title">
                                           Gerichte
                                       </h2>
                                       <svg
                                           class="meal-selection__toggle"
                                           fill="#7ea35b"
                                           version="1.1"
                                           xmlns="http://www.w3.org/2000/svg"
                                           viewBox="0 0 199.40 199.40"
                                           stroke="#7ea35b"
                                           stroke-width="0.00199404">
                                           <g>
                                           <polygon points="0,135.411 28.285,163.695 99.703,92.277 171.119,163.695 199.404,135.412 99.703,35.709"></polygon>
                                           </g>
                                       </svg>
                                       <h2 class="meal-selection__title">
                                           auswählen
                                       </h2>
                                   </div>
                                   <div class="meal-selection__content meal-list" data-delivery-date="${converted_date_format}">
                                       ${getMealsNotAvailableHTML()}
                                    </div>
                               </div>`) : ''}    
                            </div>`
                        }

                        $('.subscription-plan-details #created_subscription_list').append(load_more_create_subscription_list)
                        load_more_create_subscription_list = ""

                        if (active_subscription.plan == "ABO" || active_subscription.plan == "Abo" || active_subscription.plan == "abo") {
                            if (get_pause_count_onload == 0 && active_subscription.is_limited_pause == true) {
                                $('.data-delivery-data-list').each(function () {
                                    var demp = this;
                                    if ($(demp).find('.toggleSwitch__wrapper').hasClass('shopify_resume_wrapper')) {
                                        $(demp).addClass('make_disalbe_state_change_abo');
                                    }
                                })
                            }
                            if (get_pause_count_onload > 0) {
                                $('.data-delivery-data-list').each(function () {
                                    var demp = this;
                                    if ($(demp).find('.toggleSwitch__wrapper').hasClass('shopify_resume_wrapper')) {
                                        $(demp).removeClass('make_disalbe_state_change_abo');
                                    }
                                })
                            }
                        }

                    })

                    // code for load more feature delivery dates code end here
                    //**********************************************************
                }


                if (active_subscription.subscription_cancellation_request == true) {
                    make_disable_cancel_button = "disable"
                    $('.cancel_subscription_overlay').remove();
                    $('.subscription_remove_confirmation').remove();
                } else {
                    make_disable_cancel_button = ""
                }

                if (pro_plan == "FLEX" || pro_plan == "flex") {
                    // Both daycare flows use the cancellation handler below;
                    // it selects the parent account payload and authentication when needed.
                    if (active_subscription.status_of_subscription == "non_renewing") {
                        var cancel_subscription_data = '<div class="status-btn btn" style="margin-left: auto;display: table;">Subscription Cancelled</div>';
                    }
                    else {
                        var cancel_subscription_data = '<div class="enable-cancel status-btn btn ' + make_disable_cancel_button + '" subscription-date-attr="' + date_to_pass_chargebee + '" subscription-id-attr="' + value.subscription_id + '" style="margin-left: auto;display: table;">Kündigen</div>';
                    }
                }
                else {
                    if ($("#created_subscription_list").hasClass("daycare-customer")) {
                        var cancel_subscription_data = "";
                    }
                    else {
                        if (active_subscription.status_of_subscription == "non_renewing") {
                            var cancel_subscription_data = '<div class="status-btn btn" style="margin-left: auto;display: table;">Subscription Cancelled</div>';
                        }
                        else {
                            var cancel_subscription_data = "";
                        }
                    }
                }

                if (value.device_price == "NULL" || value.device_price == "null") {
                    var addon_device = ""
                    var order_overview_addon_price = ""
                    csp_get_device_price = false;
                }
                else {
                    csp_get_device_price = true;
                    var addon_device = '<div>5. Sous-Vide Geräte Optionen: <span>Mit Gerät (+ € ' + value.device_price.replace('.', ',') + ')</span></div>'
                    var order_overview_addon_price = '<span>6. Sous-Vide Geräte Optionen:</span> <span>Mit Gerät (+ € ' + value.device_price.replace('.', ',') + ')<label>Mietpreis pro Lieferwoche</label></span>'
                }

                if (active_subscription.plan == "ABO") {
                    var basic_plan_price = `2,99`
                } else {
                    var basic_plan_price = `3,50`
                }

                var new_converted_price = value.total_amount;
                var price_with_comma = new_converted_price.toString().replace('.', ',')

                if (value.device_price == "NULL" || value.device_price == "null") {
                    var csp_device_data = `<div class="config-box__item config-box-change-sous" data-equalizer="">
                                    <div class="config-box__head text-center">
                                        <h4 class="config-box__title">${getSetting('fifth_step_heading')}</h4>
                                    </div>                                
                                    <div class="form__row pure-g">
                                        <div class="pure-u-1-2 pure-u-md-1-2">
                                            <div class="form__radio-wrapper">
                                                <input type="radio" class="form__radio" name="change_devices" id="cps_noDevice" data-device-attr="Ohne Gerät" checked>
                                                <label for="cps_noDevice" class="form__radio-label">Ohne Gerät</label>
                                            </div>
                                            ${getSetting('no_device_notes') ? `<span class="form__small-text">${getSetting('no_device_notes')}</span>` : ''}
                                        </div>
                                        <div class="pure-u-1-2 pure-u-md-1-2">
                                            <div class="form__radio-wrapper">
                                                <input type="radio" class="form__radio" name="change_devices" id="cps_withDevice" data-pro-price="" data-pro-id="" data-sell_id="" data-device-handle-abo="${getSetting('device_product_abo')}" data-device-handle-flex="${getSetting('device_product_flex')}" data-device-attr="Mit Gerät">
                                                <label for="cps_withDevice" class="form__radio-label">Mit Gerät <span class="d-none d-md-inline">(empfohlen)</span></label> 
                                            </div>
                                            ${getSetting('with_device_notes') ? `<span class="form__small-text">${getSetting('with_device_notes')}</span>` : ''}
                                        </div>
                                    </div>
                                    ${getSetting('fifth_step_info_popup_text') ? `
                                    <div class="config-box__info js-config-device-info">
                                        <span>?</span>
                                    </div>` : ''}                                
                                </div>`
                } else {
                    var csp_device_data = `<div class="config-box__item config-box-change-sous" data-equalizer="">
                                <div class="config-box__head text-center">
                                    <h4 class="config-box__title">${getSetting('fifth_step_heading')}</h4>
                                </div>
                                <div class="form__row pure-g">
                                    <div class="pure-u-1-2 pure-u-md-1-2">
                                        <div class="form__radio-wrapper">
                                            <input type="radio" class="form__radio disable-" name="change_devices" id="cps_noDevice" data-device-attr="Ohne Gerät" disabled->
                                            <label for="cps_noDevice" class="form__radio-label">Ohne Gerät</label>
                                        </div>
                                        ${getSetting('no_device_notes') ? `<span class="form__small-text">${getSetting('no_device_notes')}</span>` : ''}
                                    </div>
                                    <div class="pure-u-1-2 pure-u-md-1-2">
                                        <div class="form__radio-wrapper">
                                            <input type="radio" class="form__radio " name="change_devices" id="cps_withDevice" checked data-pro-price="" data-pro-id="" data-sell_id="" data-device-handle-abo="${getSetting('device_product_abo')}" data-device-handle-flex="${getSetting('device_product_flex')}" data-device-attr="Mit Gerät">
                                            <label for="cps_withDevice" class="form__radio-label">Mit Gerät <span class="d-none d-md-inline">(empfohlen)</span></label> 
                                        </div>
                                        ${getSetting('with_device_notes') ? `<span class="form__small-text">${getSetting('with_device_notes')}</span>` : ''}
                                    </div>
                                </div>
                                ${getSetting('fifth_step_info_popup_text') ? `
                                <div class="config-box__info js-config-device-info">
                                    <span>?</span>
                                </div>` : ''}                                
                            </div>`
                }

                if ($("#created_subscription_list").hasClass("daycare-customer")) {
                    var change_subscription_data_button = `<div class="change-subscription-product open-subscription-change-popup demo" data-change-product-handle="${pro_handle}">Präferenz ändern</div>`;
                    var change_subscription_kid_selector = `<div class="config-box__item config-box-change-kids ipctest" data-equalizer="">                                
                                            <div class="config-box__head text-center">
                                                <h4 class="config-box__title">${getSetting('first_step_heading')}</h4>
                                            </div>
            
                                            <div class="form__row pure-g">
                                                <div class="pure-u-1 pure-u-md-1">
                                                    <div class="form__select-wrapper" id="js-change-portion-toggle">
                                                        <div class="form__select-inner">
                                                            <div class="form__select-title">                                                    
                                                                <span class="form__select-val" id="js-change-portion-selected-text"></span>
                                                                <input type="text" class="form__select-input hidden" name="change_qut" value="5" id="js-change-portion-selected" readonly />
                                                                <span>Kinder</span>
                                                            </div>
                                                            <div class="form__select-dropdown">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="21.412" height="13.743" viewBox="0 0 21.412 13.743">
                                                                    <use href="#icon-arrow-2"></use>
                                                                </svg>
                                                            </div>
                                                        </div>
                                                        <div class="form__select-list__wrapper" id="js-change-portion-select">
                                                            <ul class="form__select-list">
                                                                ${(getSetting('jp_final_quantity', [])).map((i, idx) => `
                                                                    <li data-quantity="${i}" class="${idx === 0 ? 'active' : ''}">${i}</li>
                                                                `).join('')}
                                                            </ul>
                                                        </div>
                                                        
            
                                                    </div>
                                                    <div class="form__small-text" ><span id="js-change-portion-text" data-type="true"><b>Portion size for childminders
                                                    </b></span></div>
                                                </div>
                                            </div>
                                            ${getSetting('first_step_info_popup_text') ? `
                                            <div class="config-box__info js-config-kids-info">
                                                <span>?</span>
                                            </div>` : ''}
                                        </div>`;
                } else {
                    var change_subscription_data_button = `<div class="change-subscription-product open-subscription-change-popup demo" data-change-product-handle="${pro_handle}">Präferenz ändern</div>`;
                    var change_subscription_kid_selector = `<div class="config-box__item config-box-change-kids helotest" data-equalizer="">                                
                                            <div class="config-box__head text-center">
                                                <h4 class="config-box__title">${getSetting('first_step_heading')}</h4>
                                            </div>
            
                                            <div class="form__row pure-g">
                                                <div class="pure-u-1 pure-u-md-1">
                                                    <div class="form__select-wrapper" id="js-change-portion-toggle">
                                                        <div class="form__select-inner">
                                                            <div class="form__select-title">                                                    
                                                                <span class="form__select-val" id="js-change-portion-selected-text">5</span>
                                                                <input type="text" class="form__select-input hidden" value="" id="js-change-portion-selected" readonly />
                                                                <span>Kinder</span>
                                                            </div>
                                                            <div class="form__select-dropdown">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="21.412" height="13.743" viewBox="0 0 21.412 13.743">
                                                                    <use href="#icon-arrow-2"></use>
                                                                </svg>
                                                            </div>
                                                        </div>
                                                        <div class="form__select-list__wrapper" id="js-change-portion-select">
                                                            <ul class="form__select-list">
                                                                ${(getSetting('jp_final_quantity', [])).map((i, idx) => `
                                                                    <li data-quantity="${i}" class="${idx === 0 ? 'active' : ''}">${i}</li>
                                                                `).join('')}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div class="form__small-text" ><span id="js-change-portion-text" data-type="true"><b>Portion size for childminders
                                                    </b></span></div>
                                                </div>
                                            </div>
                                            ${getSetting('first_step_info_popup_text') ? `
                                            <div class="config-box__info js-config-kids-info">
                                                <span>?</span>
                                            </div>` : ''}
                                        </div> `
                }

                your_subscription_data = `
                <div class="sub-inner-content">
                    ${change_subscription_data_button}                   
                    <div class="plan-details-section">
                        <div class="delivery-product-details">
                        <div>
                        <img src="${product_json_date[0].featured_image}">
                        </div>
                        <b>${product_json_date[0].title}</b>
                        </div>
                        <div>1. Anzahl der betreuten Kinder: <span>${plan_no_of_qty} Kinder</span></div>
                        <div class="selecetd_quentity">2. Anzahl der Betreuungstage: <span>${variant_Array[0]}</span></div>
                        <div class="diatry_pattern">3. Ernährungsform: <span>${variant_Array[1]}</span></div>
                        <div class="court_preferance">4. Gerichtepräferenz: <span>${variant_Array[2]}</span></div>
                        ${addon_device}
                        <div>7% MwSt. <span class="discounted_price">+ € <span class="discounted_price_inner">10,50</span></span></div>
                        <div class="express_kuhlversand">
                        Express Kühlversand: <span><span class="chinuki-asf"><span>€ </span><span class="order-overview-shipping-rate"></span></span><label>Versandpreis pro Lieferung</label></span>
                        </div>
                        <div class="plan-final-bottom-price"><h3>Dein Preis*</h3><span><h3>€ ${price_with_comma}</h3></span></div>
                        ${cancel_subscription_data}              
                        <div class="order_counter_list_second"></div>
                        <div class="subscription-renew-date" style="display:none"></div>
                    </div>
                </div>`

                var eth = variant_Array[0].replace(/[^0-9]/g, '')
                var p_qty = parseInt(eth);
                var snipper = p_qty * plan_no_of_qty;
                let aspiresol = ""
                setTimeout(function () {
                    if (pro_plan == "ABO") {
                        var final_snipper = snipper * 2.99;
                        // console.log('plan_no_of_qty ',plan_no_of_qty)
                        // console.log('p_qty ',p_qty)

                        if ((plan_no_of_qty >= 3 && plan_no_of_qty <= 15) && (p_qty == 3)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_abo_1.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_abo_1);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 16 && plan_no_of_qty <= 35) && (p_qty == 3)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_abo_2.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_abo_2);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 36 && plan_no_of_qty <= 50) && (p_qty == 3)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_abo_3.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_abo_3);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 3 && plan_no_of_qty <= 10) && (p_qty == 4)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_abo_1.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_abo_1);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 11 && plan_no_of_qty <= 25) && (p_qty == 4)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_abo_2.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_abo_2);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 26 && plan_no_of_qty <= 35) && (p_qty == 4)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_abo_3.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_abo_3);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 36 && plan_no_of_qty <= 50) && (p_qty == 4)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_abo_4.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_abo_4);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 3 && plan_no_of_qty <= 10) && (p_qty == 5)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_abo_1.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_abo_1);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 11 && plan_no_of_qty <= 20) && (p_qty == 5)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_abo_2.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_abo_2);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 21 && plan_no_of_qty <= 30) && (p_qty == 5)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_abo_3.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_abo_3);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 31 && plan_no_of_qty <= 40) && (p_qty == 5)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_abo_4.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_abo_4);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 41 && plan_no_of_qty <= 50) && (p_qty == 5)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_abo_5.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_abo_5);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }

                    } else {
                        var final_snipper = snipper * 3.50;

                        if ((plan_no_of_qty >= 3 && plan_no_of_qty <= 15) && (p_qty == 3)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_flex_1.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_flex_1);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 16 && plan_no_of_qty <= 35) && (p_qty == 3)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_flex_2.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_flex_2);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 36 && plan_no_of_qty <= 50) && (p_qty == 3)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_flex_3.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_flex_3);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 3 && plan_no_of_qty <= 10) && (p_qty == 4)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_flex_1.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_flex_1);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 11 && plan_no_of_qty <= 25) && (p_qty == 4)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_flex_2.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_flex_2);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 26 && plan_no_of_qty <= 35) && (p_qty == 4)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_flex_3.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_flex_3);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 36 && plan_no_of_qty <= 50) && (p_qty == 4)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_flex_4.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_flex_4);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 51 && plan_no_of_qty <= 60) && (p_qty == 4)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_flex_6.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_flex_6);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 3 && plan_no_of_qty <= 10) && (p_qty == 5)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_flex_1.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_flex_1);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 11 && plan_no_of_qty <= 20) && (p_qty == 5)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_flex_2.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_flex_2);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 21 && plan_no_of_qty <= 30) && (p_qty == 5)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_flex_3.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_flex_3);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 31 && plan_no_of_qty <= 40) && (p_qty == 5)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_flex_4.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_flex_4);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                        else if ((plan_no_of_qty >= 41 && plan_no_of_qty <= 50) && (p_qty == 5)) {
                            $('.order-overview-shipping-rate').text(shipping_cost_flex_5.replace('.', ','))
                            var sr = Number.parseFloat(shipping_cost_flex_5);
                            var pq = Number.parseFloat(value.device_price);
                            if (!isNaN(pq)) {
                                // Only add pq if it's a valid number
                                aspiresol = final_snipper + (sr + pq);
                            } else {
                                aspiresol = final_snipper + sr;
                            }
                        }
                    }

                    var discount = aspiresol * 0.07;
                    var subtotal = aspiresol + discount;

                    $('.overview_subtotal_price_inner').text(aspiresol.toFixed(2).replace('.', ','));
                    $('.discounted_price_inner').text(discount.toFixed(2).replace('.', ','));
                    $('.overview_total_price_inner').text(subtotal.toFixed(2).replace('.', ','));

                }, 1000)

                order_overview_wrapper = `
                <div class="order-details-box">
                    <div class="order-details-box__inner">
                        <div class="order-details-box__detail">
                        <div class="heading">
                            <img src="{{ 'order-overview-box-icon4.svg' | file_url }}" alt="icon" class="order-details-box__icon" />
                            <h2 class="tab-content-list-heading">Bestelldetails</h2>
                        </div>
                        <ul>
                            <li>
                            <span>1. Anzahl der betreuten Kinder:</span>
                            <span>${plan_no_of_qty} Kinder</span>
                            </li>
                            <li>
                            <span>2. Anzahl der Betreuungstage:</span>
                            <span>${variant_Array[0]}</span>
                            </li>
                            <li>
                            <span>3. Ernährungsform:</span>
                            <span>${variant_Array[1]}</span>
                            </li>
                            <li>
                            <span>4. Gerichtepräferenz:</span>
                            <span>${variant_Array[2]}</span>
                            </li>
                            <li>
                            <span>5. Bestellvariante:</span>
                            <span>${pro_plan}<label>€ ${basic_plan_price} Pro Portion (Netto, exkl. MwSt.)</label></span>
                            </li>
                            <li>
                            ${order_overview_addon_price}                       
                            </li>
                            <li>
                            <span>Express Kühlversand:</span>
                            <span><span class="chinuki-asf"><span>€ </span><span class="order-overview-shipping-rate"></span></span><label>Versandpreis pro Lieferung</label></span>
                            
                            </li>
                            <li>
                            <span>Nettosumme*</span>
                            <span class="overview_subtotal_price">€ <span class="overview_subtotal_price_inner">150,05</span></span>
                            </li>
                            <li>
                            <span>7% MwSt.</span>
                            <span class="discounted_price">+ € <span class="discounted_price_inner">10,50</span></span>
                            </li>
                            <li>
                            <span>Bruttosumme</span>
                            <span class="overveiw_total_price">€ <span class="overview_total_price_inner">160,55</span></span>
                            </li>
                        </ul>
                        </div>
                    </div>
                    <a href="javascript:void(0)" class="btn border-link open-subscription-change-popup">Präferenz ändern</a>
                </div>`

                open_subscription_change_popup = `
                <div id="change-product-datail-modal" class="modal fade modal--product-detail need-to-make-product-change" data-backdrop="static"  tabindex="-1" role="dialog">
                    <div class="change-preference-popup-overlay"></div>
                    <div class="modal-dialog modal-dialog-centered modal-dialog--product-detail">
                        <div class="modal-content modal-content--product-detail">
                        <div class="modal-header modal-header--product-detail">
                            <button type="button" class="close close-update-popup" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><img class="img lazyload" data-src="https://cdn.shopify.com/s/files/1/0568/0381/9709/files/icon-close_0633ab65-1091-4207-a853-7dfdea49467a.svg?v=1668057388" alt="Icon close" /></span></button>
                        </div>
                        <div class="modal-body modal-body--product-detail">
                            <div class="product-detail">
                            <div class="pure-g current-product-details">
                                    <div  class="form form--config">
                                            <div class="config-box" data-equalizer-row="jsConfig" data-equalizer-on="medium,xlarge">
                                            <div class="delivery-product-details">
                                                <div>
                                                <img src="${product_json_date[0].featured_image
                    }">
                                                </div>
                                                <b>${product_json_date[0].title
                    }</b>
                                            </div>
                                            ${change_subscription_kid_selector}
                                                 <div class="config-box__item config-box-change-meals" data-equalizer="">
                                                    <div class="config-box__head text-center">
                                                        <h4 class="config-box__title">${getSetting('second_step_heading')}</h4>
                                                    </div>
                                                    <div class="form__row pure-g">
                                                        <div class="pure-u-1 pure-u-md-1">
                                                            <div class="form__select-wrapper" id="js-change-meal-toggle">
                                                                <div class="form__select-inner">
                                                                    <div class="form__select-title">
                                                                        <span class="form__select-val" id="js-change-meal-selected-text"></span>
                                                                        <span>Tage</span>
                                                                        <input type="text" class="form__select-input hidden" value="" id="js-change-meals-selected" readonly />
                                                                    </div>
                                                                    <div class="form__select-dropdown">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="21.412" height="13.743" viewBox="0 0 21.412 13.743">
                                                                            <use href="#icon-arrow-2"></use>
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                                <div class="form__select-list__wrapper" id="js-change-meals-select">
                                                                
                                                                </div>
                                                            </div>                                        
                                                        </div>
                                                    </div>
                                                    ${getSetting('second_step_info_popup_text') ? `
                                                    <div class="config-box__info js-config-meals-info">
                                                        <span>?</span>
                                                    </div>` : ''}
                                                </div> 
                                                <div class="config-box__item config-box-change-preference" data-equalizer="">
                                                    <div class="config-box__head text-center">
                                                        <h4 class="config-box__title">${getSetting('third_step_heading')}</h4>
                                                    </div>
                                                    <div class="form__row pure-g"> 
                                                    </div>
                                                    ${getSetting('third_step_info_popup_text') ? `
                                                    <div class="config-box__info js-config-preference-info">
                                                        <span>?</span>
                                                    </div>` : ''}
                                                </div>
                                                <div class="config-box__item config-box-change-additional-preference" data-equalizer="">
                                                    <div class="config-box__head text-center">
                                                        <h4 class="config-box__title">${getSetting('fourth_step_heading')}</h4>
                                                    </div>
                                                    <div class="form__row pure-g"> 
                                                    </div>
                                                    ${getSetting('fourth_step_info_popup_text') ? `
                                                    <div class="config-box__info js-config-add-preference-info">
                                                        <span>?</span>
                                                    </div>` : ''}
                                                </div>
                    
                                                    ${csp_device_data}
                                                
                                                <select id="csp-product-variant-list" style="display: none;"></select>
                                                <span class="csp-shipping-price" style="display: none;"></span>
 
                                                <div class="config-box__price-wrapper">
                                                    <span class="config-box__price-text">${getSetting('your_box_price_text')}</span>
                                                    <span class="config-box__price-symbol">€ </span>
                                                    <span class="config-box__price-popup"></span>
                                                </div>
 
                                                <div class="price-addtional-info">${getSetting('price_info')}</div>
                                                <div class="update-subscription-product">
                                                    <button type="submit" class="btn btn--primary update-sub-products">Bestätigen</div>
                                                </div>
                                                <div class="subscription_confirmation" style="display: none;">
                                                    Sind Sie sicher, dass Sie dieses Abonnementprodukt ändern möchten?
                                                <div class="subscription-confimation-buttons">
                                                    <button class="button_confirm_subscription btn btn btn--primary" data-dismiss="modal" aria-label="Close" >Ja</button>
                                                    <button onclick="cancel_update_product()" class="btn btn btn--primary" data-dismiss="modal" aria-label="Close" >Nein</button>
                                                </div>
                                                </div>
                                            </div>
                                        </div>                  
                            </div>
                            </div>
                        </div>
                        </div>      
                    </div>
                </div>`

                // code for show billing address code start here


                let bill_address1 = "";
                let bill_address2 = "";
                let bill_phone = "";
                let bill_city = "";
                let bill_zip_code = "";
                let bill_country = "";
                let addresstext = "";

                if (active_subscription.billing_address_details.length > 0) {
                    addresstext = "Ändern"
                    if (active_subscription.billing_address_details[0].bill_address1 == "" || active_subscription.billing_address_details[0].bill_address1 == "NULL" || active_subscription.billing_address_details[0].bill_address1 == "null" || active_subscription.billing_address_details[0].bill_address1 == null) {
                        bill_address1 = "";
                        bill_address1_value = "";
                    } else {
                        bill_address1 = `${active_subscription.billing_address_details[0].bill_address1}<br>`;
                        bill_address1_value = `${active_subscription.billing_address_details[0].bill_address1}`;
                    }

                    if (active_subscription.billing_address_details[0].bill_address2 == "" || active_subscription.billing_address_details[0].bill_address2 == "NULL" || active_subscription.billing_address_details[0].bill_address2 == "null" || active_subscription.billing_address_details[0].bill_address2 == null) {
                        bill_address2 = "";
                        bill_address2_value = "";
                    } else {
                        bill_address2 = `${active_subscription.billing_address_details[0].bill_address2}<br>`;
                        bill_address2_value = `${active_subscription.billing_address_details[0].bill_address2}`;
                    }

                    if (active_subscription.billing_address_details[0].bill_phone == "" || active_subscription.billing_address_details[0].bill_phone == "NULL" || active_subscription.billing_address_details[0].bill_phone == "null" || active_subscription.billing_address_details[0].bill_phone == null) {
                        bill_phone = "";
                        bill_phone_value = "";
                    } else {
                        bill_phone = `${active_subscription.billing_address_details[0].bill_phone}<br>`;
                        bill_phone_value = `${active_subscription.billing_address_details[0].bill_phone}`;
                    }

                    if (active_subscription.billing_address_details[0].bill_city == "" || active_subscription.billing_address_details[0].bill_city == "NULL" || active_subscription.billing_address_details[0].bill_city == "null" || active_subscription.billing_address_details[0].bill_city == null) {
                        bill_city = "";
                        bill_city_value = "";
                    } else {
                        bill_city = `${active_subscription.billing_address_details[0].bill_city}<br>`;
                        bill_city_value = `${active_subscription.billing_address_details[0].bill_city}`;
                    }

                    if (active_subscription.billing_address_details[0].bill_zip_code == "" || active_subscription.billing_address_details[0].bill_zip_code == "NULL" || active_subscription.billing_address_details[0].bill_zip_code == "null" || active_subscription.billing_address_details[0].bill_zip_code == null) {
                        bill_zip_code = "";
                        bill_zip_code = "";
                    } else {
                        bill_zip_code = `${active_subscription.billing_address_details[0].bill_zip_code}`;
                    }

                    if (active_subscription.billing_address_details[0].bill_country == "" || active_subscription.billing_address_details[0].bill_country == "NULL" || active_subscription.billing_address_details[0].bill_country == "null" || active_subscription.billing_address_details[0].bill_country == null) {
                        bill_country = "";
                        bill_country = "";
                    } else {
                        bill_country = `${active_subscription.billing_address_details[0].bill_country}<br>`;
                    }



                    var add_billing_address = `
                <h4>Rechnungsadresse</h4>${cus_name}<br>
                <p class="storage-billing-address-dash">${bill_address1}${bill_address2}${bill_zip_code} ${bill_city}${bill_country}${bill_phone}</p>
                <p class="pink-edit-billing-address">${addresstext}</p>
                <div class="edit-billing-address-section" style="display:none">
                    <form class="customer_edit_billing_address_form" action="/account">                   
                    <div class="field">                      
                        <label>Straße und Hausnummer</label>
                        <input type="text" class="edit_billing_address1" name="edit_billing_address1" value="${bill_address1_value}">                                        
                    </div>
                    <div class="field">                      
                        <label>Zusätzliche Adressangaben</label>
                        <input type="text" class="edit_billing_address2" name="edit_billing_address2" value="${bill_address2_value}">                                          
                    </div>
                    <div class="field">                      
                        <label>Telefon</label>
                        <input type="text" class="edit_billing_phone" name="edit_billing_phone" value="${bill_phone_value}">                                          
                    </div>
                    <div class="field">                      
                        <label>Stadt</label>
                        <input type="text" class="edit_billing_city" name="edit_billing_city" value="${bill_city_value}">                                          
                    </div>
                    <div class="field">                      
                        <label>Postleitzahl</label>
                        <input type="number" class="edit_billing_zip" name="edit_billing_zip" value="${bill_zip_code}">                                          
                    </div>
                    <div>
                        <input type="hidden" value="dashview" name="formview" class="formview">
                        <button type="submit" class="submit-edit-billing-address btn btn--primary-light">Adresse aktualisieren</button>
                        <button class="reset-edit-address btn btn--primary-light" type="reset">Abbrechen</button>
                    </div>
                    </form>
                </div>
                `
                    $('.customer_billing_address').html(add_billing_address)

                    var storage_bill_add = `<span>${cus_name}</span><span>${bill_address1}</span><span>${bill_address2}</span><span>${bill_zip_code}</span><span>${bill_city}</span><span>${bill_country}</span><span>${bill_phone}</span>`
                    var bill_address_form = `
                <div class="edit-billing-address-section" style="display:none">
                    <form class="customer_edit_billing_address_form" action="/account">                   
                    <div class="field">                      
                        <label>Straße und Hausnummer</label>
                        <input type="text" class="edit_billing_address1" name="edit_billing_address1" value="${bill_address1_value}">                                        
                    </div>
                    <div class="field">                      
                        <label>Zusätzliche Adressangaben</label>
                        <input type="text" class="edit_billing_address2" name="edit_billing_address2" value="${bill_address2_value}">                                          
                    </div>
                    <div class="field">                      
                        <label>Telefon</label>
                        <input type="text" class="edit_billing_phone" name="edit_billing_phone" value="${bill_phone_value}">                                          
                    </div>
                    <div class="field">                      
                        <label>Stadt</label>
                        <input type="text" class="edit_billing_city" name="edit_billing_city" value="${bill_city_value}">                                          
                    </div>
                    <div class="field">                      
                        <label>Postleitzahl</label>
                        <input type="number" class="edit_billing_zip" name="edit_billing_zip" value="${bill_zip_code}">                                          
                    </div>
                    <div>
                        <input type="hidden" value="orderview" name="formview" class="formview">
                        <button type="submit" class="submit-edit-billing-address btn btn--primary-light">Adresse aktualisieren</button>
                        <button class="reset-edit-address btn btn--primary-light" type="reset">Abbrechen</button>
                    </div>
                    </form>
                </div>`

                    $('.storage-billing-address').html(storage_bill_add)
                    $('.order_overview_billing_address').append(bill_address_form)


                }
                else {
                    addresstext = "Hinzufügen"
                    var add_billing_address = `<h4>Rechnungsadresse</h4><br>
                            <p class="pink-edit-billing-address">${addresstext}</p>
                                        <div class="edit-billing-address-section" style="display:none">
                                    <form class="customer_edit_billing_address_form" action="/account">                   
                                        <div class="field">                      
                                        <label>Straße und Hausnummer</label>
                                        <input type="text" class="edit_billing_address1" name="edit_billing_address1" value="">                                        
                                        </div>
                                        <div class="field">                      
                                        <label>Zusätzliche Adressangaben</label>
                                        <input type="text" class="edit_billing_address2" name="edit_billing_address2" value="">                                          
                                        </div>
                                        <div class="field">                      
                                        <label>Telefon</label>
                                        <input type="text" class="edit_billing_phone" name="edit_billing_phone" value="">                                          
                                        </div>
                                        <div class="field">                      
                                        <label>Stadt</label>
                                        <input type="text" class="edit_billing_city" name="edit_billing_city" value="">                                          
                                        </div>
                                        <div class="field">                      
                                        <label>Postleitzahl</label>
                                        <input type="number" class="edit_billing_zip" name="edit_billing_zip" value="">                                          
                                        </div>
                                        <div>
                                        <input type="hidden" value="dashview" name="formview" class="formview">
                                        <button type="submit" class="submit-edit-billing-address btn btn--primary-light">Add Address</button>
                                        <button class="reset-edit-address btn btn--primary-light" type="reset">Abbrechen</button>
                                        </div>
                                        </form>
                                    </div>
                            `
                    $('.customer_billing_address').html(add_billing_address)

                    var bill_address_form = ` <div class="edit-billing-address-section" style="display:none">
                                    <form class="customer_edit_billing_address_form" action="/account">                   
                                        <div class="field">                      
                                        <label>Straße und Hausnummer</label>
                                        <input type="text" class="edit_billing_address1" name="edit_billing_address1" value="">                                        
                                        </div>
                                        <div class="field">                      
                                        <label>Zusätzliche Adressangaben</label>
                                        <input type="text" class="edit_billing_address2" name="edit_billing_address2" value="">                                          
                                        </div>
                                        <div class="field">                      
                                        <label>Telefon</label>
                                        <input type="text" class="edit_billing_phone" name="edit_billing_phone" value="">                                          
                                        </div>
                                        <div class="field">                      
                                        <label>Stadt</label>
                                        <input type="text" class="edit_billing_city" name="edit_billing_city" value="">                                          
                                        </div>
                                        <div class="field">                      
                                        <label>Postleitzahl</label>
                                        <input type="number" class="edit_billing_zip" name="edit_billing_zip" value="">                                          
                                        </div>
                                        <div>
                                        <input type="hidden" value="orderview" name="formview" class="formview">
                                        <button type="submit" class="submit-edit-billing-address btn btn--primary-light">Add Address</button>
                                        <button class="reset-edit-address btn btn--primary-light" type="reset">Abbrechen</button>
                                        </div>
                                        </form>
                                    </div>`

                    $('.order_overview_billing_address .pink-edit-billing-address').html('Add a new address')
                    $('.order_overview_billing_address').append(bill_address_form)

                }


                // code for show billing address code end here

                // code for add billing email address code start here

                if (billingemail == null) {
                    var add_billing_email = `<h4>Rechnungs E-Mail</h4>
                    <p class="pink-edit-billing-email">E-Mail Adresse hinzufügen</p>
                            <div class="edit-billing-email-section" style="display:none">
                            <form class="customer_edit_billing_email_form" action="/account">                   
                            <div class="field">                      
                            <label>E-mail</label>
                                <input type="hidden" class="customer_email_billing" name="customer_email_billing" value="${dm}">  
                                <input type="text" class="edit_email_billing" name="edit_email_billing" value="">                                        
                            </div>
                            <div>
                                <button type="submit" class="submit-edit-billing-email btn btn--primary-light">E-Mail aktualisieren</button>
                                <button class="reset-edit-email btn btn--primary-light" type="reset">Abbrechen</button>
                            </div>
                            </form>
                            </div>
                    `
                    $('.customer_billing_email').html(add_billing_email)
                } else {

                    var add_billing_email = `<h4>Rechnungs E-Mail</h4>
                        <p class="storage-email-address">${billingemail}</p>
                        <p class="pink-edit-billing-email">E-Mail Adresse aktualisieren</p>
                        <div class="edit-billing-email-section" style="display:none">
                        <form class="customer_edit_billing_email_form" action="/account">                   
                        <div class="field">                      
                        <label>E-mail</label>
                            <input type="hidden" class="customer_email_billing" name="customer_email_billing" value="${dm}">   
                            <input type="text" class="edit_email_billing" name="edit_email_billing" value="${billingemail}">                                        
                        </div>                    
                        <div>
                            <button type="submit" class="submit-edit-billing-email btn btn--primary-light">E-Mail aktualisieren</button>
                            <button class="reset-edit-email btn btn--primary-light" type="reset">Abbrechen</button>
                        </div>
                        </form>
                        </div>`
                    $('.customer_billing_email').html(add_billing_email)

                    // $('.order_overview_billing_address .pink-edit-billing-email').html('Add a new address')
                    //$('.customer_billing_email').append(bill_email_form)
                }

                // code for add billing email address code end here

                // show renewal date code start here

                if (active_subscription.plan == "ABO" || active_subscription.plan == "Abo" || active_subscription.plan == "abo") {
                    if ($(value.subscription_renewal_date.length)) {
                        var get_plan_renewal_date = $(value.subscription_renewal_date).get(-1).subscription_renewal_date;
                        var renewal_date = new Date(get_plan_renewal_date);

                        var check_current_date = new Date(); //yyyy-mm-dd  

                        // console.log(renewal_date)
                        // console.log(check_current_date)
                        if (renewal_date > check_current_date) {
                            var renewal_dd = renewal_date.getDate();
                            var renewal_mm = renewal_date.getMonth() + 1;
                            var renewal_yy = renewal_date.getFullYear();
                            if (renewal_dd < 10) {
                                renewal_dd = '0' + renewal_dd;
                            }
                            if (renewal_mm < 10) {
                                renewal_mm = '0' + renewal_mm;
                            }
                            var renewal_date_formated = renewal_dd + '.' + renewal_mm + "." + renewal_yy;
                            // console.log(renewal_date_formated)
                            setTimeout(function () {
                                $('.subscription-renew-date').html('Erneuerungsdatum des Abos : ' + renewal_date_formated);
                                $('.subscription-renew-date').show();
                            }, 1000);
                        }
                    }
                }

                // show renewal date code end here

            }, 2000)
        })

        setTimeout(function () {
            get_details();
        }, 3000)
    }
})


function get_details() {
    $('.your-subscription-details #subscription-data-inner-part').html(your_subscription_data);
    $('.tab-content-wrapper__list.order-overview-wrapper .container').append(order_overview_wrapper)
    $('.chinuki-site-subscription-page').append(open_subscription_change_popup)

    $('.past-pause-subscription-details .accordion__inner').html(your_past_pause_subscription_data)

    if ($('.accordion__inner .data-delivery-data-list').length > 10) {
        $('.past-pause-subscription-details .accordion__inner').append('<div class="load_more_past_pause_dates text-center"><div class="btn btn--primary">Mehr anzeigen</div></div>');
    }
    $(function () {
        $(".past-pause-subscription-details .data-delivery-data-list ").slice(0, 10).show();
        $(".load_more_past_pause_dates").on('click', function (e) {
            e.preventDefault();
            $(".past-pause-subscription-details .data-delivery-data-list:hidden").slice(0, 10).show();
            if ($(".past-pause-subscription-details .data-delivery-data-list:hidden").length == 0) {
                $(".load_more_past_pause_dates").remove();
            } else {
                $('html,body').animate({
                    scrollTop: $(this).offset().top
                }, 1500);
            }
        });
    });

    if (document.querySelector('#js-faq-accordion-past-pause-subscription')) {
        var faqAccordion = new Accordion({
            element: "#js-faq-accordion-past-pause-subscription",
        });
    }

    $('.subscription-plan-details #created_subscription_list').html(create_subscription_list)
    $('.se-pre-con').hide();

    $.ajax({
        url: window.ChinukiConfig.apiBaseUrl + "/shopify_orders_count/?shopify_customer_id=" + cus_id + "",
        type: 'GET',
        dataType: 'json',
        success: function (res01) {
            let order_counter = 0;
            //console.log(res01);
            $(res01.orders).each(function (key, value) {
                //console.log(value.fulfillment_status);
                if (value.fulfillment_status == "fulfilled") {
                    order_counter = order_counter + 1;
                }
            })
            // console.log(order_counter);           
            if (order_counter > 0) {
                $('.order_counter_list').html('Gelieferte Sendungen: ' + order_counter);
                $('.order_counter_list_second').html('Gelieferte Sendungen: ' + order_counter);
            }

        }
    })
}

$(document).on('click', '.order_status_change', function (e) {
    var checkbox = $(this);

    if (typeof hasAnyUnsavedMealSelections === "function" && hasAnyUnsavedMealSelections()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const dirtyInfo = typeof getActiveDirtyWeekInfo === "function" ? getActiveDirtyWeekInfo() : null;
        const weekText = dirtyInfo && dirtyInfo.label ? ` für ${dirtyInfo.label}` : "";
        const msg = `Bitte speichern oder verwerfen Sie zuerst Ihre ausstehenden Gerichtsauswahlen${weekText}, bevor Sie den Status ändern.`;
        if (typeof triggerStickyBarAttention === "function") {
            triggerStickyBarAttention(msg);
        }
        return false;
    }

    var status = checkbox.attr("data-status");
    var deliveryDate = checkbox.next().attr('subscription-date-attr');

    // check only for pause
    if (status === "shopify_pause") {
        e.preventDefault();
        $.ajax({
            url: window.ChinukiConfig.apiBaseUrl + "/check/parent/pause/data",
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify({
                email: dm,
                delivery_date: deliveryDate,
                pause_data_show: true
            }),
            success: function (res) {
                let message = res[0].subscription_update_details.message;
                let showPopup = res[0].subscription_update_details.show_popup;

                if (showPopup) {
                    showConfirmPopup(message, function (userChoice) {
                        if (userChoice) {
                            checkbox.prop("checked", !checkbox.prop("checked"));
                            // run existing logic (reloads on API success inside runOrderStatusChange)
                            runOrderStatusChange(checkbox);
                        }
                    });
                } else {
                    console.log('No need to show popup, directly running the logic');
                    // run existing logic (reloads on API success inside runOrderStatusChange)
                    checkbox.prop("checked", !checkbox.prop("checked"));
                    runOrderStatusChange(checkbox);
                }
            }
        });
    }
    else {
        // run existing flow directly (reloads on API success inside runOrderStatusChange)
        runOrderStatusChange(checkbox);
    }
});

function runOrderStatusChange(element) {
    var hrs = element;
    var checked_box = element.parents('.toggleSwitch__wrapper').find('.order_status_change');
    var get_date_to_pause = element.next().attr('subscription-date-attr');
    var get_sub_id = element.next().attr('subscription-id-attr');
    //  console.log($(checked_box).length)     
    if (element.prop("checked")) {
        $(hrs).parents('.toggleSwitch__wrapper').removeClass('shopify_pause_wrapper');
        $(hrs).parents('.toggleSwitch__wrapper').addClass('shopify_resume_wrapper');
        // console.log('resume');
        // console.log('checkbox is checked')

        let daycare_update_details_retrieve = {};
        daycare_update_details_retrieve['email'] = dm;
        daycare_update_details_retrieve['delivery_date'] = get_date_to_pause;
        daycare_update_details_retrieve['status'] = "resume";

        if ($("#created_subscription_list").hasClass("daycare-customer")) {
            var daycare_update_data_url = window.ChinukiConfig.apiBaseUrl + "/shopify_daycare_subscription_status_update/";
            var daycare_get_post = "POST";
            var daycare_data_body = JSON.stringify(daycare_update_details_retrieve);
        }
        else {
            var daycare_update_data_url = window.ChinukiConfig.apiBaseUrl + "/shopify_subscription_status_update/?email=" + encodeURIComponent(dm) + "&date=" + get_date_to_pause + "&subscription_id=" + get_sub_id + "&status=resume";
            var daycare_get_post = "GET";
            var daycare_data_body = "";
        }

        $.ajax({
            url: daycare_update_data_url,
            type: daycare_get_post,
            dataType: 'json',
            data: daycare_data_body,
            success: function (res1) {
                // console.log(res1)
                get_pause_count_onload = res1[0].subscription_update_details.pause_count
                // console.log('all pause count on resume = '+get_pause_count_onload)
                if (res1[0].subscription_update_details.plan == "ABO" || res1[0].subscription_update_details.plan == "Abo" || res1[0].subscription_update_details.plan == "abo") {
                    $('.simpleToast').html('Es sind ' + res1[0].subscription_update_details.pause_count + ' von 12 Pausierungen noch verfügbar')
                    $(".simpleToast").css("background", "#88af80");
                    if (res1[0].subscription_update_details.pause_count == 0 && active_subscription.is_limited_pause == true) {
                        $('.data-delivery-data-list').each(function () {
                            var demp = this;
                            if ($(demp).find('.toggleSwitch__wrapper').hasClass('shopify_resume_wrapper')) {
                                $(demp).addClass('make_disalbe_state_change_abo');
                            }
                        })
                        // console.log('count is 0');
                    }

                    if (res1[0].subscription_update_details.pause_count > 0) {
                        $('.data-delivery-data-list').each(function () {
                            var demp = this;
                            if ($(demp).find('.toggleSwitch__wrapper').hasClass('shopify_resume_wrapper')) {
                                $(demp).removeClass('make_disalbe_state_change_abo');
                            }
                        })
                        // console.log('count is 0');
                    }
                    if (active_subscription.is_limited_pause == true) {
                        if (res1[0].subscription_update_details.pause_count == 0 && res1[0].subscription_update_details.status == false) {
                            $('.simpleToast').html(res1[0].subscription_update_details.message)
                            $(".simpleToast").css("background", "#e19f8f");
                            $('.simpleToast').addClass("active");
                            setTimeout(() => {
                                $('.simpleToast ').removeClass("active");
                            }, 5000)
                        }
                        $('.simpleToast').addClass("active");
                        setTimeout(() => {
                            $('.simpleToast ').removeClass("active");
                        }, 5000)
                    }

                }
                if (res1[0].subscription_update_details.subscription_id == null && res1[0].subscription_update_details.status == false) {
                    $('.simpleToast').html(res1[0].subscription_update_details.message)
                    $(".simpleToast").css("background", "#e19f8f");
                    $('.simpleToast').addClass("active");
                    setTimeout(() => {
                        $('.simpleToast ').removeClass("active");
                    }, 5000)
                }
                $(hrs).parents('.data-delivery-data-list').removeClass('paused-delivery-status')

                // On successful resume, persist active tab and reload
                if (!res1 || !res1[0] || !res1[0].subscription_update_details || res1[0].subscription_update_details.status !== false) {
                    try {
                        if (window.history && window.history.replaceState) {
                            window.history.replaceState(window.history.state, '', '#tab-content-list-5');
                        }
                    } catch (e) {}
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            }
        })
    }
    else {
        // console.log('pause');
        $(hrs).parents('.toggleSwitch__wrapper').addClass('shopify_pause_wrapper');
        $(hrs).parents('.toggleSwitch__wrapper').removeClass('shopify_resume_wrapper');
        // console.log('checkbox not checked')

        let daycare_update_details_retrieve = {};
        daycare_update_details_retrieve['email'] = dm;
        daycare_update_details_retrieve['delivery_date'] = get_date_to_pause;
        daycare_update_details_retrieve['status'] = "pause";

        if ($("#created_subscription_list").hasClass("daycare-customer")) {
            var daycare_update_data_url = window.ChinukiConfig.apiBaseUrl + "/shopify_daycare_subscription_status_update/";
            var daycare_get_post = "POST";
            var daycare_data_body = JSON.stringify(daycare_update_details_retrieve);
        }
        else {
            var daycare_update_data_url = window.ChinukiConfig.apiBaseUrl + "/shopify_subscription_status_update/?email=" + encodeURIComponent(dm) + "&date=" + get_date_to_pause + "&subscription_id=" + get_sub_id + "&status=pause";
            var daycare_get_post = "GET";
            var daycare_data_body = "";
        }

        $.ajax({
            url: daycare_update_data_url,
            type: daycare_get_post,
            dataType: 'json',
            data: daycare_data_body,
            success: function (res1) {
                // console.log(res1)  
                get_pause_count_onload = res1[0].subscription_update_details.pause_count
                // console.log('all pause count on pause = '+get_pause_count_onload)
                if (res1[0].subscription_update_details.plan == "ABO" || res1[0].subscription_update_details.plan == "Abo" || res1[0].subscription_update_details.plan == "abo") {
                    $('.simpleToast').html('Es sind ' + res1[0].subscription_update_details.pause_count + ' von 12 Pausierungen noch verfügbar')
                    $(".simpleToast").css("background", "#88af80");
                    if (res1[0].subscription_update_details.pause_count == 0 && active_subscription.is_limited_pause == true) {
                        $('.data-delivery-data-list').each(function () {
                            var demp = this;
                            if ($(demp).find('.toggleSwitch__wrapper').hasClass('shopify_resume_wrapper')) {
                                $(demp).addClass('make_disalbe_state_change_abo');
                            }
                        })
                        // console.log('count is 0');
                    }

                    if (active_subscription.is_limited_pause == true) {
                        if (res1[0].subscription_update_details.pause_count == 0 && res1[0].subscription_update_details.status == false) {
                            $('.simpleToast').html(res1[0].subscription_update_details.message)
                            $(".simpleToast").css("background", "#e19f8f");
                            $('.simpleToast').addClass("active");
                            setTimeout(() => {
                                $('.simpleToast ').removeClass("active");
                            }, 5000)
                        }
                        $('.simpleToast').addClass("active");
                        setTimeout(() => {
                            $('.simpleToast ').removeClass("active");
                        }, 5000)
                    }

                }
                if (res1[0].subscription_update_details.subscription_id == null && res1[0].subscription_update_details.status == false) {
                    $('.simpleToast').html(res1[0].subscription_update_details.message)
                    $(".simpleToast").css("background", "#e19f8f");
                    $('.simpleToast').addClass("active");
                    setTimeout(() => {
                        $('.simpleToast ').removeClass("active");
                    }, 5000)
                }
                $(hrs).parents('.data-delivery-data-list').addClass('paused-delivery-status')

                // On successful pause, persist active tab and reload
                if (!res1 || !res1[0] || !res1[0].subscription_update_details || res1[0].subscription_update_details.status !== false) {
                    try {
                        if (window.history && window.history.replaceState) {
                            window.history.replaceState(window.history.state, '', '#tab-content-list-5');
                        }
                    } catch (e) {}
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            }
        })
    }
}

function showConfirmPopup(message, callback) {
    let popup = `
<div class="confirm-popup">
    <div class="popup-box">
        <p>${message}</p>
        <button class="popup-yes">Yes</button>
        <button class="popup-no">No</button>
    </div>
</div>`;

    $("body").append(popup);

    $(".popup-yes").click(function () {
        $(".confirm-popup").remove();
        callback(true);
    });

    $(".popup-no").click(function () {
        $(".confirm-popup").remove();
        callback(false);
    });
}


$(document).on('click', '.enable-cancel', function (t) {
    t.preventDefault();
    var get_sub_id = $(this).attr('subscription-id-attr');

    var hrs = $(this);
    $('.cancel_subscription_overlay').show();
    $('.subscription_remove_confirmation').show();
    $('.button_confirm').off('click').on('click', async function () {
        // $('.se-pre-con').show();

        if ($('#cancel_subscription_reason').val().length === 0) {
            $('.warning-msg-show-for-cancel').show();
        } else {
            var cancel_reason = $('#cancel_subscription_reason').val();
            let customerData = {};
            const tagsList = typeof window.customer_tags !== "undefined" ? window.customer_tags : (typeof cus_tags !== "undefined" ? cus_tags : "");
            const hasTag = (tag) => {
                if (Array.isArray(tagsList)) {
                    return tagsList.some(t => t.trim().toLowerCase() === tag.toLowerCase());
                }
                if (typeof tagsList === "string") {
                    return tagsList.split(",").map(t => t.trim().toLowerCase()).includes(tag.toLowerCase());
                }
                return false;
            };

            var isDaycareWithParent = (hasTag("Subscriber") && hasTag("daycare")) ||
                hasTag("daycare_with_parent") ||
                $("#created_subscription_list").hasClass("daycare-customer");

            let authHeaders = {};

            if (isDaycareWithParent) {
                customerData['email'] = dm || window.customer_email || '';
                customerData['account_type'] = "daycare_with_parent";
                customerData['reason'] = cancel_reason;

                if (typeof window.getValidShopifyAuthHeaders === "function") {
                    authHeaders = await window.getValidShopifyAuthHeaders(900);
                } else if (typeof window.refreshShopifyAuthHeaders === "function") {
                    authHeaders = await window.refreshShopifyAuthHeaders();
                } else if (window.ShopifyAuthHeaders) {
                    authHeaders = window.ShopifyAuthHeaders;
                }
            } else {
                customerData['name'] = cus_name || window.customer_name || '';
                customerData['email'] = dm || window.customer_email || '';
                customerData['customerid'] = cus_id || window.customer_id || '';
                customerData['subscription_id'] = get_sub_id;
                customerData['reason'] = cancel_reason;
            }

            // console.log(customerData);

            const sendCancelRequest = (headersToSend, isRetry = false) => {
                $.ajax({
                    url: window.ChinukiConfig.apiBaseUrl + "/cancel_subscription/",
                    method: "POST",
                    dataType: "JSON",
                    contentType: "application/json; charset=utf-8",
                    headers: headersToSend,
                    data: JSON.stringify(customerData),
                    success: function (data) {
                        if (data && (data.status === false || data.status === "false")) {
                            const msg = (data.message || "");
                            if (!isRetry && isDaycareWithParent && (msg.toLowerCase().includes("hmac") || msg.toLowerCase().includes("signature") || msg.toLowerCase().includes("timestamp"))) {
                                if (typeof window.refreshShopifyAuthHeaders === "function") {
                                    window.refreshShopifyAuthHeaders().then(newHeaders => {
                                        sendCancelRequest(newHeaders, true);
                                    });
                                    return;
                                }
                            }

                            $('.cancel_subscription_overlay').hide();
                            $('.subscription_remove_confirmation').hide();
                            $('.warning-msg-show-for-cancel').hide();
                            $('#cancel_subscription_reason').val('');
                            $('.simpleToast').html(msg || "Fehler beim Kündigen");
                            $(".simpleToast").css("background", "#e19f8f");
                            $('.simpleToast').addClass("active");
                            setTimeout(() => {
                                $('.simpleToast').removeClass("active");
                            }, 5000);
                            return;
                        }

                        setTimeout(function () {
                            $('.cancel_subscription_overlay').hide();
                            $('.subscription_remove_confirmation').hide();
                            $('.warning-msg-show-for-cancel').hide();
                            $('#cancel_subscription_reason').val('');
                            // console.log("Sent successful")
                            // console.log(data)   

                            if (data.status == true || data.status === "true") {
                                $('.enable-cancel').addClass('disable');
                                $('.cancel_subscription_overlay').remove();
                                $('.subscription_remove_confirmation').remove();
                            }

                        }, 1000);
                    },
                    error: async function (xhr, status, error) {
                        let isHMACError = false;
                        if (xhr && xhr.responseText) {
                            try {
                                const parsed = JSON.parse(xhr.responseText);
                                if (parsed && parsed.message && (parsed.message.toLowerCase().includes("hmac") || parsed.message.toLowerCase().includes("signature") || parsed.message.toLowerCase().includes("timestamp"))) {
                                    isHMACError = true;
                                }
                            } catch (e) { }
                        }

                        if (!isRetry && isDaycareWithParent && (xhr.status === 401 || xhr.status === 403 || xhr.status === 400 || isHMACError)) {
                            if (typeof window.refreshShopifyAuthHeaders === "function") {
                                const newHeaders = await window.refreshShopifyAuthHeaders();
                                return sendCancelRequest(newHeaders, true);
                            }
                        }

                        // console.log('error');  
                        $('.cancel_subscription_overlay').hide();
                        $('.subscription_remove_confirmation').hide();
                        $('.warning-msg-show-for-cancel').hide();
                        $('#cancel_subscription_reason').val('');
                        var errorMsg = xhr.responseText || "Fehler beim Kündigen";
                        try {
                            var parsed = JSON.parse(xhr.responseText);
                            if (parsed && parsed.message) errorMsg = parsed.message;
                        } catch (e) { }
                        $('.simpleToast').html(errorMsg);
                        $(".simpleToast").css("background", "#e19f8f");
                        $('.simpleToast').addClass("active");
                        setTimeout(() => {
                            $('.simpleToast').removeClass("active");
                        }, 5000);
                    }
                });
            };
            sendCancelRequest(authHeaders);

        }
    });
})

function cancel_remove() {
    $('.cancel_subscription_overlay').hide();
    $('.subscription_remove_confirmation').hide();
    $('.warning-msg-show-for-cancel').hide();
    $('#cancel_subscription_reason').val('')
}

//subsciption product change code start here 

$(document.body).on('click', '.open-subscription-change-popup, .change-subscription-product', function (e) {
    if (typeof hasAnyUnsavedMealSelections === "function" && hasAnyUnsavedMealSelections()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const dirtyInfo = typeof getActiveDirtyWeekInfo === "function" ? getActiveDirtyWeekInfo() : null;
        const weekText = dirtyInfo && dirtyInfo.label ? ` für ${dirtyInfo.label}` : "";
        const msg = `Bitte speichern oder verwerfen Sie zuerst Ihre ausstehenden Gerichtsauswahlen${weekText}, bevor Sie den Konfigurator öffnen.`;
        if (typeof triggerStickyBarAttention === "function") {
            triggerStickyBarAttention(msg);
        }
        return false;
    }

    jQuery.getJSON('/products/' + change_subscription_product_handle + '.js', function (product) {

        var csp_sidebar_structure_deshes = "";
        var csp_meal_preference = "";
        var csp_meal_add_preference = "";

        let need_to_change_0_variant = "";
        let need_to_change_1_variant = "";
        let need_to_change_2_variant = "";

        setTimeout(() => {
            $('.config-box-change-additional-preference input[type="radio"]:checked + .form__radio-label').click();
            $('.config-box-change-preference input[type="radio"]:checked + .form__radio-label').click();
            let selected_qut = document.querySelector('.selecetd_quentity span');
            let main_price = document.querySelector('.plan-final-bottom-price span h3');
            if (main_price) {
                let priceText = main_price.innerText;   // "€ 128,56"
                let cleanPrice = priceText.replace(/[^\d,]/g, '');
                $('.config-box__price-popup').text(cleanPrice);
            }
            if (selected_qut) {
                let quentityText = selected_qut.innerText;
                let onlyNumber = quentityText.replace(/\D/g, ''); // e.g. "4"

                // Update your text
                $('#js-change-meal-selected-text').text(onlyNumber);

                // All meal options
                let items = $('#js-change-meals-select li');

                // Add active only to the matching one
                items.each(function () {
                    $(this).removeClass('active');
                    let itemValue = $(this).data('meals-value');  // e.g. "4 Tage"

                    // Match: number at beginning
                    if (itemValue && itemValue.startsWith(onlyNumber)) {
                        $(this).addClass('active');
                        $(this).click();
                    }
                });
            }

        }, 10);

        // Disable the "Tage" (days) selector for FLEX plan customers
        if (active_subscription.plan && active_subscription.plan.toUpperCase() !== "ABO") {
            $('.config-box-change-meals').css({
                'opacity': '0.5',
                'pointer-events': 'none'
            });
        } else {
            $('.config-box-change-meals').css({
                'opacity': '1',
                'pointer-events': 'auto'
            });
        }

        $('#js-change-portion-select li').each(function () {
            var curr_selected_radion_portion = $(this).text();
            if (change_subscription_current_product_quantity == curr_selected_radion_portion) {
                $(this).addClass('active').siblings().removeClass('active');
                $('#js-change-portion-selected-text').html($("#js-change-portion-select li.active").text());
            }
        })

        //  ------------ code for weekly dished get  -------------
        $(product.options[0]).each(function (key, value) {
            // 🔧 Reset before appending
            var csp_sidebar_structure_deshes = "";

            $(value.values).each(function (im, em) {
                var get_menu_dishes = em;
                var get_menu_dishes_clear = get_menu_dishes.replace(/\D/g, '');
                var need_to_change_0_variant = change_subscription_current_product_variant[0].replace(/\D/g, '');

                // Fix: define class per iteration
                var active_denim = (im === 0) ? "active" : "";

                csp_sidebar_structure_deshes += '<li data-meals-value="' + get_menu_dishes + '" class="' + active_denim + '">' + get_menu_dishes_clear + '</li>';
            });

            let $html = $(csp_sidebar_structure_deshes);
            // Find the active li
            let activeText = $html.filter('.active').text() || $html.find('.active').text();

            // Update DOM
            $('#js-change-meals-select').html(csp_sidebar_structure_deshes);
            // Update active state
            $('#js-change-meals-select li').each(function (i, li) {
                if ($(li).text() == need_to_change_0_variant) {
                    $(this).addClass('active').siblings().removeClass('active');
                }
            });
            var menu_dishes = $("#js-change-meals-select li.active").text();
            $('#js-change-meal-selected-text').html(activeText);
        });



        //  ------------ code for preference of your dishes get  -------------

        $(product.options[1]).each(function (key1, value1) {
            $(value1.values).each(function (im1, em1) {
                need_to_change_1_variant = change_subscription_current_product_variant[1];
                if (need_to_change_1_variant === undefined) {
                    if (im1 === 0) {
                        var checkec_pref_radio = "checked";
                    }
                } else {
                    if (need_to_change_1_variant == em1) {
                        var checkec_pref_radio = "checked";
                    }
                }

                csp_meal_preference += '<div class="pure-u-1-3 pure-u-md-1-3">\
    <div class="form__radio-wrapper">\
    <input type="radio" class="form__radio" name="change_mealPreference" id="csp_'+ em1 + '" data-preference-value="' + em1 + '" ' + checkec_pref_radio + '>\
    <label for="csp_'+ em1 + '" class="form__radio-label">' + em1 + '</label>\
    </div>\
    </div>';
            })
            $('.config-box-change-preference .form__row').html(csp_meal_preference);
        })



        //  ------------ code for Additional Preference get  -------------

        $(product.options[2]).each(function (key2, value2) {
            $(value2.values).each(function (im2, em2) {
                need_to_change_2_variant = change_subscription_current_product_variant[2];
                let checkec_add_pref_radio = '';
                if (need_to_change_2_variant === undefined) {
                    if (im2 === 0) {
                        checkec_add_pref_radio = "checked";
                    }
                } else {
                    if (need_to_change_2_variant == em2) {
                        checkec_add_pref_radio = "checked";
                    }
                }
                let sanitizedId = em2.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9\-_]/g, '');
                csp_meal_add_preference += '<div class="pure-u-1-2 pure-u-md-1-2">\
        <div class="form__radio-wrapper">\
        <input type="radio" class="form__radio" name="change_addPrefernce" id="csp_'+ sanitizedId + '" data-addi-preference-value="' + em2 + '" ' + checkec_add_pref_radio + '>\
        <label for="csp_'+ sanitizedId + '" class="form__radio-label">' + em2 + '</label>\
        </div>\
        </div>';
            })
            $('.config-box-change-additional-preference .form__row').html(csp_meal_add_preference);
        })

        setTimeout(function () {
            if ($('#csp_Vegan').is(':checked')) {
                $('#csp_Gelegentlich-s').prop('checked', false)
                    .addClass('disable')
                    .prop('disabled', true);
            } else {
                $('#csp_Gelegentlich-s').prop('disabled', false)
                    .removeClass('disable');
            }
        }, 0);
        //  ----------- Product variant selector code --------------

        var csp_variant_structure = [];
        for (let i = 0; i < product.variants.length; i++) {
            var new_pro_title = product.variants[i].title;
            var new_pro_id = product.variants[i].id;
            var new_pro_price = product.variants[i].price;
            var pri_update = parseFloat(new_pro_price / 100);
            csp_variant_structure += '<option data-attr="' + new_pro_title + '" value=' + product.variants[i].id + ' data-option1="' + product.variants[i].option1 + '" data-option2="' + product.variants[i].option2 + '" data-option3="' + product.variants[i].option3 + '" data-price="' + pri_update + '" >' + new_pro_title + '</option>';
            $("#csp-product-variant-list").html(csp_variant_structure);
        }

        if (csp_get_device_price == true) {
            $('#cps_withDevice').prop('checked', true);
            $('#cps_noDevice').prop('checked', false);
        } else {
            $('#cps_withDevice').prop('checked', false);
            $('#cps_noDevice').prop('checked', true);
        }

        setTimeout(function () {
            csp_product_selector();
        }, 500);
    });

    setTimeout(function () {
        new Modal({
            el: document.getElementById('change-product-datail-modal'),
            backdrop: "static"
        }).show();
    }, 1000);
})

$(document.body).on('mouseover', '#js-change-portion-toggle', function () {
    $(this).addClass('is-open')
})
$(document.body).on('mouseout', '#js-change-portion-toggle', function () {
    $(this).removeClass('is-open')
})

$(document.body).on('mouseover', '#js-change-meal-toggle', function () {
    $(this).addClass('is-open')
})
$(document.body).on('mouseout', '#js-change-meal-toggle', function () {
    $(this).removeClass('is-open')
})

$(document).on('click', '#js-change-portion-select li', function () {
    setTimeout(function () {
        $('#js-change-portion-toggle').removeClass("is-open");
    }, 100);
    jQuery(this).addClass('active').siblings().removeClass('active');
    $('#js-change-portion-selected-text').text($('#js-change-portion-select li.active').text());
    change_subscription_current_product_quantity = $('#js-change-portion-selected-text').text();
    $('#js-change-portion-selected').attr('value', $('#js-change-portion-selected-text').text());

    var csp_portion_text = $('#js-change-portion-select li.active').attr('data-quantity');
    if (csp_portion_text >= 1 && csp_portion_text <= 5) {
        $('#js-change-portion-text b').text($('.range_1-5').text());
    }
    if (csp_portion_text >= 6 && csp_portion_text <= 10) {
        $('#js-change-portion-text b').text($('.range_6-10').text());
    }
    if (csp_portion_text >= 11 && csp_portion_text <= 15) {
        $('#js-change-portion-text b').text($('.range_11-15').text());
    }
    if (csp_portion_text >= 16 && csp_portion_text <= 20) {
        $('#js-change-portion-text b').text($('.range_16-20').text());
    }
    if (csp_portion_text >= 21 && csp_portion_text <= 25) {
        $('#js-change-portion-text b').text($('.range_21-25').text());
    }
    if (csp_portion_text >= 26 && csp_portion_text <= 30) {
        $('#js-change-portion-text b').text($('.range_26-30').text());
    }
    if (csp_portion_text > 30) {
        $('#js-change-portion-text b').text($('.range_30plus').text());
    }
    setTimeout(function () {
        csp_product_selector();
    }, 500);
})

$(document).on('click', '#js-change-meals-select li', function () {
    setTimeout(function () {
        $('#js-change-meal-toggle').removeClass("is-open");
    }, 100);

    jQuery(this).addClass('active').siblings().removeClass('active');
    $('#js-change-meal-selected-text').html(this.innerHTML);


    setTimeout(function () {
        csp_product_selector();
    }, 500);
})

$(document).on('change', 'input[name=change_mealPreference]:radio', function () {
    setTimeout(function () {
        csp_product_selector();
    }, 500);
})

$(document).on('change', 'input[name=change_addPrefernce]:radio', function () {
    setTimeout(function () {
        csp_product_selector();
    }, 500);
})

$(document).on('change', 'input[name=change_devices]:radio', function () {
    setTimeout(function () {
        csp_product_selector();
    }, 500);
})


function csp_product_selector() {
    var csp_quantity_range = $('#js-change-portion-select li.active').text();
    let csp_demoats = [];
    let csp_myVar2 = [];

    var csp_menu_dishes_selected = "";
    var csp_menu_prefe_selected = "";
    var csp_menu_addi_prefe_selected = "";
    csp_menu_dishes_selected = $("#js-change-meals-select li.active").attr('data-meals-value');
    csp_menu_prefe_selected = $('input[name="change_mealPreference"]:checked').attr('data-preference-value');
    csp_menu_addi_prefe_selected = $('input[name="change_addPrefernce"]:checked').attr('data-addi-preference-value');
    csp_demoats.push(csp_menu_dishes_selected);
    csp_demoats.push(csp_menu_prefe_selected);
    csp_demoats.push(csp_menu_addi_prefe_selected);
    csp_myVar2 = csp_demoats.join(' / ');
    $("#csp-product-variant-list option").each(function () {
        var csp_d_option = $(this).data('attr');
        if (csp_d_option == csp_myVar2) {
            var csp_demnstar = $(this).attr('value');
            $(this).attr('selected', true).siblings().attr('selected', false);
            $('.update-sub-products').attr('data-pro-id', csp_demnstar);
        }
    })



    let csp_selected_meals_dishes = $('#js-change-meals-select li.active').text();
    var csp_get_abo_device_handle = $('input[name="change_devices"]:checked').attr('data-device-handle-abo');
    var csp_get_flex_device_handle = $('input[name="change_devices"]:checked').attr('data-device-handle-flex');

    if (get_current_subscription_product_plan == "ABO" || get_current_subscription_product_plan == "Abo" || get_current_subscription_product_plan == "abo") {
        if ($('#cps_withDevice').is(':checked')) {
            jQuery.getJSON('/products/' + csp_get_abo_device_handle + '.js', function (data22) {
                if (csp_quantity_range >= 4 && csp_quantity_range <= 10) {
                    $('input[name="change_devices"]:checked').attr('data-pro-id', data22.variants[0].id);
                    $('#cps_withDevice').attr('data-pro-price', Number.parseFloat(data22.variants[0].price / 100).toFixed(2))
                } else if (csp_quantity_range >= 11 && csp_quantity_range <= 20) {
                    $('input[name="change_devices"]:checked').attr('data-pro-id', data22.variants[1].id);
                    $('#cps_withDevice').attr('data-pro-price', Number.parseFloat(data22.variants[1].price / 100).toFixed(2))
                } else if (csp_quantity_range >= 21 && csp_quantity_range <= 51) {
                    $('input[name="change_devices"]:checked').attr('data-pro-id', data22.variants[2].id);
                    $('#cps_withDevice').attr('data-pro-price', Number.parseFloat(data22.variants[2].price / 100).toFixed(2))
                }
            })
        }

        if ((csp_quantity_range >= 4 && csp_quantity_range <= 15) && (csp_selected_meals_dishes == 3)) {
            $('.csp-shipping-price').text(shipping_cost_abo_1)
        }
        else if ((csp_quantity_range >= 16 && csp_quantity_range <= 35) && (csp_selected_meals_dishes == 3)) {
            $('.csp-shipping-price').text(shipping_cost_abo_2)
        }
        else if ((csp_quantity_range >= 36 && csp_quantity_range <= 50) && (csp_selected_meals_dishes == 3)) {
            $('.csp-shipping-price').text(shipping_cost_abo_3)
        }
        else if ((csp_quantity_range >= 4 && csp_quantity_range <= 10) && (csp_selected_meals_dishes == 4)) {
            $('.csp-shipping-price').text(shipping_cost_abo_1)
        }
        else if ((csp_quantity_range >= 11 && csp_quantity_range <= 25) && (csp_selected_meals_dishes == 4)) {
            $('.csp-shipping-price').text(shipping_cost_abo_2)
        }
        else if ((csp_quantity_range >= 26 && csp_quantity_range <= 35) && (csp_selected_meals_dishes == 4)) {
            $('.csp-shipping-price').text(shipping_cost_abo_3)
        }
        else if ((csp_quantity_range >= 36 && csp_quantity_range <= 51) && (csp_selected_meals_dishes == 4)) {
            $('.csp-shipping-price').text(shipping_cost_abo_4)
        }
        else if ((csp_quantity_range >= 4 && csp_quantity_range <= 10) && (csp_selected_meals_dishes == 5)) {
            $('.csp-shipping-price').text(shipping_cost_abo_1)
        }
        else if ((csp_quantity_range >= 11 && csp_quantity_range <= 20) && (csp_selected_meals_dishes == 5)) {
            $('.csp-shipping-price').text(shipping_cost_abo_2)
        }
        else if ((csp_quantity_range >= 21 && csp_quantity_range <= 30) && (csp_selected_meals_dishes == 5)) {
            $('.csp-shipping-price').text(shipping_cost_abo_3)
        }
        else if ((csp_quantity_range >= 31 && csp_quantity_range <= 40) && (csp_selected_meals_dishes == 5)) {
            $('.csp-shipping-price').text(shipping_cost_abo_4)
        }
        else if ((csp_quantity_range >= 41 && csp_quantity_range <= 51) && (csp_selected_meals_dishes == 5)) {
            $('.csp-shipping-price').text(shipping_cost_abo_5)
        }

    }
    if (get_current_subscription_product_plan == "FLEX" || get_current_subscription_product_plan == "Flex" || get_current_subscription_product_plan == "flex") {

        if ($('#cps_withDevice').is(':checked')) {
            jQuery.getJSON('/products/' + csp_get_flex_device_handle + '.js', function (data22) {
                if (csp_quantity_range >= 4 && csp_quantity_range <= 10) {
                    $('input[name="change_devices"]:checked').attr('data-pro-id', data22.variants[0].id);
                    $('#cps_withDevice').attr('data-pro-price', Number.parseFloat(data22.variants[0].price / 100).toFixed(2))
                } else if (csp_quantity_range >= 11 && csp_quantity_range <= 20) {
                    $('input[name="change_devices"]:checked').attr('data-pro-id', data22.variants[1].id);
                    $('#cps_withDevice').attr('data-pro-price', Number.parseFloat(data22.variants[1].price / 100).toFixed(2))
                } else if (csp_quantity_range >= 21 && csp_quantity_range <= 51) {
                    $('input[name="change_devices"]:checked').attr('data-pro-id', data22.variants[2].id);
                    $('#cps_withDevice').attr('data-pro-price', Number.parseFloat(data22.variants[2].price / 100).toFixed(2))
                }
            })
        }

        if ((csp_quantity_range >= 4 && csp_quantity_range <= 15) && (csp_selected_meals_dishes == 3)) {
            $('.csp-shipping-price').text(shipping_cost_flex_1)
        }
        else if ((csp_quantity_range >= 16 && csp_quantity_range <= 35) && (csp_selected_meals_dishes == 3)) {
            $('.csp-shipping-price').text(shipping_cost_flex_2)
        }
        else if ((csp_quantity_range >= 36 && csp_quantity_range <= 51) && (csp_selected_meals_dishes == 3)) {
            $('.csp-shipping-price').text(shipping_cost_flex_3)
        }
        else if ((csp_quantity_range >= 4 && csp_quantity_range <= 10) && (csp_selected_meals_dishes == 4)) {
            $('.csp-shipping-price').text(shipping_cost_flex_1)
        }
        else if ((csp_quantity_range >= 11 && csp_quantity_range <= 20) && (csp_selected_meals_dishes == 4)) {
            $('.csp-shipping-price').text(shipping_cost_flex_2)
        }
        else if ((csp_quantity_range >= 26 && csp_quantity_range <= 35) && (csp_selected_meals_dishes == 4)) {
            $('.csp-shipping-price').text(shipping_cost_flex_3)
        }
        else if ((csp_quantity_range >= 36 && csp_quantity_range <= 50) && (csp_selected_meals_dishes == 4)) {
            $('.csp-shipping-price').text(shipping_cost_flex_4)
        }
        else if ((csp_quantity_range >= 51 && csp_quantity_range <= 60) && (csp_selected_meals_dishes == 4)) {
            $('.csp-shipping-price').text(shipping_cost_flex_6)
        }
        else if ((csp_quantity_range >= 4 && csp_quantity_range <= 10) && (csp_selected_meals_dishes == 5)) {
            $('.csp-shipping-price').text(shipping_cost_flex_1)
        }
        else if ((csp_quantity_range >= 11 && csp_quantity_range <= 20) && (csp_selected_meals_dishes == 5)) {
            $('.csp-shipping-price').text(shipping_cost_flex_2)
        }
        else if ((csp_quantity_range >= 21 && csp_quantity_range <= 30) && (csp_selected_meals_dishes == 5)) {
            $('.csp-shipping-price').text(shipping_cost_flex_3)
        }
        else if ((csp_quantity_range >= 31 && csp_quantity_range <= 40) && (csp_selected_meals_dishes == 5)) {
            $('.csp-shipping-price').text(shipping_cost_flex_4)
        }
        else if ((csp_quantity_range >= 41 && csp_quantity_range <= 51) && (csp_selected_meals_dishes == 5)) {
            $('.csp-shipping-price').text(shipping_cost_flex_5)
        }

    }

    setTimeout(function () {
        csp_product_price_change()
    }, 300);
}

let csp_quantity_range = "";
let csp_main_product_update_id = ""
let csp_addon_device_id = ""
let csp_addonn_product_price = ""
let csp_multiply_var_price = ""
let csp_main_product_price = ""
let csp_sub_plan_price = ""
let csp_final_step_price = ""

function csp_product_price_change() {
    setTimeout(function () {
        csp_quantity_range = $('#js-change-portion-select li.active').text();
        var csp_sel_pro_pri = $('#csp-product-variant-list :selected').data("price");
        csp_multiply_var_price = (csp_quantity_range * csp_sel_pro_pri);
        csp_main_product_price = Number.parseFloat(csp_multiply_var_price).toFixed(2);
        var csp_shipping_price = $('.csp-shipping-price').text();
        if ($('#cps_withDevice').is(':checked')) {
            csp_sub_plan_price = $('#cps_withDevice').attr('data-pro-price');
        } else {
            csp_sub_plan_price = 00;
        }
        var all_price_sum = parseFloat(csp_multiply_var_price) + parseFloat(csp_shipping_price) + parseFloat(csp_sub_plan_price);
        var csp_step_price = Number.parseFloat(all_price_sum).toFixed(2);
        // console.log(csp_step_price);   
        var sub_page_gettaxprice = Number.parseFloat(csp_step_price * 7 / 100).toFixed(2)
        var f_price = Number.parseFloat(parseFloat(sub_page_gettaxprice) + parseFloat(csp_step_price)).toFixed(2);
        // console.log('price with tex='+ f_price)
        csp_final_step_price = f_price.toString().replace('.', ',');

        csp_addon_device_id = $('#cps_withDevice').attr('data-pro-id');
        csp_main_product_update_id = $('.update-sub-products').attr('data-pro-id');
        $('.config-box__price-popup').html(csp_final_step_price);

    }, 500);
}

$(document).on('click', '.update-sub-products', function () {
    $('#change-product-datail-modal .config-box').hide();
    $('.subscription_confirmation').show();
})
$(document).on('click', '.close-update-popup', function () {
    $("#custom-config-modal").fadeOut();
    $("body").css("overflow", "");
    $('#change-product-datail-modal .config-box').show();
    $('.subscription_confirmation').hide();
})
$(document).on('click', '.button_confirm_subscription', function () {
    var csp_itemData = {
        email: dm,
        subscription_id: csp_subscription_id,
        total_amount: csp_final_step_price,
        variants: []
    };

    if ($("#created_subscription_list").hasClass("daycare-customer")) {
        csp_itemData.variants.push({
            variant_id: csp_main_product_update_id,
            quantity: change_subscription_current_product_quantity,
            type: "plan",
            price: csp_main_product_price
        });
    } else {
        csp_itemData.variants.push({
            variant_id: csp_main_product_update_id,
            quantity: csp_quantity_range,
            type: "plan",
            price: csp_main_product_price
        });
    }

    if ($('#cps_withDevice').is(':checked')) {
        csp_itemData.variants.push({
            variant_id: csp_addon_device_id,
            quantity: 1,
            type: "addon",
            price: csp_sub_plan_price
        });
    }

    // console.log(csp_itemData);  

    if ($("#created_subscription_list").hasClass("daycare-customer")) {
        var update_sub_data_url = window.ChinukiConfig.apiBaseUrl + "/daycare/update/subscription/";
    }
    else {
        var update_sub_data_url = window.ChinukiConfig.apiBaseUrl + "/update_subscription/";
    }

    $.ajax({
        url: update_sub_data_url,
        method: "POST",
        dataType: "JSON",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(csp_itemData),
        success: function (data) {
            if (data.status == false || data.status == "false") {
                $('.simpleToast').html(data.message)
                $(".simpleToast").css("background", "#e19f8f");
                $('.simpleToast').addClass("active");
                setTimeout(() => {
                    $('.simpleToast ').removeClass("active");
                }, 5000)
            } else {
                $('.subscription_confirmation').hide();
                $('#change-product-datail-modal .config-box').show();
                try {
                    const currentActiveTab = $(".user-account-wrapper__left-inner ul li a.active-link").attr('href') || '#tab-content-list-1';
                    if (window.history && window.history.replaceState) {
                        window.history.replaceState(window.history.state, '', currentActiveTab);
                    }
                } catch (e) {}
                window.location.reload();
            }
        },
        error: function (xhr, status, error) {
            // console.log('error');     
            $('.simpleToast').html(xhr.responseText)
            $(".simpleToast").css("background", "#e19f8f");
            $('.simpleToast').addClass("active");
            setTimeout(() => {
                $('.simpleToast ').removeClass("active");
            }, 5000)

        }
    });
})

function cancel_update_product() {
    $('#change-product-datail-modal .config-box').show();
    $('.subscription_confirmation').hide();
}

// subsciption product change end start here  


//  ? click show content in popup code start here 

$(document).ready(function () {
    const modalsConfig = [
        { trigger: '.js-config-kids-info', id: 'js-modal-kids' },
        { trigger: '.js-config-meals-info', id: 'js-modal-meals' },
        { trigger: '.js-config-preference-info', id: 'js-modal-preference' },
        { trigger: '.js-config-add-preference-info', id: 'js-modal-add-preference' },
        { trigger: '.js-config-device-info', id: 'js-modal-device' },
        { trigger: '.js-config-zipcode-info', id: 'js-modal-zipcode' }
    ];

    modalsConfig.forEach(({ trigger, id, condition }) => {
        const modalInstance = new Modal({ el: document.getElementById(id) });

        $(document).on('click', trigger, function () {
            if (!condition || $(condition).hasClass('show')) {
                modalInstance.show();
                $('.modal-dialog').css('margin', '0 auto');
            }
        });

        modalInstance.on('show', () => {
            $('.change-preference-popup-overlay').addClass('is-active');
        });

        modalInstance.on('hide', () => {
            $('.change-preference-popup-overlay').removeClass('is-active');
        });
    });
})

$(document).ready(function () {
    // Optional: Real-time check to disable button when user is typing
    $(".postal-code").on("input", function () {
        let allValid = true;
        let allzip_filled_zero = false;
        $(".postal-code").each(function () {
            // Check if the field is empty or contains non-numeric values
            if ($(this).val() === '' || /[^0-9]/.test($(this).val())) {
                allValid = false;  // Mark as false if empty or contains invalid characters

                // If special characters are detected, alert the user
                if (/[^0-9]/.test($(this).val())) {
                    alert("Please do not add special characters. Only numbers are allowed.");
                    $(this).val(''); // Clear the invalid input
                }
            }

            // Check if zipcode field has all 0 values
            if ($(this).val().replace(/0/g, '') !== '') {
                allzip_filled_zero = true;
            }
        });

        // Disable the button if any postal code is empty or invalid or have all 0 values
        $(".submit-button-br").prop('disabled', !allValid || !allzip_filled_zero);
    });
});

//  ? click show content in popup code end here 

if ($("#created_subscription_list").hasClass("daycare-customer")) {
    //  console.log('daycare customer');
}
else {
    // console.log('subscriber customer');
}

$(document).ready(function () {

    setTimeout(function () {

        $('.pink-edit-address').click(function (e) {
            $('.edit-address-section').show();
            $(this).parents('.accordion__panel').find('.accordion__content').css('height', 'auto');
        })
        $(document).on('click', '.pink-edit-billing-address', function (e) {
            $('.edit-billing-address-section').show();
            $(this).parents('.accordion__panel').find('.accordion__content').css('height', 'auto');
        })
        $(document).on('click', '.edit-address-section .reset-edit-address', function (e) {
            $('.edit-address-section').hide()
            $.each($(".field"), function () {
                $(this).find('label.error').hide()
            });
        });

        $(document).on('click', '.edit-billing-address-section .reset-edit-address', function (e) {
            $('.edit-billing-address-section').hide()
            $.each($(".edit-billing-address-section .field"), function () {
                $(this).find('label.error').hide()
            });
        });

        $(document).on('click', '.pink-edit-billing-email', function (e) {
            $('.customer_billing_email').find('.edit-billing-email-section').show();
            $(this).parents('.accordion__panel').find('.accordion__content').css('height', 'auto');
        })
        $(document).on('click', '.edit-billing-email-section .reset-edit-email', function (e) {
            $(this).parents('.customer_billing_email').find('.edit-billing-email-section').hide()
            $.each($(".edit-billing-email-section .field"), function () {
                $(this).find('label.error').hide()
            });
        });


        $(".customer_edit_address_form").each(function () {
            $(this).validate({
                ignore: ":hidden",
                rules: {
                    edit_address1:
                    {
                        required: true
                    },
                    edit_phone:
                    {
                        required: true
                    },
                    edit_zip:
                    {
                        required: true,
                        maxlength: 5,
                        minlength: 5
                    },
                    edit_city:
                    {
                        required: true
                    }
                },
                messages: {
                    edit_address1:
                    {
                        required: "Bitte gültige Adresse angeben"
                    },
                    edit_phone:
                    {
                        required: "Bitte gültige Telefonnummer"
                    },
                    edit_zip:
                    {
                        required: "Bitte gültige 5-stellige Postleitzahi angeben",
                        maxlength: "Bitte gültige 5-stellige Postleitzahi angeben",
                        minlength: "Bitte gültige 5-stellige Postleitzahi angeben"
                    },
                    edit_city:
                    {
                        required: "Bitte Stadt angeben"
                    }
                }
            })
        })

        $(".customer_edit_billing_address_form").each(function () {
            $(this).validate({
                ignore: ":hidden",
                rules: {
                    edit_billing_address1:
                    {
                        required: true
                    },
                    edit_billing_phone:
                    {
                        required: true
                    },
                    edit_billing_zip:
                    {
                        required: true,
                        maxlength: 5,
                        minlength: 5
                    },
                    edit_billing_city:
                    {
                        required: true
                    }
                },
                messages: {
                    edit_billing_address1:
                    {
                        required: "Bitte gültige Adresse angeben"
                    },
                    edit_billing_phone:
                    {
                        required: "Bitte gültige Telefonnummer"
                    },
                    edit_billing_zip:
                    {
                        required: "Bitte gültige 5-stellige Postleitzahi angeben",
                        maxlength: "Bitte gültige 5-stellige Postleitzahi angeben",
                        minlength: "Bitte gültige 5-stellige Postleitzahi angeben"
                    },
                    edit_billing_city:
                    {
                        required: "Bitte Stadt angeben"
                    }
                }
            })
        })

        $(".customer_edit_billing_email_form")
            .validate({
                ignore: ":hidden",
                rules: {
                    edit_email_billing: {
                        required: true,
                        email: true
                    }
                },
                messages: {
                    edit_email_billing: {
                        required: "Bitte gültige Adresse angeben"
                    }
                }
            })

        $('.submit-edit-address').click(function (e) {
            $(this).prop('disabled', true)

            if ($(this).parents(".customer_edit_address_form").valid()) {
                e.preventDefault();
                if ($("#created_subscription_list").hasClass("daycare-customer")) {
                    var customer_type = "daycare"
                } else {
                    var customer_type = "customer"
                }
                var edit_address1 = $(this).parents(".customer_edit_address_form").find('.edit_address1').val();
                var edit_address2 = $(this).parents(".customer_edit_address_form").find('.edit_address2').val();
                var edit_phone = $(this).parents(".customer_edit_address_form").find('.edit_phone').val();
                var edit_city = $(this).parents(".customer_edit_address_form").find('.edit_city').val();
                var edit_zip = $(this).parents(".customer_edit_address_form").find('.edit_zip').val();
                var form_type = $(this).parents(".customer_edit_address_form").find('.formview').val();

                let editaddress = {};
                editaddress['type'] = customer_type;
                editaddress['email'] = dm;
                editaddress['address1'] = edit_address1;
                editaddress['address2'] = edit_address2;
                editaddress['phone'] = edit_phone;
                editaddress['city'] = edit_city;
                editaddress['zip'] = edit_zip;
                editaddress['viewtype'] = form_type;

                console.log(editaddress)
                $.ajax({
                    url: window.ChinukiConfig.apiBaseUrl + "/update/shipping/",
                    type: 'POST',
                    dataType: 'json',
                    data: JSON.stringify(editaddress),
                    success: function (data) {

                        console.log(data);
                        //location.reload();
                        var shipping = data.new_shipping_address;
                        $('.edit-address-section').css('display', 'none');
                        $('.submit-edit-address').prop('disabled', false);

                        const shipping_address = `<p>${shipping.first_name} ${shipping.last_name}
                                        <br>${shipping.line1}
                                        <br>${shipping.line2}
                                        <br>${shipping.zip} ${shipping.city}
                                        <br>German
                                        <br>${shipping.phone}</p>`;
                        $('.shipping-address-dash').html(shipping_address);

                        const shipping_address2 = `<span>${shipping.first_name} ${shipping.last_name}</span>
                                        <span>${shipping.line1}</span>
                                        <span>${shipping.line2}</span>
                                        <span>${shipping.zip} ${shipping.city}</span>
                                        <span>German</span>
                                        <span>${shipping.phone}</span>`;
                        $('.shipping-address').html(shipping_address2);

                        $('.edit_address1').attr('value', shipping.line1).val(shipping.line1);
                        $('.edit_address2').attr('value', shipping.line2).val(shipping.line2);
                        $('.edit_phone').attr('value', shipping.phone).val(shipping.phone);
                        $('.edit_city').attr('value', shipping.city).val(shipping.city);
                        $('.edit_zip').attr('value', shipping.zip).val(shipping.zip);

                        $('.simpleToast').html('Änderungen wurden gespeichert');
                        $(".simpleToast").css("background", "#e19f8f");
                        $('.simpleToast').addClass("active");
                        setTimeout(() => {
                            $('.simpleToast ').removeClass("active");
                        }, 5000)
                    }
                })
            }
        })

        $(document).on('click', '.submit-edit-billing-address', function (e) {
            $(this).prop('disabled', true)
            // console.log('demo');
            if ($(this).parents(".customer_edit_billing_address_form").valid()) {
                e.preventDefault();
                // console.log('dmeo123')
                if ($("#created_subscription_list").hasClass("daycare-customer")) {
                    var customer_type = "daycare"
                } else {
                    var customer_type = "customer"
                }
                var edit_billing_address1 = $(this).parents(".customer_edit_billing_address_form").find('.edit_billing_address1').val();
                var edit_billing_address2 = $(this).parents(".customer_edit_billing_address_form").find('.edit_billing_address2').val();
                var edit_billing_phone = $(this).parents(".customer_edit_billing_address_form").find('.edit_billing_phone').val();
                var edit_billing_city = $(this).parents(".customer_edit_billing_address_form").find('.edit_billing_city').val();
                var edit_billing_zip = $(this).parents(".customer_edit_billing_address_form").find('.edit_billing_zip').val();
                var form_type = $(this).parents(".customer_edit_address_form").find('.formview').val();

                let editbillingaddress = {};
                editbillingaddress['type'] = customer_type;
                editbillingaddress['email'] = dm;
                editbillingaddress['address1'] = edit_billing_address1;
                editbillingaddress['address2'] = edit_billing_address2;
                editbillingaddress['phone'] = edit_billing_phone;
                editbillingaddress['city'] = edit_billing_city;
                editbillingaddress['zip'] = edit_billing_zip;
                editbillingaddress['viewtype'] = form_type;

                // console.log(editbillingaddress)
                $.ajax({
                    url: window.ChinukiConfig.apiBaseUrl + "/update/billing/",
                    type: 'POST',
                    dataType: 'json',
                    data: JSON.stringify(editbillingaddress),
                    success: function (data) {
                        console.log(data)
                        //location.reload();
                        var billing = data.new_billing_address;
                        $('.edit-billing-address-section').css('display', 'none');
                        $('.submit-edit-billing-address').prop('disabled', false);

                        const billing_address = `<p>${billing.first_name} ${billing.last_name}
                                        <br>${billing.line1}
                                        <br>${billing.line2}
                                        <br>${billing.zip} ${billing.city}
                                        <br>Deutschland
                                        <br>${billing.phone}</p>`;
                        $('.storage-billing-address-dash').html(billing_address);

                        const billing_address2 = `<span>${billing.first_name} ${billing.last_name}</span>
                                        <span>${billing.line1}</span>
                                        <span>${billing.line2}</span>
                                        <span>${billing.zip}</span>
                                        <span>${billing.city}</span>
                                        <span>Deutschland</span>
                                        <span>${billing.phone}</span>`;
                        $('.storage-billing-address').html(billing_address2);

                        $('.edit_billing_address1').attr('value', billing.line1).val(billing.line1);
                        $('.edit_billing_address2').attr('value', billing.line2).val(billing.line2);
                        $('.edit_billing_phone').attr('value', billing.phone).val(billing.phone);
                        $('.edit_billing_city').attr('value', billing.city).val(billing.city);
                        $('.edit_billing_zip').attr('value', billing.zip).val(billing.zip);


                        $('.simpleToast').html('Änderungen wurden gespeichert');
                        $(".simpleToast").css("background", "#e19f8f");
                        $('.simpleToast').addClass("active");
                        setTimeout(() => {
                            $('.simpleToast ').removeClass("active");
                        }, 5000)
                    }
                })
            }
        })

        //submit billing email address
        $(document).on('click', '.submit-edit-billing-email', function (e) {
            $(this).prop('disabled', true)

            if ($(this).parents(".customer_edit_billing_email_form").valid()) {
                e.preventDefault();

                var customer_email_billing = $(this).parents(".customer_edit_billing_email_form").find('.customer_email_billing').val();
                var edit_email_billing = $(this).parents(".customer_edit_billing_email_form").find('.edit_email_billing').val();
                if ($("#created_subscription_list").hasClass("daycare-customer")) {
                    var is_daycare = true
                } else {
                    var is_daycare = false
                }

                let editbillingemail = {};
                editbillingemail['customer_email'] = customer_email_billing;
                editbillingemail['billing_email'] = edit_email_billing;
                editbillingemail['is_daycare'] = is_daycare;

                console.log(editbillingemail)
                $.ajax({
                    url: window.ChinukiConfig.apiBaseUrl + "/billing/email/add/",
                    type: 'POST',
                    dataType: 'json',
                    data: JSON.stringify(editbillingemail),
                    success: function (data) {
                        console.log(data)
                        $('.edit-billing-email-section').css('display', 'none');
                        $('.storage-email-address').html(data.billing_email);
                        $('.edit_email_billing').attr('value', data.billing_email).val(data.billing_email);
                        $('.simpleToast').html('Änderungen wurden gespeichert');
                        $(".simpleToast").css("background", "#e19f8f");
                        $('.simpleToast').addClass("active");
                        setTimeout(() => {
                            $('.simpleToast ').removeClass("active");
                        }, 5000)
                    }
                })
            }
        })

    }, 5000)
})


$(document).on('click', '.daycare-login-btn', function () {
    let customertoken = {};
    customertoken['token'] = $(this).attr('data-token')
    $.ajax({
        url: window.ChinukiConfig.apiBaseUrl + "/check_login/",
        type: 'POST',
        dataType: 'json',
        data: JSON.stringify(customertoken),
        success: function (data) {
            if (data.status == true) {
                window.location.href = data.redirect_url
            }
        }
    })
})

$('.payment-update-button').click(function (e) {
    e.preventDefault();
    let payment_update_data = {};
    if ($("#created_subscription_list").hasClass("daycare-customer")) {
        payment_update_data['is_daycare'] = true
    } else {
        payment_update_data['is_daycare'] = false
    }
    payment_update_data['email'] = dm
    $.ajax({
        url: window.ChinukiConfig.apiBaseUrl + '/daycare/payment_methode/update/',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(payment_update_data),
        success: function (data) {
            if (data.status == true) {
                window.location.href = data.url
            }
        },
        error: function (xhr, status, error) {
            $('.simpleToast').html(xhr.responseText)
            $(".simpleToast").css("background", "#e19f8f");
            $('.simpleToast').addClass("active");
            setTimeout(() => {
                $('.simpleToast ').removeClass("active");
            }, 5000)
        }
    });
})

if ($('.weekly-menus-wrapper').length > 0) {
    $.get("https://www.chinuki.de/pages/wochenmenu").done(function (data) {
        var $data = $(data);
        var menus = $data.find('.plans-solution');
        if (menus.length > 0) {
            $('.weekly-menus-wrapper .container').append(menus);
        }
    })
        .fail(function (jqXHR, textStatus, errorThrown) {
            console.log("error");
        });
}


$('.Rating__star').each(function () {
    var productId = $(this).attr('data-id');
    var customerEmail = '{{customer.email}}';
    var storageKey = 'order__' + productId;
    var $currentRatingStars = $(this).find('.list_review_star'); // Find stars within the current product
    var _this = $(this);

    function highlightStars(rating) {
        $currentRatingStars.each(function (i) {
            if (i + 1 <= rating) {
                $(this).find(".star-icon").attr("fill", "#e19f8f"); // Fill the stars up to the rating value
            } else {
                $(this).find(".star-icon").attr("fill", "none"); // Empty the stars beyond the rating value
            }
        });
    }

    // Function to get rating from API
    function getRatingFromAPI() {
        var params1 = {
            "email": customerEmail,
            "order_id": productId
        };
        $.ajax({
            url: `${window.ChinukiConfig.apiBaseUrl}/order/rating/?email=${encodeURIComponent(customerEmail)}&order_id=${productId}`,
            type: 'GET',
            contentType: 'application/json',
            success: function (data) {
                // console.log(data, "get order data");
                var savedRating = data.order_rating;
                if (savedRating !== null && savedRating > 0) {
                    localStorage.setItem(storageKey, savedRating); // Save to localStorage
                    highlightStars(savedRating); // Highlight stars based on API response
                    $currentRatingStars.addClass('locked'); // Lock the stars
                    _this.removeClass("add_rating");
                } else if (savedRating <= 0 || savedRating == "data not found") {
                    _this.addClass("add_rating");
                }
            },
            error: function (xhr, status, error) {
                console.log('Error fetching rating from API:', error);
            }
        });
    }
    // Initial call to set the rating from API if available
    getRatingFromAPI();
});

function highlightStars(rating, currentRatingStars) {
    currentRatingStars.each(function (i) {
        if (i + 1 <= rating) {
            $(this).find(".star-icon").attr("fill", "#e19f8f");
        } else {
            $(this).find(".star-icon").attr("fill", "none");
        }
    });
}

$('body').on("click", ".submit-review-btn", function () {
    var productId = $('[data-order-id]').val();
    var customerEmail = '{{customer.email}}';
    var storageKey = 'order__' + productId;
    var _this = $(this);
    var reviewMessage = $(this).closest('.review-wrapper').find('[data-message]').val();

    var $currentRatingStars = $(`[data-id="${productId}"]`).find('.review .list_review_star');

    var params1 = {
        "email": customerEmail,
        "order_id": productId,
        "rating": parseInt($('.review_star svg.filled').length | 0),
        "message": reviewMessage
    };

    $.ajax({
        url: `${window.ChinukiConfig.apiBaseUrl}/order/rating/`,
        type: 'POST',
        data: JSON.stringify(params1),
        dataType: 'JSON',
        success: function (data) {
            var savedRating = data.order_rating;
            if (savedRating !== null && savedRating > 0) {
                localStorage.setItem(storageKey, savedRating);
                highlightStars(savedRating, $currentRatingStars);
                $currentRatingStars.addClass('locked');
                _this.closest('.Rating__star').removeClass("add_rating");

                // Close the popup
                closePopup();
            } else if (savedRating <= 0 || savedRating == "data not found") {
                _this.closest('.Rating__star').addClass("add_rating");
            }
        },
        error: function (xhr, status, error) {
            console.log('Error fetching rating from API:', error);
        }
    });

    // Helper function to close the popup
    function closePopup() {
        // Replace this with your popup's actual selector or close method.
        $('.review-box').hide(); // Update '.popup-class-name' to the actual popup class/ID.
    }
});


$(document).on('click', '.list_review_star', function () {
    var customerEmail = '{{customer.email}}';
    let orderId = $(this).closest('.Rating__star').attr('data-id');
    $('.review-box .review_star').each(function (index, em) {
        $(em).find('svg').removeClass('filled');
    });
    $.ajax({
        url: `${window.ChinukiConfig.apiBaseUrl}/order/rating/?email=${encodeURIComponent(customerEmail)}&order_id=${orderId}`,
        type: 'GET',
        contentType: 'application/json',
        success: function (data) {
            var savedRating = data.order_rating;
            var ratingStatus = data.status;
            var ratingChange = data.is_changeable; // Whether the rating can be changed
            var ratingMessage = data.message;

            // Highlight stars based on savedRating
            $('.review-box .review_star').each(function (index, em) {
                if ($(em).data('index') <= savedRating) {
                    $(em).find('svg').addClass('filled');
                }
            });

            // Set order ID and message
            $(`.review-box`).find('[data-order-id]').val(orderId);
            $(`.review-box`).find('[data-message]').val(ratingMessage);

            // Disable stars and message box if ratingChange is false
            if (!ratingChange) {
                $('.review-box .review_star').addClass('disabled'); // Add a class to indicate disabled stars
                $('.review-box [data-message]').attr('disabled', true); // Disable the message input
                $('.submit-review-btn').attr('disabled', true); // Disable the submit button
                $('.submit-review-btn').css('cursor', 'not-allowed');
                $('.submit-review-btn').css('opacity', '0.5');
            } else {
                $('.review-box .review_star').removeClass('disabled'); // Add a class to indicate disabled stars
                $('.review-box [data-message]').attr('disabled', false);
                $('.submit-review-btn').attr('disabled', false); // Enable the submit button
                $('.submit-review-btn').css('cursor', 'pointer'); // Enable pointer events for the submit button
                $('.submit-review-btn').css('opacity', '1');
            }
        },
        error: function (xhr, status, error) {
            console.log('Error fetching rating from API:', error);
        }
    });
});


$('body').on("click", ".add_rating li", function () {
    var productId = $(this).closest('.Rating__star').attr('data-id');
    var customerEmail = '{{customer.email}}';
    var storageKey = 'order__' + productId;
    var $currentRatingStars = $(this).closest('.Rating__star').find('.review_star');
    var _this = $(this);

    function highlightStars(rating) {
        $currentRatingStars.each(function (i) {
            if (i + 1 <= rating) {
                $(this).find(".star-icon").attr("fill", "#e19f8f");
            } else {
                $(this).find(".star-icon").attr("fill", "none");
            }
        });
    }

    var params1 = {
        "email": customerEmail,
        "order_id": productId,
        "rating": parseInt(_this.attr("data-name"))
    };

    $.ajax({
        url: `${window.ChinukiConfig.apiBaseUrl}/order/rating/`,
        type: 'POST',
        data: JSON.stringify(params1),
        dataType: 'JSON',
        success: function (data) {
            var savedRating = data.order_rating;
            if (savedRating !== null && savedRating > 0) {
                localStorage.setItem(storageKey, savedRating);
                highlightStars(savedRating);
                $currentRatingStars.addClass('locked');
                _this.closest('.Rating__star').removeClass("add_rating");
            } else if (savedRating <= 0 || savedRating == "data not found") {
                _this.closest('.Rating__star').addClass("add_rating");
            }
        },
        error: function (xhr, status, error) {
            console.log('Error fetching rating from API:', error);
        }
    });
});

$(document).on('click', '.review_star', function () {
    var selectedIndex = $(this).data('index');
    $('.review_star .star-icon').removeClass('filled');
    $('.review_star').each(function () {
        if ($(this).data('index') <= selectedIndex) {
            $(this).find('.star-icon').addClass('filled');
        }
    });
});

$(".toggle-review-card").on('click', function () {
    $('.review-box').show();
});

$(".hide-review-card").on('click', function () {
    $('.review-box').hide();
});
$(document).mouseup(function (e) {
    if ($(e.target).closest(".review-box").length === 0) {
        $(".review-box").hide()
    }
});

//function to week number based on 1st monday of the year
function getCurrentWeek(date) {
    var d = new Date(date);
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + 4 - (d.getDay() || 7));
    var yearStart = new Date(d.getFullYear(), 0, 1);
    return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
}

$('body').on('change', 'input[name="change_mealPreference"]', function () {
    if ($('#csp_Vegan').is(':checked')) {
        $('#csp_Gelegentlich-s').prop('checked', false).addClass('disable').prop('disabled', true);
        $('#csp_Nur-herzhaft').prop('checked', true);
    } else {
        $('#csp_Gelegentlich-s').prop('disabled', false).removeClass('disable');
    }
});

// Code for meal selection start here

$(document).on("click", ".meal-quantity__increase", function () {
    const $qty = $(this).siblings(".meal-quantity__input");

    let value = parseInt($qty.val(), 10) || 0;

    $qty.val(value + 1);
});

$(document).on("click", ".meal-quantity__decrease", function () {
    const $qty = $(this).siblings(".meal-quantity__input");

    let value = parseInt($qty.val(), 10) || 0;

    if (value > 3) {
        $qty.val(value - 1);
    }
});

$(document).on("click", ".js-dish-selection", function (e) {
    const header = $(this).closest(".js-dish-selection");
    const mealList = header.next(".meal-list");
    const targetDeliveryDate = mealList.attr("data-delivery-date") || mealList.find(".meal-card__button").first().attr("data-delivery-date");

    if (typeof hasAnyUnsavedMealSelections === "function" && hasAnyUnsavedMealSelections()) {
        const dirtyInfo = typeof getActiveDirtyWeekInfo === "function" ? getActiveDirtyWeekInfo() : null;
        if (dirtyInfo && dirtyInfo.deliveryDate && targetDeliveryDate && dirtyInfo.deliveryDate !== targetDeliveryDate) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            const msg = `Bitte speichern oder verwerfen Sie zuerst Ihre Auswahl für ${dirtyInfo.label}, bevor Sie eine andere Woche bearbeiten.`;
            if (typeof triggerStickyBarAttention === "function") {
                triggerStickyBarAttention(msg);
            }
            return false;
        }
    }

    const isOpen = mealList.hasClass("open");

    // 1. CLOSE ALL FIRST
    $(".meal-list").each(function () {
        const $list = $(this);
        if ($list.hasClass("open")) {
            $list.css("max-height", $list.prop("scrollHeight") + "px");
            $list.height(); // Force reflow
            $list.removeClass("open").css("max-height", "0px");
        }
    });

    $(".js-dish-selection svg, .meal-selection__toggle").removeClass("rotate");

    // 2. IF IT WAS CLOSED, OPEN THIS ONE
    if (!isOpen) {
        mealList
            .addClass("open")
            .css("max-height", mealList.prop("scrollHeight") + "px");

        header.find(".meal-selection__toggle, svg").addClass("rotate");

        // Clear max-height after transition to allow content to grow dynamically
        setTimeout(() => {
            if (mealList.hasClass("open")) {
                mealList.css("max-height", "none");
            }
        }, 450);
    }
});

// ==================== B2B Dishes Popup Logic ====================
$(document).on("click", ".meal-card__button", function (e) {
    e.preventDefault();
    const deliveryDate = $(this).attr("data-delivery-date");
    const clickedDay = $(this).attr("data-day");
    if (!deliveryDate || !clickedDay) return;

    if (typeof hasAnyUnsavedMealSelections === "function" && hasAnyUnsavedMealSelections()) {
        const dirtyInfo = typeof getActiveDirtyWeekInfo === "function" ? getActiveDirtyWeekInfo() : null;
        if (dirtyInfo && dirtyInfo.deliveryDate && deliveryDate !== dirtyInfo.deliveryDate) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            const msg = `Bitte speichern oder verwerfen Sie zuerst Ihre Auswahl für ${dirtyInfo.label}, bevor Sie eine andere Woche bearbeiten.`;
            if (typeof triggerStickyBarAttention === "function") {
                triggerStickyBarAttention(msg);
            }
            return false;
        }
    }

    const matchedDelivery = meal_data.deliveries.find(d => d.deliveryDate === deliveryDate);
    if (!matchedDelivery) return;

    const matchedDayData = matchedDelivery.weeklyMeals.find(d => d.day === clickedDay);
    if (!matchedDayData) return;

    // Get the currently selected meal info for this day
    let currentSelectedId = matchedDayData.selectedMealId;
    let currentSelectedDay = matchedDayData.selectedMealDay || matchedDayData.day;

    if (!currentSelectedId && matchedDayData.meals && matchedDayData.meals.length > 0) {
        currentSelectedId = matchedDayData.meals[0].id;
        currentSelectedDay = matchedDayData.day;
    }

    if ($("#b2b-dishes-popup").length === 0) {
        $("body").append(`
        <div id="b2b-dishes-popup" class="b2b-popup-overlay" style="display: none;">
            <div class="b2b-popup-content">
            <button class="b2b-close-popup">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 46.866 47.957">
                <g transform="translate(-1611.694 -741.608)">
                    <g transform="translate(1614.521 744.437)">
                    <line x2="20.077" y2="21.15" fill="none" stroke="#e48e81" stroke-linecap="round" stroke-width="4"></line>
                    <line x1="20.667" y2="21.15" transform="translate(20.543)" fill="none" stroke="#e48e81" stroke-linecap="round" stroke-width="4"></line>
                    </g>
                    <g transform="translate(1614.521 765.587)">
                    <line y1="21.15" x2="20.077" fill="none" stroke="#e48e81" stroke-linecap="round" stroke-width="4"></line>
                    <line x1="20.667" y1="21.15" transform="translate(20.543)" fill="none" stroke="#e48e81" stroke-linecap="round" stroke-width="4"></line>
                    </g>
                </g>
                </svg>
            </button>
            <div class="b2b-popup-header">
                <h2 class="b2b-popup-title">Auswahl der Wochengerichte</h2>
                <p class="b2b-popup-subtitle">Bitte wählen Sie das Gericht für die Lieferwoche aus.</p>
            </div>
            <div class="b2b-popup-dishes-list"></div>
            <div class="b2b-popup-footer">
                <button class="b2b-btn-confirm js-save-b2b-meals">Auswahl bestätigen</button>
            </div>
            </div>
        </div>
        `);
        ensureProductModalExists();
    }

    // Collect ALL dishes from ALL days in this delivery (deduplicated by unique dish key)
    const allDishes = [];
    const seenDishKeys = new Set();
    matchedDelivery.weeklyMeals.forEach((dayData) => {
        dayData.meals.forEach((meal) => {
            const uniqueKey = meal.id ? String(meal.id) : (meal.handle || meal.title);
            if (!seenDishKeys.has(uniqueKey)) {
                seenDishKeys.add(uniqueKey);
                allDishes.push({ ...meal, sourceDay: dayData.day });
            }
        });
    });

    // Add the global Feiertag dish (always last)
    if (meal_data.feiertagDish) {
        allDishes.push({ ...meal_data.feiertagDish, sourceDay: "feiertag" });
    }

    let dishesHTML = `
        <div class="b2b-meals-grid">
    `;

    allDishes.forEach((meal, index) => {

        // Check if this dish is the currently selected one for the clicked day
        const isSelected = (String(meal.id) === String(currentSelectedId));

        const dishColor = meal.dish_color || '#e39f8f';
        const isFeiertag = !!meal.isFeiertag;

        dishesHTML += `
            <div class="b2b-dish-card ${isSelected ? 'selected' : ''} ${isFeiertag ? 'b2b-dish-card--feiertag' : ''}" data-source-day="${meal.sourceDay}" data-meal-id="${meal.id}" data-product-handle="${meal.handle || ''}" data-is-feiertag="${isFeiertag}">
                <div class="b2b-card-inner">
                    <div class="b2b-selected-badge">Auswahl</div>
                    <div class="b2b-product-tags">
                        ${(meal.tags || []).map(tag => `<span class="b2b-tag-circle" style="background-color: ${dishColor};">${tag}</span>`).join('')}
                        ${(!isFeiertag && String(meal.dish_type).toLowerCase() === 'vegan') ? `<span class="b2b-tag-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="34.536" height="31.308" viewBox="0 0 34.536 31.308">
                                <defs>
                                <clipPath id="clip-path">
                                    <rect width="34.536" height="31.308" fill="${dishColor}"></rect>
                                </clipPath>
                                </defs>
                                <g clip-path="url(#clip-path)">
                                <path d="M31.893,8.226C15.491,8.144,6.7,16.154,5.938,32.7a.166.166,0,0,1-.331.02
                                34.667,34.667,0,0,1,.72-14.617c4.358-14.15,20.9-16.02,32.63-11.548a.842.842,0,0,1,.233,1.423
                                c-9.164,7.644-7.919,28.523-30.2,19.476
                                3.463-11.283,10.6-18.3,22.9-19.232" fill="${dishColor}" fill-rule="evenodd"></path>
                                </g>
                            </svg>
                        </span>` : ''}
                    </div>
                    <div class="b2b-product-bg-shape"></div>
                    <div class="b2b-product-image-wrapper">
                        <img src="${meal.image}" alt="${meal.title}" class="b2b-product-image" />
                        ${(!isFeiertag && meal.handle) ? `
                            <button type="button" class="b2b-product-detail-btn" data-product-handle="${meal.handle}" aria-label="Details zu ${meal.title}">
                                <span class="btn-spinner"></span>
                                <span class="btn-text">Details</span>
                            </button>
                        ` : ''}
                        <div class="b2b-product-by">
                            <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/logo-img1.png?v=1767357995" alt="product by" />
                        </div>
                    </div>
                    <div class="b2b-product-info" style="background-color: ${dishColor};">
                        <h4 class="b2b-dish-title">${meal.title}</h4>
                    </div>
                    <div class="b2b-select-wrapper">
                        <div class="b2b-select-text">
                            <span class="b2b-select-badge">
                                <span class="b2b-select-text--unselected">Auswählen</span>
                                <span class="b2b-select-text--selected">Ausgewählt</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        `;
    });

    dishesHTML += `
        </div>
    `;

    $("#b2b-dishes-popup .b2b-popup-dishes-list").html(dishesHTML);
    $("#b2b-dishes-popup .js-save-b2b-meals")
        .data("delivery-date", deliveryDate)
        .data("day", clickedDay);

    ensureGlobalStickyBarExists().addClass("is-suppressed");
    $("#b2b-dishes-popup").css("display", "flex");
    $("#b2b-dishes-popup .b2b-popup-dishes-list").scrollTop(0);
    $("body").css("overflow", "hidden");

    if ($.fn.matchHeight) {
        $('#b2b-dishes-popup .b2b-product-info').matchHeight({ byRow: true });
    }
});

let $currentCard = null;

function ensureProductModalExists() {
    let $modal = $("#productModal");
    if ($modal.length === 0) {
        $("body").append(`
        <div class="modal-overlay" id="productModal" style="display: none;">
            <div class="custom-modal-popup">
                <button class="custom-modal-close" type="button" aria-label="Schließen">
                    <svg xmlns="http://www.w3.org/2000/svg" width="46.866" height="47.957" viewBox="0 0 46.866 47.957">
                    <g id="Group_1226" data-name="Group 1226" transform="translate(-1611.694 -741.608)">
                        <g id="Component_5_7" data-name="Component 5 – 7" transform="translate(1614.521 744.437)">
                        <g id="drop_down" data-name="drop down">
                            <line id="Line_5" data-name="Line 5" x2="20.077" y2="21.15" fill="none" stroke="#e39f8f" stroke-linecap="round" stroke-width="4"/>
                            <line id="Line_6" data-name="Line 6" x1="20.667" y2="21.15" transform="translate(20.543)" fill="none" stroke="#e39f8f" stroke-linecap="round" stroke-width="4"/>
                        </g>
                        </g>
                        <g id="Component_5_8" data-name="Component 5 – 8" transform="translate(1614.521 765.587)">
                        <g id="drop_down-2" data-name="drop down">
                            <line id="Line_5-2" data-name="Line 5" y1="21.15" x2="20.077" fill="none" stroke="#e39f8f" stroke-linecap="round" stroke-width="4"/>
                            <line id="Line_6-2" data-name="Line 6" x1="20.667" y1="21.15" transform="translate(20.543)" fill="none" stroke="#e39f8f" stroke-linecap="round" stroke-width="4"/>
                        </g>
                        </g>
                    </g>
                    </svg>
                </button>
                <div class="custom-modal-content">
                    <div class="model-title">
                        <h3>Auswahl der Wochengerichte</h3>
                    </div>
                    <div class="custom-modal-row"></div>
                    <div class="custom-modal-cta">
                        <button type="button" class="custom-modal-btn button-outline js-modal-back">Zurück</button>
                        <button type="button" class="custom-modal-btn button js-modal-add-to-cart">Auswählen</button>
                    </div>
                </div>
            </div>
        </div>
        `);
        $modal = $("#productModal");
    }
    return $modal;
}

function closeProductModal() {
    const $modal = $("#productModal");
    if ($modal.length && $modal.is(":visible")) {
        $modal.fadeOut(150);
    }
    $currentCard = null;
    if (!$("#b2b-dishes-popup").is(":visible")) {
        $("body").css("overflow", "");
    }
}

async function openProductDetailModal($card) {
    if (!$card || !$card.length) return;

    const isFeiertag = String($card.data('is-feiertag')) === 'true';
    if (isFeiertag) return;

    const productHandle = $card.data('product-handle');
    if (!productHandle || productHandle === 'feiertag') {
        console.warn('Product handle not found for B2B detail modal');
        return;
    }

    const $btn = $card.find('.b2b-product-detail-btn');
    const $imgWrapper = $card.find('.b2b-product-image-wrapper');

    // Prevent duplicate simultaneous requests
    if ($btn.hasClass('is-loading') || $imgWrapper.hasClass('is-loading')) return;

    $btn.addClass('is-loading').prop('disabled', true);
    $imgWrapper.addClass('is-loading');

    try {
        const response = await fetch(`/products/${productHandle}?view=b2c-product-detail`);
        if (!response.ok) {
            throw new Error(`Request failed: ${response.status}`);
        }

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        let detailContainer = doc.querySelector('.custom-modal-row');
        if (!detailContainer) {
            const $temp = $('<div>').html(html);
            const $found = $temp.find('.custom-modal-row');
            if ($found.length) {
                detailContainer = $found[0];
            }
        }

        if (!detailContainer) {
            throw new Error('Detail container .custom-modal-row not found in response');
        }

        $currentCard = $card;
        const $modal = ensureProductModalExists();
        const $modalContent = $modal.find('.custom-modal-row');

        // Update the Auswählen button state inside the modal
        const isSelected = $card.hasClass('selected');
        const $modalAddBtn = $modal.find('.js-modal-add-to-cart');
        if (isSelected) {
            $modalAddBtn.text('Ausgewählt').addClass('selected');
        } else {
            $modalAddBtn.text('Auswählen').removeClass('selected');
        }

        // Populate content while modal is still hidden
        $modalContent.html(detailContainer.innerHTML);
        $modalContent.find('img').each(function () {
            $(this).attr('loading', 'eager');
        });

        // Handle judge.me review badge localization if present
        if ($modal.find('.modal-content-block .jdgm-prev-badge__text').length) {
            let reviewString = $modal.find('.modal-content-block .jdgm-prev-badge__text').text().trim();
            const parts = reviewString.split(' ');
            if (parts.length > 1) {
                if (parts[1].includes('No')) {
                    $modal.find('.modal-content-block .jdgm-prev-badge__text').text('Keine Bewertungen');
                } else {
                    $modal.find('.modal-content-block .jdgm-prev-badge__text').text(parts[1] + ' Bewertungen');
                }
            }
        }

        const reviewButtonUrl = '/products/' + productHandle + '?review-open-form&b2c=true';
        setTimeout(function () {
            $modal.find('.custom-modal-content .jdgm-preview-badge').wrap('<a href="' + reviewButtonUrl + '"></a>');
            $modal.find('.product-detail__valuation').each(function () {
                $(this).html('<a href="' + reviewButtonUrl + '" class="btn btn--quaternary btn--small">Jetzt bewerten</a>');
            });
        }, 200);

        // Analytics tracking in background (non-blocking)
        if (typeof window.chinukiDevTrack === 'function') {
            try {
                fetch(`/products/${productHandle}.js`)
                    .then(r => r.json())
                    .then(productData => {
                        if (!productData) return;
                        const firstVariant = productData.variants && productData.variants[0];
                        const price = firstVariant ? (parseFloat(firstVariant.price) / 100).toFixed(2) : (parseFloat(productData.price) / 100).toFixed(2);
                        window.chinukiDevTrack('dev_view_item', {
                            currency: 'EUR',
                            value: price,
                            items: [{
                                item_id: firstVariant ? firstVariant.id.toString() : productData.id.toString(),
                                item_name: productData.title,
                                price: price,
                                quantity: 1
                            }]
                        });
                    })
                    .catch(() => {});
            } catch (trackErr) {}
        }

        // Open modal ONLY after content is populated and ready
        $modal.css('display', 'flex');
        $('body').css('overflow', 'hidden');

    } catch (error) {
        console.error('Error loading product details:', error);
        if ($('.simpleToast').length) {
            $('.simpleToast').text("Produktdetails konnten leider nicht geladen werden.").css("background", "#e19f8f").addClass("active");
            setTimeout(() => {
                $('.simpleToast').removeClass("active");
            }, 4000);
        }
    } finally {
        $btn.removeClass('is-loading').prop('disabled', false);
        $imgWrapper.removeClass('is-loading');
    }
}

function closeB2BDishesPopup() {
    closeProductModal();
    $("#b2b-dishes-popup").fadeOut(200, function () {
        $(".js-b2b-global-sticky-bar").removeClass("is-suppressed");
        if (typeof updateGlobalStickyBar === "function") {
            updateGlobalStickyBar();
        }
    });
    $("body").css("overflow", "");
}

$(document).on("click", ".b2b-close-popup", function () {
    closeB2BDishesPopup();
});

$(document).on("click", "#b2b-dishes-popup", function (e) {
    if ($(e.target).is("#b2b-dishes-popup")) {
        closeB2BDishesPopup();
    }
});

$(document).on("keydown", function (e) {
    if (e.key === "Escape") {
        if ($("#productModal").is(":visible")) {
            closeProductModal();
            return;
        }
        if ($("#b2b-dishes-popup").is(":visible")) {
            closeB2BDishesPopup();
        }
    }
});

// Responsive Interaction: Details button (desktop hover) & image tap (mobile)
$(document).on('click', '.b2b-product-detail-btn, .b2b-product-image-wrapper', function (e) {
    const isDesktop = window.matchMedia('(min-width: 992px)').matches;
    const isTrigger = $(e.target).closest('.b2b-product-detail-btn').length > 0;
    const $card = $(this).closest('.b2b-dish-card');
    const isFeiertag = String($card.data('is-feiertag')) === 'true';

    if (isFeiertag) return;

    if (isDesktop) {
        if (isTrigger) {
            e.preventDefault();
            e.stopPropagation();
            openProductDetailModal($card);
        } else {
            e.preventDefault();
            e.stopPropagation();
        }
        return;
    }

    e.preventDefault();
    e.stopPropagation();
    openProductDetailModal($card);
});

// Select meal from inside the detail popup
$(document).on('click', '.custom-modal-btn.js-modal-add-to-cart', function () {
    if (!$currentCard || !$currentCard.length) {
        closeProductModal();
        return;
    }

    $('.b2b-dish-card').removeClass('selected');
    $currentCard.addClass('selected');

    closeProductModal();
});

// Close product detail popup
$(document).on('click', '.custom-modal-close, .js-modal-back', function () {
    closeProductModal();
});

$(document).on('click', '#productModal', function (e) {
    if ($(e.target).is('#productModal')) {
        closeProductModal();
    }
});

$(document).on('click', '.b2b-dish-card', function (e) {
    e.preventDefault();

    const $this = $(this);
    if ($this.hasClass('selected')) return;

    $('.b2b-dish-card').removeClass('selected');
    $this.addClass('selected');
});

document.addEventListener('click', e => {
    const header = e.target.closest('.accordion-header');
    if (!header) return;

    const currentItem = header.parentElement;
    document.querySelectorAll('.accordion-item').forEach(item => {
        if (item !== currentItem) item.classList.remove('active');
    });
    currentItem.classList.toggle('active');
});

$(document).on("click", ".js-save-b2b-meals", function () {

    const deliveryDate = $(this).data("delivery-date");
    const day = $(this).data("day");
    const matchedDelivery = meal_data.deliveries.find(d => d.deliveryDate === deliveryDate);

    if (!matchedDelivery) return;

    const selectedCard = $("#b2b-dishes-popup .b2b-dish-card.selected");
    if (!selectedCard.length) return;

    const mealId = selectedCard.data("meal-id");
    const sourceDay = String(selectedCard.data("source-day"));

    // Save the selection on the target day
    const targetDayData = matchedDelivery.weeklyMeals.find(d => d.day === day);
    if (!targetDayData) return;

    if (!window.mealBaselineState[deliveryDate]) {
        captureBaselineForDelivery(deliveryDate);
    }
    targetDayData.selectedMealId = mealId;
    targetDayData.selectedMealDay = sourceDay;

    // Find the actual meal object
    let selectedMeal;
    if (sourceDay === "feiertag") {
        selectedMeal = meal_data.feiertagDish;
    } else {
        const sourceDayData = matchedDelivery.weeklyMeals.find(d => d.day === sourceDay);
        selectedMeal = sourceDayData?.meals.find(m => m.id === mealId);
    }
    targetDayData.selectedMeal = selectedMeal;

    // Update the UI card for this day
    if (selectedMeal) {
        const $mealItem = $(`.meal-card__button[data-delivery-date="${deliveryDate}"][data-day="${day}"]`).closest(".meal-item");
        $mealItem.find(".meal-item__image img").attr("src", selectedMeal.image).attr("alt", selectedMeal.title);
        $mealItem.find(".meal-image__bg").css("--bg-dish-color", selectedMeal.dish_color);
        $mealItem.find(".meal-card__category").text(selectedMeal.meal_category || selectedMeal.category || '');
        $mealItem.find(".meal-card__title").text(selectedMeal.title);
        $mealItem.find(".meal-card__tags").html(
            (selectedMeal.tags || []).map(tag => `<span style="background-color: ${selectedMeal.dish_color};">${tag}</span>`).join("") +
            ((!selectedMeal.isFeiertag && String(selectedMeal.dish_type).toLowerCase() === 'vegan') ? `<span class="b2b-tag-icon">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="34.536" height="31.308" viewBox="0 0 34.536 31.308">
                    <defs>
                    <clipPath id="clip-path">
                        <rect width="34.536" height="31.308" fill="${selectedMeal.dish_color}"></rect>
                    </clipPath>
                    </defs>
                    <g clip-path="url(#clip-path)">
                    <path d="M31.893,8.226C15.491,8.144,6.7,16.154,5.938,32.7a.166.166,0,0,1-.331.02
                    34.667,34.667,0,0,1,.72-14.617c4.358-14.15,20.9-16.02,32.63-11.548a.842.842,0,0,1,.233,1.423
                    c-9.164,7.644-7.919,28.523-30.2,19.476
                    3.463-11.283,10.6-18.3,22.9-19.232" fill="${selectedMeal.dish_color}" fill-rule="evenodd"></path>
                    </g>
                </svg>
            </span>` : '')
        );
        $mealItem.toggleClass("meal-item--no-meal", !!selectedMeal.isFeiertag);

        const $mealList = $mealItem.closest(".meal-list");
        if ($mealList.hasClass("open") && $mealList.css("max-height") !== "none") {
            $mealList.css("max-height", $mealList.prop("scrollHeight") + "px");
        }
    }

    $("#b2b-dishes-popup").hide();
    $("body").css("overflow", "");

    $(".js-b2b-global-sticky-bar").removeClass("is-suppressed");
    window.activeUnsavedDeliveryDate = deliveryDate;
    if (typeof updateGlobalStickyBar === "function") {
        updateGlobalStickyBar();
    }
});

// ==================== B2B API Synchronization ====================
const B2B_MEAL_API_URL = window.ChinukiConfig.apiBaseUrl + "/save_custom_dish_selection/";

function setBtnConfirmLoading($btn, isLoading) {
    if (isLoading) {
        $btn.addClass('is-loading').prop('disabled', true);
    } else {
        $btn.removeClass('is-loading').prop('disabled', false);
    }
}

$(document).on("click", ".js-confirm-meal-selection", async function (e) {
    e.preventDefault();
    const $btn = $(this);
    if ($btn.hasClass("is-loading")) return;

    const deliveryDate = $btn.attr("data-delivery-date");
    if (!deliveryDate) return;

    const matchedDelivery = meal_data.deliveries.find(d => d.deliveryDate === deliveryDate);
    if (!matchedDelivery) return;

    setBtnConfirmLoading($btn, true);

    try {
        const selections = {};
        const dayMap = {
            "montag": "monday",
            "dienstag": "tuesday",
            "mittwoch": "wednesday",
            "donnerstag": "thursday",
            "freitag": "friday"
        };

        for (const dayData of matchedDelivery.weeklyMeals) {
            const dayKey = dayMap[dayData.day.toLowerCase()] || dayData.day.toLowerCase();

            let selectedMeal = dayData.selectedMeal;
            if (!selectedMeal) {
                const sourceDay = dayData.selectedMealDay || dayData.day;
                if (sourceDay === "feiertag") {
                    selectedMeal = meal_data.feiertagDish;
                } else {
                    const sourceDayData = matchedDelivery.weeklyMeals.find(d => d.day === sourceDay);
                    if (sourceDayData) {
                        selectedMeal = sourceDayData.meals.find(m => m.id === dayData.selectedMealId);
                    }
                }
            }

            // Fallback to first available meal if none selected yet
            if (!selectedMeal && dayData.meals && dayData.meals.length > 0) {
                selectedMeal = dayData.meals[0];
            }

            let sku = "";
            if (selectedMeal) {
                if (selectedMeal.id === "feiertag" || selectedMeal.isFeiertag) {
                    sku = meal_data.feiertagDish?.sku || selectedMeal.sku || "K000K000";
                } else if (selectedMeal.sku) {
                    sku = selectedMeal.sku;
                } else if (selectedMeal.handle) {
                    try {
                        const response = await fetch(`/products/${selectedMeal.handle}.js`);
                        if (response.ok) {
                            const productData = await response.json();
                            if (productData && productData.variants && productData.variants.length > 0) {
                                sku = productData.variants[0].sku || selectedMeal.handle;
                                selectedMeal.sku = sku; // Cache it
                            } else {
                                sku = selectedMeal.handle;
                            }
                        } else {
                            sku = selectedMeal.handle;
                        }
                    } catch (err) {
                        console.error("Error fetching SKU for " + selectedMeal.handle, err);
                        sku = selectedMeal.handle;
                    }
                } else {
                    sku = String(selectedMeal.id);
                }
            }
            selections[dayKey] = sku;
        }

        let formattedDeliveryDate = deliveryDate;
        if (deliveryDate.includes(".")) {
            const parts = deliveryDate.split(".");
            if (parts.length === 3) {
                formattedDeliveryDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
        }

        const tagsList = typeof window.customer_tags !== "undefined" ? window.customer_tags : (typeof cus_tags !== "undefined" ? cus_tags : "");
        const hasTag = (tag) => {
            if (Array.isArray(tagsList)) {
                return tagsList.some(t => t.trim().toLowerCase() === tag.toLowerCase());
            }
            if (typeof tagsList === "string") {
                return tagsList.split(",").map(t => t.trim().toLowerCase()).includes(tag.toLowerCase());
            }
            return false;
        };

        let accountType = "only_daycare";
        if (hasTag("Subscriber") && hasTag("daycare")) {
            accountType = "daycare_with_parent";
        } else if (hasTag("Subscriber")) {
            accountType = "only_daycare";
        }

        const payload = {
            email: typeof window.customer_email !== "undefined" ? window.customer_email : (typeof dm !== "undefined" ? dm : ""),
            delivery_date: formattedDeliveryDate,
            account_type: accountType,
            selections: selections
        };

        const authHeaders = typeof window.getValidShopifyAuthHeaders === "function"
            ? await window.getValidShopifyAuthHeaders(900)
            : (window.ShopifyAuthHeaders || {});

        const sendSaveRequest = (headers, isRetry = false) => {
            $.ajax({
                url: B2B_MEAL_API_URL,
                type: "POST",
                contentType: "application/json",
                headers: headers,
                data: JSON.stringify(payload),
                success: function (response) {
                    if (response && response.status === false) {
                        const errorMsg = response.message || "Bitte wählen Sie Gerichte für mindestens 3 Tage aus.";
                        $('.simpleToast').text(errorMsg);
                        $(".simpleToast").css("background", "#e19f8f");
                        $('.simpleToast').addClass("active");
                        setTimeout(() => {
                            $('.simpleToast').removeClass("active");
                        }, 5000);

                        setBtnConfirmLoading($btn, false);
                        return;
                    }

                    window.isLegitimateSubmission = true;
                    if (typeof captureBaselineForDelivery === "function") {
                        captureBaselineForDelivery(deliveryDate);
                    }
                    if (typeof updateGlobalStickyBar === "function") {
                        updateGlobalStickyBar();
                    }

                    $('.simpleToast').text("Gerichte erfolgreich gespeichert!");
                    $(".simpleToast").css("background", "#e19f8f");
                    $('.simpleToast').addClass("active");
                    try {
                        if (window.history && window.history.replaceState) {
                            window.history.replaceState(window.history.state, '', '#tab-content-list-5');
                        }
                    } catch (e) {}
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                },
                error: async function (err) {
                    let isHMACError = false;
                    let errorMsg = "";

                    if (err && err.responseText) {
                        try {
                            const parsed = JSON.parse(err.responseText);
                            if (parsed && parsed.status === false && parsed.message) {
                                errorMsg = parsed.message;
                                if (parsed.message.toLowerCase().includes("hmac") || parsed.message.toLowerCase().includes("timestamp") || parsed.message.toLowerCase().includes("signature")) {
                                    isHMACError = true;
                                }
                            }
                        } catch (e) { }
                    }

                    if (!isRetry && err && (err.status === 401 || err.status === 403 || err.status === 400 || isHMACError)) {
                        if (!errorMsg || isHMACError) {
                            if (typeof window.refreshShopifyAuthHeaders === "function") {
                                const newHeaders = await window.refreshShopifyAuthHeaders();
                                return sendSaveRequest(newHeaders, true);
                            }
                        }
                    }

                    console.error("Error saving meal selections:", err);

                    if (!errorMsg) {
                        errorMsg = "Fehler!";
                    }

                    $('.simpleToast').text(errorMsg);
                    $(".simpleToast").css("background", "#e19f8f");
                    $('.simpleToast').addClass("active");
                    setTimeout(() => {
                        $('.simpleToast').removeClass("active");
                    }, 5000);

                    setBtnConfirmLoading($btn, false);
                }
            });
        };

        sendSaveRequest(authHeaders);

    } catch (error) {
        console.error("Error preparing meal selections payload:", error);
        $('.simpleToast').text("Fehler beim Speichern der Gerichte.");
        $(".simpleToast").css("background", "#e19f8f");
        $('.simpleToast').addClass("active");
        setTimeout(() => {
            $('.simpleToast').removeClass("active");
        }, 5000);
        setBtnConfirmLoading($btn, false);
    }
});

// Function to fetch saved selections and update the UI
let _fetchMealRetryCount = 0;
const _FETCH_MEAL_MAX_RETRIES = 50; // 50 × 100ms = 5 seconds max wait

async function fetchSavedMealSelections() {
    // Skip for ABO plan customers — they don't use meal selection
    if (active_subscription && active_subscription.plan && active_subscription.plan.toUpperCase() === "ABO") {
        return;
    }

    if (!meal_data || !meal_data.deliveries || !active_subscription || !active_subscription.plan) {
        _fetchMealRetryCount++;
        if (_fetchMealRetryCount >= _FETCH_MEAL_MAX_RETRIES) {
            console.warn("fetchSavedMealSelections: max retries reached, stopping.");
            return;
        }
        // Retry in 100ms if meal_data/active_subscription is not loaded yet from the retrieve subscription AJAX call
        setTimeout(fetchSavedMealSelections, 100);
        return;
    }

    const email = typeof window.customer_email !== "undefined" ? window.customer_email : (typeof dm !== "undefined" ? dm : "");
    if (!email) return;
    const customerEmail = email;

    // Initialize only missing baselines before the asynchronous auth/GET work.
    captureAllMealBaselines();

    const tagsList = typeof window.customer_tags !== "undefined" ? window.customer_tags : (typeof cus_tags !== "undefined" ? cus_tags : "");
    const hasTag = (tag) => {
        if (Array.isArray(tagsList)) {
            return tagsList.some(t => t.trim().toLowerCase() === tag.toLowerCase());
        }
        if (typeof tagsList === "string") {
            return tagsList.split(",").map(t => t.trim().toLowerCase()).includes(tag.toLowerCase());
        }
        return false;
    };

    let accountType = "only_daycare";
    if (hasTag("Subscriber") && hasTag("daycare")) {
        accountType = "daycare_with_parent";
    } else if (hasTag("Subscriber")) {
        accountType = "only_daycare";
    }

    function areDaysEqual(day1, day2) {
        if (!day1 || !day2) return false;
        const d1 = day1.trim().toLowerCase();
        const d2 = day2.trim().toLowerCase();
        if (d1 === d2) return true;

        const engToGer = {
            "monday": "montag",
            "tuesday": "dienstag",
            "wednesday": "mittwoch",
            "thursday": "donnerstag",
            "friday": "freitag"
        };

        const gerToEng = {
            "montag": "monday",
            "dienstag": "tuesday",
            "mittwoch": "wednesday",
            "donnerstag": "thursday",
            "freitag": "friday"
        };

        return engToGer[d1] === d2 || gerToEng[d1] === d2 || engToGer[d2] === d1 || gerToEng[d2] === d1;
    }

    const authHeaders = typeof window.getValidShopifyAuthHeaders === "function"
        ? await window.getValidShopifyAuthHeaders(900)
        : (window.ShopifyAuthHeaders || {});

    $.ajax({
        url: `${B2B_MEAL_API_URL}?email=${encodeURIComponent(customerEmail)}&account_type=${accountType}`,
        type: "GET",
        dataType: "json",
        headers: authHeaders,
        success: function (response) {
            if (response && response.deliveries) {
                response.deliveries.forEach(savedDelivery => {
                    const rawDate = savedDelivery.delivery_date || savedDelivery.deliveryDate;
                    if (!rawDate) return;
                    let apiFormattedDate = rawDate;
                    if (rawDate.includes("-")) {
                        const parts = rawDate.split("-");
                        if (parts.length === 3) {
                            apiFormattedDate = `${parts[2]}.${parts[1]}.${parts[0]}`;
                        }
                    }

                    const matchedDelivery = meal_data.deliveries.find(d => d.deliveryDate === apiFormattedDate);
                    if (matchedDelivery && savedDelivery.selections) {
                        Object.entries(savedDelivery.selections).forEach(([dayKey, sku]) => {
                            const matchedDay = matchedDelivery.weeklyMeals.find(d => areDaysEqual(d.day, dayKey));
                            if (matchedDay) {
                                const baseline = window.mealBaselineState[matchedDelivery.deliveryDate];
                                const hasLocalChange = isMealDayDirty(matchedDay, baseline && baseline[matchedDay.day]);
                                let savedSelection = null;
                                if (sku === "K000K000" || sku === meal_data.feiertagDish?.sku) {
                                    savedSelection = {
                                        selectedMealId: "feiertag",
                                        selectedMealDay: "feiertag",
                                        selectedMeal: meal_data.feiertagDish
                                    };
                                } else {
                                    let foundMeal = null;
                                    let foundSourceDay = null;
                                    for (const dayData of matchedDelivery.weeklyMeals) {
                                        if (dayData.meals) {
                                            const m = dayData.meals.find(meal => meal.sku === sku || meal.id === sku || meal.handle === sku);
                                            if (m) {
                                                foundMeal = m;
                                                foundSourceDay = dayData.day;
                                                break;
                                            }
                                        }
                                    }
                                    if (foundMeal) {
                                        savedSelection = {
                                            selectedMealId: foundMeal.id,
                                            selectedMealDay: foundSourceDay || matchedDay.day,
                                            selectedMeal: foundMeal
                                        };
                                    }
                                }
                                if (savedSelection && baseline) {
                                    baseline[matchedDay.day] = Object.assign({}, savedSelection, {
                                        selectedMeal: savedSelection.selectedMeal ? Object.assign({}, savedSelection.selectedMeal) : null
                                    });
                                    if (!hasLocalChange) {
                                        Object.assign(matchedDay, savedSelection);
                                    }
                                }
                            }
                        });
                    }
                });

                $(".meal-list").each(function () {
                    const $list = $(this);
                    const deliveryDate = $list.attr("data-delivery-date") || $list.find(".meal-card__button").first().attr("data-delivery-date");
                    if (deliveryDate) {
                        const renderFunc = typeof renderMeals === "function" ? renderMeals : window.renderMeals;
                        const newHtml = renderFunc ? renderFunc(meal_data, deliveryDate) : "";
                        if (newHtml) {
                            $list.find(".meal-item").remove();
                            $list.append(newHtml);
                        }
                    }
                });

                if (typeof updateGlobalStickyBar === "function") {
                    updateGlobalStickyBar();
                }
            }
        },
        error: function (err) {
            console.error("Error fetching saved meal selections:", err);
        }
    });
}

// ==================== B2B Meal Selection Global Sticky Bar System ====================

window.activeUnsavedDeliveryDate = null;
window.mealBaselineState = window.mealBaselineState || {};

/**
 * Capture a baseline snapshot of meal selections for a delivery date.
 */
function captureBaselineForDelivery(deliveryDate) {
    if (!meal_data || !meal_data.deliveries) return;
    const matched = meal_data.deliveries.find(d => d.deliveryDate === deliveryDate);
    if (!matched || !matched.weeklyMeals) return;

    const snapshot = {};
    matched.weeklyMeals.forEach(dayData => {
        let selectedMeal = dayData.selectedMeal;
        if (!selectedMeal) {
            const sourceDay = dayData.selectedMealDay || dayData.day;
            if (sourceDay === "feiertag") {
                selectedMeal = meal_data.feiertagDish;
            } else {
                const sData = matched.weeklyMeals.find(d => d.day === sourceDay);
                if (sData) {
                    selectedMeal = sData.meals.find(m => m.id === dayData.selectedMealId);
                }
            }
        }
        if (!selectedMeal && dayData.meals && dayData.meals.length > 0) {
            selectedMeal = dayData.meals[0];
        }

        snapshot[dayData.day] = {
            selectedMealId: dayData.selectedMealId || (selectedMeal ? selectedMeal.id : null),
            selectedMealDay: dayData.selectedMealDay || dayData.day,
            selectedMeal: selectedMeal ? Object.assign({}, selectedMeal) : null
        };
    });
    window.mealBaselineState[deliveryDate] = snapshot;
}

/**
 * Initialize missing baseline snapshots without replacing unsaved state.
 */
function captureAllMealBaselines() {
    if (!meal_data || !meal_data.deliveries) return;
    meal_data.deliveries.forEach(d => {
        if (d.deliveryDate && !window.mealBaselineState[d.deliveryDate]) {
            captureBaselineForDelivery(d.deliveryDate);
        }
    });
}

/**
 * Compare a day's selection with its saved baseline, including the source day.
 */
function isMealDayDirty(dayData, baseDay) {
    if (!baseDay) return true;
    const currentId = dayData.selectedMealId || (dayData.meals && dayData.meals[0] ? dayData.meals[0].id : null);
    const normId = value => value != null ? String(value) : "";
    if (normId(currentId) !== normId(baseDay.selectedMealId)) return true;

    const normSource = value => String(value || dayData.day).trim().toLowerCase();
    return normSource(dayData.selectedMealDay) !== normSource(baseDay.selectedMealDay);
}

/**
 * Check for unsaved changes without mutating baseline state.
 */
function isDeliveryDirty(deliveryDate) {
    if (!meal_data || !meal_data.deliveries) return false;
    const matched = meal_data.deliveries.find(d => d.deliveryDate === deliveryDate);
    if (!matched || !matched.weeklyMeals) return false;

    const baseline = window.mealBaselineState ? window.mealBaselineState[deliveryDate] : null;
    if (!baseline) return false;

    return matched.weeklyMeals.some(dayData => isMealDayDirty(dayData, baseline[dayData.day]));
}

/**
 * Get the currently active delivery date that has unsaved changes.
 */
function getActiveDirtyDeliveryDate() {
    // If activeUnsavedDeliveryDate is set and still dirty, prioritize it
    if (window.activeUnsavedDeliveryDate && isDeliveryDirty(window.activeUnsavedDeliveryDate)) {
        return window.activeUnsavedDeliveryDate;
    }

    // Otherwise, check all deliveries in meal_data
    if (meal_data && meal_data.deliveries) {
        for (const d of meal_data.deliveries) {
            if (d.deliveryDate && isDeliveryDirty(d.deliveryDate)) {
                return d.deliveryDate;
            }
        }
    }

    return null;
}

/**
 * Get delivery date and readable week label (e.g. "KW 44 (26.10.–30.10.)") for active dirty week.
 */
function getActiveDirtyWeekInfo() {
    const activeDate = getActiveDirtyDeliveryDate();
    if (!activeDate) return null;

    const $list = $(`.meal-list[data-delivery-date="${activeDate}"]`).closest('.data-delivery-data-list');
    let weekLabel = "";
    if ($list.length) {
        weekLabel = $list.find('.cons-date').first().text().replace(/\s+/g, ' ').trim();
    }
    if (!weekLabel) {
        weekLabel = activeDate;
    }

    return {
        deliveryDate: activeDate,
        label: weekLabel
    };
}
window.getActiveDirtyWeekInfo = getActiveDirtyWeekInfo;

/**
 * Ensure the single global sticky bar DOM element exists in the body.
 */
function ensureGlobalStickyBarExists() {
    let $bar = $(".js-b2b-global-sticky-bar");
    if ($bar.length === 0) {
        const textUnsaved = "Nicht gespeicherte Auswahl";
        const textDiscard = "Auswahl verwerfen";
        const textConfirm = "Auswahl bestätigen";

        const barHtml = `
            <div class="b2b-global-sticky-bar js-b2b-global-sticky-bar" style="display: none;">
                <div class="b2b-global-sticky-bar__inner">
                    <div class="b2b-global-sticky-bar__info">
                        <span class="b2b-global-sticky-bar__dot"></span>
                        <span class="b2b-global-sticky-bar__text">${textUnsaved}</span>
                    </div>
                    <div class="b2b-global-sticky-bar__actions">
                        <button type="button" class="b2b-global-btn-discard js-global-discard-meal">
                            ${textDiscard}
                        </button>
                        <button type="button" class="b2b-global-btn-save js-confirm-meal-selection meal-selection__confirm">
                            <span class="btn-spinner"></span>
                            <span class="btn-label">${textConfirm}</span>
                        </button>
                    </div>
                </div>
            </div>`;
        $("body").append(barHtml);
        $bar = $(".js-b2b-global-sticky-bar");
    }
    return $bar;
}

/**
 * Update the visibility and target delivery date of the global sticky bar.
 */
function updateGlobalStickyBar() {
    const $bar = ensureGlobalStickyBarExists();
    if ($("#b2b-dishes-popup").is(":visible")) {
        $bar.addClass("is-suppressed");
    }
    const activeDate = getActiveDirtyDeliveryDate();
    window.activeUnsavedDeliveryDate = activeDate;

    if (activeDate) {
        $bar.find(".js-confirm-meal-selection").attr("data-delivery-date", activeDate);
        $bar.find(".js-global-discard-meal").attr("data-delivery-date", activeDate);
        $bar.attr("data-delivery-date", activeDate);

        $bar.css("display", "flex");
        // Force reflow for smooth animation
        $bar[0].offsetHeight;
        $bar.addClass("is-visible");
    } else {
        $bar.removeClass("is-visible");
        setTimeout(() => {
            if (!$bar.hasClass("is-visible")) {
                $bar.hide();
            }
        }, 350);
    }
}

/**
 * Revert selections for a delivery date back to the baseline.
 */
function revertDeliverySelections(deliveryDate) {
    if (!meal_data || !meal_data.deliveries) return;
    const matched = meal_data.deliveries.find(d => d.deliveryDate === deliveryDate);
    const baseline = window.mealBaselineState ? window.mealBaselineState[deliveryDate] : null;
    if (!matched || !matched.weeklyMeals || !baseline) return;

    // 1. Revert in-memory delivery state
    matched.weeklyMeals.forEach(dayData => {
        const baseDay = baseline[dayData.day];
        if (baseDay) {
            dayData.selectedMealId = baseDay.selectedMealId;
            dayData.selectedMealDay = baseDay.selectedMealDay;
            dayData.selectedMeal = baseDay.selectedMeal ? Object.assign({}, baseDay.selectedMeal) : null;
        }
    });

    // 2. Re-render UI cards for this delivery date
    const $list = $(`.meal-list`).filter(function () {
        return $(this).attr("data-delivery-date") === deliveryDate || $(this).find(`[data-delivery-date="${deliveryDate}"]`).length > 0;
    });

    if ($list.length) {
        const renderFunc = typeof renderMeals === "function" ? renderMeals : window.renderMeals;
        if (typeof renderFunc === "function") {
            const newHtml = renderFunc(meal_data, deliveryDate);
            if (newHtml) {
                $list.find(".meal-item").remove();
                $list.append(newHtml);
                if ($list.hasClass("open") && $list.css("max-height") !== "none") {
                    $list.css("max-height", $list.prop("scrollHeight") + "px");
                }
            }
        }
    }

    // 3. Clear active date if this was the active date
    if (window.activeUnsavedDeliveryDate === deliveryDate) {
        window.activeUnsavedDeliveryDate = null;
    }

    // 4. Update global sticky bar state
    updateGlobalStickyBar();

    // 5. Subtle feedback toast
    if ($('.simpleToast').length) {
        $('.simpleToast').text("Auswahl wurde verworfen.");
        $(".simpleToast").css("background", "#35437C");
        $('.simpleToast').addClass("active");
        setTimeout(() => {
            $('.simpleToast').removeClass("active");
        }, 3000);
    }
}

// Discard button click handler
$(document).on("click", ".js-global-discard-meal", function (e) {
    e.preventDefault();
    const deliveryDate = $(this).attr("data-delivery-date") || window.activeUnsavedDeliveryDate;
    if (deliveryDate) {
        revertDeliverySelections(deliveryDate);
    }
});

// Update active week when user opens or interacts with an accordion or meal-list
$(document).on("click", ".js-dish-selection, .meal-list", function () {
    const $mealList = $(this).hasClass("meal-list") ? $(this) : $(this).next(".meal-list");
    const weekDeliveryDate = $mealList.attr("data-delivery-date") || $mealList.find(".meal-card__button").first().attr("data-delivery-date");
    if (weekDeliveryDate && isDeliveryDirty(weekDeliveryDate)) {
        window.activeUnsavedDeliveryDate = weekDeliveryDate;
        updateGlobalStickyBar();
    }
});

// ==================== B2B Navigation Protection Guard ====================

window.isLegitimateSubmission = false;

/**
 * Check if ANY delivery week currently has unsaved dish selections.
 */
function hasAnyUnsavedMealSelections() {
    if (!meal_data || !meal_data.deliveries) return false;
    for (const d of meal_data.deliveries) {
        if (d.deliveryDate && isDeliveryDirty(d.deliveryDate)) {
            return true;
        }
    }
    return false;
}
window.hasAnyUnsavedMealSelections = hasAnyUnsavedMealSelections;

/**
 * Revert unsaved selections across ALL delivery weeks back to their saved baseline.
 */
function revertAllUnsavedSelections() {
    if (!meal_data || !meal_data.deliveries) return;
    meal_data.deliveries.forEach(d => {
        if (d.deliveryDate && isDeliveryDirty(d.deliveryDate)) {
            const baseline = window.mealBaselineState ? window.mealBaselineState[d.deliveryDate] : null;
            if (baseline && d.weeklyMeals) {
                d.weeklyMeals.forEach(dayData => {
                    const baseDay = baseline[dayData.day];
                    if (baseDay) {
                        dayData.selectedMealId = baseDay.selectedMealId;
                        dayData.selectedMealDay = baseDay.selectedMealDay;
                        dayData.selectedMeal = baseDay.selectedMeal ? Object.assign({}, baseDay.selectedMeal) : null;
                    }
                });
            }

            const $list = $(`.meal-list`).filter(function () {
                return $(this).attr("data-delivery-date") === d.deliveryDate || $(this).find(`[data-delivery-date="${d.deliveryDate}"]`).length > 0;
            });
            if ($list.length) {
                const renderFunc = typeof renderMeals === "function" ? renderMeals : window.renderMeals;
                if (typeof renderFunc === "function") {
                    const newHtml = renderFunc(meal_data, d.deliveryDate);
                    if (newHtml) {
                        $list.find(".meal-item").remove();
                        $list.append(newHtml);
                        if ($list.hasClass("open") && $list.css("max-height") !== "none") {
                            $list.css("max-height", $list.prop("scrollHeight") + "px");
                        }
                    }
                }
            }
        }
    });

    window.activeUnsavedDeliveryDate = null;
    updateGlobalStickyBar();

    if ($('.simpleToast').length) {
        $('.simpleToast').text("Auswahl wurde verworfen.");
        $(".simpleToast").css("background", "#35437C");
        $('.simpleToast').addClass("active");
        setTimeout(() => {
            $('.simpleToast').removeClass("active");
        }, 3000);
    }
}

/**
 * Directly draw attention to the global sticky button with a shake left-right animation and clear feedback.
 */
function triggerStickyBarAttention(customMessage) {
    const $bar = ensureGlobalStickyBarExists();
    if (!$bar.hasClass("is-visible")) {
        updateGlobalStickyBar();
    }
    const innerEl = $bar.find(".b2b-global-sticky-bar__inner")[0];
    $bar.removeClass("is-shaking");
    if (innerEl) {
        void innerEl.offsetWidth; // Force reflow to immediately replay animation on repeated clicks
    }
    $bar.addClass("is-shaking");

    clearTimeout(window._b2bShakeTimeout);
    window._b2bShakeTimeout = setTimeout(() => {
        $bar.removeClass("is-shaking");
    }, 750);

    if (customMessage && $('.simpleToast').length) {
        clearTimeout(window._b2bToastTimeout);
        $('.simpleToast').text(customMessage);
        $('.simpleToast').css("background", "#35437C");
        $('.simpleToast').addClass("active");
        window._b2bToastTimeout = setTimeout(() => {
            $('.simpleToast').removeClass("active");
        }, 4000);
    }
}
window.triggerStickyBarAttention = triggerStickyBarAttention;

// Keep guard resources scoped together so page/section transitions can release them.
(function () {
let sectionRoot = null;
let drawerObserver = null;
let refreshTimer = null;
let guardsActive = false;
const configuratorSelector = ".js-config-slider, .js-config-slider-plan-page, .header__action---cart, [href*='tab=configurator'], [href*='configOpen']";

// Intercept navigation clicks via DOM capture phase
function handleMealNavigationClick(e) {
    if (window.isLegitimateSubmission) return;
    if (!hasAnyUnsavedMealSelections()) return;

    // Ignore clicks inside our popup or the sticky save bar itself
    if (e.target.closest("#b2b-dishes-popup") || e.target.closest(".b2b-global-sticky-bar")) {
        return;
    }

    // Configurator / slider drawer / preference change triggers
    const configBtn = e.target.closest(
        ".js-config-slider, .js-config-slider-plan-page, .header__action---cart, " +
        ".open-subscription-change-popup, .change-subscription-product, .probebox-action-btn, " +
        "[data-target='#change-product-datail-modal'], [data-target='#custom-config-modal'], [data-target='#js-slider-config'], " +
        "[href*='tab=configurator'], [href*='configOpen'], [data-title*='Konfigurator'], [data-title*='Bestellen']"
    );
    if (configBtn) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Immediately close and suppress slider drawer and background overlay
        $('#js-slider-config, .slider--config, .slider-bg-overlay').removeClass('is-active');
        $('html, body').removeClass('is-slider-active equalizer-active');

        const dirtyInfo = typeof getActiveDirtyWeekInfo === "function" ? getActiveDirtyWeekInfo() : null;
        const weekText = dirtyInfo && dirtyInfo.label ? ` für ${dirtyInfo.label}` : "";
        triggerStickyBarAttention(`Bitte speichern oder verwerfen Sie zuerst Ihre ausstehenden Gerichtsauswahlen${weekText}, bevor Sie den Konfigurator öffnen.`);
        return;
    }

    // 1. Sidebar customer portal tabs (#tab-content-list-X)
    const tabLink = e.target.closest(".user-account-wrapper__left-inner ul li a");
    if (tabLink) {
        const clickedHref = tabLink.getAttribute("href") || "";
        const activeLink = document.querySelector(".user-account-wrapper__left-inner ul li a.active-link");
        const currentHref = activeLink ? activeLink.getAttribute("href") : "";

        if (clickedHref && clickedHref !== currentHref) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            triggerStickyBarAttention("Bitte speichern oder verwerfen Sie zuerst Ihre ungespeicherten Gerichtsauswahlen, bevor Sie den Tab wechseln.");
            return;
        }
    }

    // 2. Regular <a> links (header logo, nav links, footer links, logout)
    const link = e.target.closest("a");
    if (link) {
        const href = link.getAttribute("href");
        const target = link.getAttribute("target");

        if (!href || href === "#" || href.startsWith("javascript:") || href.startsWith("#")) {
            return;
        }

        if (target === "_blank") {
            return;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        triggerStickyBarAttention("Bitte speichern oder verwerfen Sie zuerst Ihre ungespeicherten Gerichtsauswahlen, bevor Sie die Seite verlassen.");
        return;
    }

    // 3. Daycare SSO buttons or other external action buttons
    const ssoBtn = e.target.closest(".daycare-login-btn, .header-logout-btn");
    if (ssoBtn) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        triggerStickyBarAttention("Bitte speichern oder verwerfen Sie zuerst Ihre ungespeicherten Gerichtsauswahlen.");
        return;
    }
}

// Direct delegated listener to intercept drawer configurator triggers
function handleConfiguratorClick(e) {
    if (typeof hasAnyUnsavedMealSelections === "function" && hasAnyUnsavedMealSelections()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        $('#js-slider-config, .slider--config, .slider-bg-overlay').removeClass('is-active');
        $('html, body').removeClass('is-slider-active equalizer-active');
        const dirtyInfo = typeof getActiveDirtyWeekInfo === "function" ? getActiveDirtyWeekInfo() : null;
        const weekText = dirtyInfo && dirtyInfo.label ? ` für ${dirtyInfo.label}` : "";
        const msg = `Bitte speichern oder verwerfen Sie zuerst Ihre ausstehenden Gerichtsauswahlen${weekText}, bevor Sie den Konfigurator öffnen.`;
        if (typeof triggerStickyBarAttention === "function") {
            triggerStickyBarAttention(msg);
        }
        return false;
    }
}

// Native browser protection on tab close / reload
function handleMealBeforeUnload(e) {
    if (window.isLegitimateSubmission) return;
    if (hasAnyUnsavedMealSelections()) {
        e.preventDefault();
        e.returnValue = "";
        return "";
    }
}

function cleanupMealGuards() {
    if (drawerObserver) {
        drawerObserver.disconnect();
        drawerObserver = null;
    }
    document.removeEventListener("click", handleMealNavigationClick, true);
    window.removeEventListener("beforeunload", handleMealBeforeUnload);
    $(document).off("click.b2bMealGuard", configuratorSelector, handleConfiguratorClick);
    clearTimeout(refreshTimer);
    refreshTimer = null;
    guardsActive = false;
}

function setupMealGuards() {
    if (guardsActive || !sectionRoot || !sectionRoot.isConnected) return;
    document.addEventListener("click", handleMealNavigationClick, true);
    window.addEventListener("beforeunload", handleMealBeforeUnload);
    $(document).on("click.b2bMealGuard", configuratorSelector, handleConfiguratorClick);
    guardsActive = true;

    // Safeguard: MutationObserver to immediately close drawer configurator if it is opened while selections are unsaved
    const configDrawer = document.getElementById("js-slider-config");
    if (configDrawer && window.MutationObserver) {
        drawerObserver = new MutationObserver(function () {
            try {
                if (typeof hasAnyUnsavedMealSelections === "function" && hasAnyUnsavedMealSelections() && configDrawer.classList.contains("is-active")) {
                    configDrawer.classList.remove("is-active");
                    $(".slider-bg-overlay").removeClass("is-active");
                    $("html, body").removeClass("is-slider-active equalizer-active");
                    const dirtyInfo = typeof getActiveDirtyWeekInfo === "function" ? getActiveDirtyWeekInfo() : null;
                    const weekText = dirtyInfo && dirtyInfo.label ? ` für ${dirtyInfo.label}` : "";
                    if (typeof triggerStickyBarAttention === "function") {
                        triggerStickyBarAttention(`Bitte speichern oder verwerfen Sie zuerst Ihre ausstehenden Gerichtsauswahlen${weekText}, bevor Sie den Konfigurator öffnen.`);
                    }
                }
            } catch (error) {
                console.error("B2B meal drawer guard failed:", error);
            }
        });
        drawerObserver.observe(configDrawer, { attributes: true, attributeFilter: ["class"] });
    }

    // Refresh the UI after initial layout; baselines are initialized with the data.
    refreshTimer = setTimeout(() => {
        refreshTimer = null;
        if (typeof updateGlobalStickyBar === "function") {
            updateGlobalStickyBar();
        }
    }, 1500);
}

window.addEventListener("pagehide", cleanupMealGuards);
window.addEventListener("pageshow", function (event) {
    if (event.persisted) setupMealGuards();
});
document.addEventListener("shopify:section:unload", function (event) {
    if (sectionRoot && event.target.contains(sectionRoot)) {
        cleanupMealGuards();
        sectionRoot = null;
    }
});
document.addEventListener("shopify:section:load", function (event) {
    const root = event.target.querySelector(".subscription-page-main-section");
    if (root) {
        cleanupMealGuards();
        sectionRoot = root;
        setupMealGuards();
    }
});

$(document).ready(function () {
    fetchSavedMealSelections();
    sectionRoot = document.querySelector(".subscription-page-main-section");
    setupMealGuards();
});
})();
